/* WL Customiser v6 — Summer's full review round 2026-07-12:
   · mockup gets TABS: Demo room · My room · In-situ photo (AI result shows INSIDE
     its tab, switch back any time); heading on top, bold; caption line under the
     canvas = size (left, "Natural Oak Frame" wording) + drag hint (right);
     big magnifier top-right opens the Full view
   · Save image / Email it to me work on the MANUAL mockup too (demo + my room);
     saved file is "<index> <title> - wall liberation.jpg"; email goes out instantly
   · custom size AUTO-APPLIES as you type (ratio-locked, no Apply button); the
     Custom pill looks like every other size box; theme's own swatch styling is
     left alone; default selection = the 4th standard size (when no ?variant=)
   · section headers bold (See it on your wall / Size / Framing / Colour Filter);
     canvas-type line in body size; kit line links to the product
   · floating frame slightly thicker in the manual mockup (1.5 cm face + 6 mm gap);
     multi-panel pieces hang with a clear 4 cm gap
   · "Complete the set": top-3 matched companions (match by colour/style/artist),
     3-across, per-row size (std list or Custom W+H) + framing + price, swap,
     engine-priced set discount, ONE "Add the set to cart" — no detours to old pages
   Served from R2 app/customiser.js; mounted by app/bar.js on artwork pages. */
(function () {
  var API = "https://wl-studio.wallliberation.workers.dev";
  var TPL = { file: "pdp-tall.jpg", floorY: 0.912, wallCm: 420 };
  var PANELMAP = { "100x100":1,"100x110":1,"100x120":1,"100x140":1,"100x160":1,"100x180":1,
    "100x200":1,"100x240":1,"100x300":1,"110x120":1,"110x140":1,"120x120":1,"120x140":1,
    "120x150":1,"120x160":1,"120x180":1,"120x200":1,"120x240":1,"120x300":1,"130x160":1,
    "140x140":1,"140x160":1,"140x180":1,"140x200":1,"140x240":1,"140x300":1,"140x400":2,
    "150x200":1,"160x160":1,"160x180":1,"160x200":1,"160x220":1,"160x240":1,"160x300":1,
    "160x320":2,"160x400":2,"160x480":2,"180x200":1,"180x240":1,"200x200":1,"200x220":1,
    "200x240":1,"200x280":1,"200x300":1,"200x400":2,"200x480":2,"200x600":2,"220x240":2,
    "220x300":2,"240x240":2,"240x280":2,"240x300":2,"240x320":2,"240x400":2,"240x480":3,
    "240x600":3,"280x300":2,"300x300":2,"300x320":2,"300x400":4,"300x480":3,"300x600":3,
    "80x100":1,"80x110":1,"80x120":1,"80x140":1,"80x160":1,"80x200":1,"80x240":1,"80x80":1,
    "90x100":1,"90x120":1,"90x140":1,"90x160":1 };
  function panelsFor(w, h) {
    var s = Math.min(w, h), l = Math.max(w, h);
    var hit = PANELMAP[Math.round(s) + "x" + Math.round(l)];
    if (hit) return hit;
    for (var n = 1; n <= 6; n++) {                    // shipping box: one side ≤200, other ≤300
      var pw = l / n, mn = Math.min(s, pw), mx = Math.max(s, pw);
      if (mn <= 200 && mx <= 300) return n; }
    return 6; }
  function canvasTypeFor(w, h) {
    return Math.min(w, h) >= 160 ? "320g Professional Canvas" : "380g Premium Linen Canvas"; }
  var LOOKS = { natural:[0,0,0,1,1,1], rosegold:[22,4,-13,1.02,1,1.02], jade:[-15,6,9,1.02,1,1],
    sepia:[18,2,-20,.72,.98,1.02], indigo:[-18,-4,16,1.02,1.02,.97], warm_golden:[28,12,-16,1.06,1,1.04],
    soft_pastel:[6,6,8,.7,.9,1.1], muted_sage:[-6,8,-2,.78,.96,1.03], monochrome:[0,0,0,0,1.05,1.02],
    vintage_faded:[12,6,-8,.62,.88,1.06], high_contrast:[0,0,0,1.08,1.22,1], cool_slate:[-12,-2,8,.85,1.02,1],
    blush:[18,2,6,.92,.96,1.06], deep_forest:[-14,4,-6,1,1.06,.94] };
  var TINTS = { rosegold:"#c9a08e", jade:"#93b3a2", sepia:"#b8a88a", indigo:"#8a92b8",
    warm_golden:"#c9ab7c", soft_pastel:"#c5bfc2", muted_sage:"#a9b39e", monochrome:"#9a9a9a",
    vintage_faded:"#b3a89a", high_contrast:"#6f6f6f", cool_slate:"#9aa4ad", blush:"#c9a8a8", deep_forest:"#7e937e" };
  var LABELS = { natural:"None", rosegold:"Rose Gold", jade:"Jade", sepia:"Sepia",
    indigo:"Indigo", warm_golden:"Warm Golden", soft_pastel:"Soft Pastel", muted_sage:"Muted Sage",
    monochrome:"Monochrome", vintage_faded:"Vintage Faded", high_contrast:"High Contrast",
    cool_slate:"Cool Slate", blush:"Blush", deep_forest:"Deep Forest" };
  var TSK = "0x4AAAAAAD0-wshBVMBagcB3";      // Turnstile sitekey (bot gate on AI renders + enquiries)
  function tsGet(cb) {                        // one token per protected action; null on any failure — server decides
    try {
      var run = function () {
        var host = document.createElement("div");
        host.style.cssText = "position:fixed;bottom:14px;right:14px;z-index:2147483000";
        document.body.appendChild(host);
        var done = false, fin = function (t) { if (done) return; done = true;
          setTimeout(function () { try { host.remove(); } catch (e) {} }, 600); cb(t || null); };
        try {
          window.turnstile.render(host, { sitekey: TSK, appearance: "interaction-only",
            callback: fin, "error-callback": function () { fin(null); },
            "expired-callback": function () { fin(null); } });
        } catch (e) { fin(null); }
        setTimeout(function () { fin(null); }, 30000);   // never hang the button
      };
      if (window.turnstile) run();
      else { var s = document.createElement("script");
        s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
        s.onload = run; s.onerror = function () { cb(null); }; document.head.appendChild(s); }
    } catch (e) { cb(null); }
  }
  // ONE control size across the whole panel (Summer 2026-08-24): every option
  // button and every input/select is 40 px tall with the same 6/12 px padding.
  // 40 px is the CHOICE height in mission_control/docs/DESIGN-RULES.md — size
  // chips, Matte/Glossy, framing and the piece tabs all sit on that token, so
  // this must never be re-tuned to a number that is not in that table.
  // Shared by the base .wlopt rule and the OWN (print page) restatement of it —
  // one constant so the two can never drift apart again.
  var WLBTN = "min-height:40px;box-sizing:border-box;display:inline-flex;align-items:center;" +
    "justify-content:center;gap:7px;padding:6px 12px;line-height:1.3;";
  var FRAME_COLOURS = { black_oak:["#26221d", "#0f0d0b"], natural_oak:["#dfc3a6", "#bd9a76"],
    white_oak:["#efe9dd", "#cfc6b4"] };
  var FR_SHORT = { rolled:"Rolled", stretched:"Stretched", black_oak:"Black Oak Frame",
    natural_oak:"Natural Oak Frame", white_oak:"White Oak Frame" };
  var FRAME_CM = 1.2, GAPF_CM = 0.7, PANEL_GAP_CM = 8;   // slim face + visible float gap + strong shadow (Summer 2026-07-13)
  function frKey(label) { label = (label || "").toLowerCase();
    if (label.indexOf("black") >= 0) return "black_oak";
    if (label.indexOf("natural") >= 0) return "natural_oak";
    if (label.indexOf("white") >= 0) return "white_oak";
    if (label.indexOf("stretch") >= 0) return "stretched";
    return "rolled"; }
  function loadImg(src) { return new Promise(function (res) { var im = new Image();
    if (String(src).indexOf("data:") !== 0) im.crossOrigin = "anonymous";
    im.onload = function () { res(im); }; im.onerror = function () { res(null); }; im.src = src; }); }
  function lookCanvas(img, k, maxPx) {
    var o = LOOKS[k] || LOOKS.natural, r = o[0], g = o[1], b = o[2], sat = o[3], con = o[4], bri = o[5];
    var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
    if (maxPx && Math.max(w, h) > maxPx) { var f = maxPx / Math.max(w, h); w = Math.round(w * f); h = Math.round(h * f); }
    var cv = document.createElement("canvas"); cv.width = w; cv.height = h;
    var x = cv.getContext("2d"); x.drawImage(img, 0, 0, w, h);
    try { var d = x.getImageData(0, 0, w, h), p = d.data;
      for (var i = 0; i < p.length; i += 4) { var R = p[i] + r * 1.6, G = p[i + 1] + g * 1.6, B = p[i + 2] + b * 1.6;
        var grey = (R + G + B) / 3; R = grey + (R - grey) * sat; G = grey + (G - grey) * sat; B = grey + (B - grey) * sat;
        R = (R - 127.5) * con + 127.5; G = (G - 127.5) * con + 127.5; B = (B - 127.5) * con + 127.5;
        p[i] = Math.max(0, Math.min(255, R * bri)); p[i + 1] = Math.max(0, Math.min(255, G * bri)); p[i + 2] = Math.max(0, Math.min(255, B * bri)); }
      x.putImageData(d, 0, 0); } catch (e) { console.warn("wl look", e); }
    return cv; }
  // intl (2026-08-01): artwork pages feed money() presented-currency values
  // (VARP2; custom/border hidden intl by wl-intl-guard) — label them truthfully.
  // The OWN print page quotes engine AUD — converted via WL_RATE for intl (r3).
  var WL_CUR = (function () { try { var c = window.Shopify && Shopify.currency;
    return c && c.active && c.active !== "AUD" ? c.active : null; } catch (e) { return null; } })();
  // TWO axes since 2026-08-23 r2 (Summer's delivery-axis ruling):
  //  WL_INTL  = outside AU and NZ — the add-on/Afterpay/sample-pack gate, the
  //             same set gate B of wl-intl-guard.liquid uses. NZ is domestic here.
  //  WL_AUDEL = outside AU — framed and stretched DELIVER within Australia, so
  //             every other country sees the "Australia delivery" tag. Options
  //             are never hidden or forced any more; the AU-only delivery
  //             profile is what actually enforces where framed can ship.
  var WL_INTL = (function () { try { var cc = window.Shopify && Shopify.country;
    return !!cc && cc !== "AU" && cc !== "NZ"; } catch (e) { return false; } })();
  var WL_AUDEL = (function () { try { var cc = window.Shopify && Shopify.country;
    return !!cc && cc !== "AU"; } catch (e) { return false; } })();
  // AUD -> presented-currency rate (Summer 2026-08-01 r3: no A$ shown to intl).
  // Checkout converts at this same rate with round-up-to-dollar — Math.ceil mirrors it.
  var WL_RATE = (function () { try { var c = window.Shopify && Shopify.currency;
    return c && c.rate ? +c.rate : 1; } catch (e) { return 1; } })();
  // OWN lives in a deeper scope — detect the print page by pathname instead
  var WL_OWNPAGE = location.pathname.indexOf("print-stretch-and-frame-your-own-art") !== -1;
  // CURRENCY SPACE, not page (2026-08-23 r2). Two kinds of number reach these
  // helpers: ENGINE AUD (every /api/quote, /api/cart/price and /api/native-line
  // total — always AUD) and PRESENTMENT (variant prices read from Shopify's own
  // product JSON — VARP/VARP2/kit.price, already in the visitor's currency).
  // Keying the conversion on which PAGE we were on shipped AUD numbers labelled
  // "USD" on artwork pages the moment custom sizes went international.
  // Pass aud=true for engine values. Mixed sums convert the AUD part first and
  // then add the presentment part — checkout converts each line separately, so
  // per-part rounding is what actually matches the bill.
  var toPres = function (v) {
    return WL_CUR ? Math.ceil(Number(v) * WL_RATE) : Number(v); };
  // the visitor's own currency SYMBOL, not a dollar sign: the theme prints
  // "£251.00" for a British visitor, so a custom quote written "$869 GBP" put
  // two currency formats on one page (Summer's 2026-07-30 rule). Intl gives the
  // right symbol for every market; the plain-dollar form is the fallback.
  var wlFmt = function (v) {
    try { return new Intl.NumberFormat("en", { style: "currency", currency: WL_CUR,
      minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(Number(v)); }
    catch (e) { return "$" + Number(v).toLocaleString("en-US"); } };
  var money = function (v, aud) {
    if (aud) v = toPres(v);
    if (WL_CUR) return wlFmt(v) + " " + WL_CUR;
    return "A$" + Number(v).toLocaleString("en-AU"); };
  // the BIG price (buy box + sticky bar) always renders in the theme's own
  // "$1,234 AUD" format — custom quotes used to switch to "A$1,234" mid-page
  // (2026-07-30: two currency formats on one page read as two different prices)
  var moneyMain = function (v, aud) {
    if (aud) v = toPres(v);
    if (WL_CUR)                 // intl sees the presented currency, never AUD
      return wlFmt(v) + " " + WL_CUR;
    return "$" + Number(v).toLocaleString("en-AU") + " AUD"; };
  // WE own the "(or 4 payments of …)" line: the theme's own script computed it
  // from the variant BEFORE our price rewrite and could stay stale (Summer
  // 2026-07-24: $318.50 shown against a $2,951 total). Call with the exact
  // total we just displayed.
  var wlAfterpay = function (total) { try {
    // intl: Afterpay is an AU/NZ gateway — never promise it to other markets
    // (audit 2026-08-01 r3)
    if (WL_INTL) { document.querySelectorAll(".wl-afterpay-msg").forEach(function (m) {
      m.textContent = ""; m.style.display = "none"; }); return; }
    var t = "(or 4 payments of $" +
      (Math.round(total * 25) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
      " Afterpay)";
    document.querySelectorAll(".wl-afterpay-msg").forEach(function (m) {
      if (m.textContent !== t) m.textContent = t; });
  } catch (e) {} };
  function track(ev, p) { try {
    if (typeof window.gtag === "function") window.gtag("event", ev, p || {});
    (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: ev }, p || {}));
  } catch (e) {} }
  var handleize = function (v) { return String(v).toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, ""); };
  var shortTitle = function (t) { return String(t || "").split("|")[0].trim(); };
  // homography (own-photo mode only)
  function solveH(src, dst) { var A = [], b = [];
    for (var i = 0; i < 4; i++) { var x = src[i][0], y = src[i][1], u = dst[i][0], v = dst[i][1];
      A.push([x, y, 1, 0, 0, 0, -u * x, -u * y]); b.push(u);
      A.push([0, 0, 0, x, y, 1, -v * x, -v * y]); b.push(v); }
    for (var c = 0; c < 8; c++) { var p = c;
      for (var r = c + 1; r < 8; r++) if (Math.abs(A[r][c]) > Math.abs(A[p][c])) p = r;
      var t = A[c]; A[c] = A[p]; A[p] = t; t = b[c]; b[c] = b[p]; b[p] = t;
      for (r = 0; r < 8; r++) { if (r === c || !A[c][c]) continue;
        var f = A[r][c] / A[c][c];
        for (var k = c; k < 8; k++) A[r][k] -= f * A[c][k]; b[r] -= f * b[c]; } }
    var h = b.map(function (v2, i2) { return v2 / A[i2][i2]; }); h.push(1); return h; }
  function applyH(h, x, y) { var w = h[6] * x + h[7] * y + h[8];
    return [(h[0] * x + h[1] * y + h[2]) / w, (h[3] * x + h[4] * y + h[5]) / w]; }
  function drawWarped(ctx, img, quad, grid) { grid = grid || 8;
    var H = solveH([[0, 0], [img.width, 0], [img.width, img.height], [0, img.height]], quad);
    var sx = img.width / grid, sy = img.height / grid;
    for (var i = 0; i < grid; i++) for (var j = 0; j < grid; j++) {
      var s = [[i * sx, j * sy], [(i + 1) * sx, j * sy], [(i + 1) * sx, (j + 1) * sy], [i * sx, (j + 1) * sy]];
      var d = s.map(function (p) { return applyH(H, p[0], p[1]); });
      [[0, 1, 2], [0, 2, 3]].forEach(function (tri) {
        var st2 = tri.map(function (k) { return s[k]; }), dt = tri.map(function (k) { return d[k]; });
        ctx.save(); ctx.beginPath(); ctx.moveTo(dt[0][0], dt[0][1]); ctx.lineTo(dt[1][0], dt[1][1]);
        ctx.lineTo(dt[2][0], dt[2][1]); ctx.closePath(); ctx.clip();
        var x0 = st2[0][0], y0 = st2[0][1], x1 = st2[1][0], y1 = st2[1][1], x2 = st2[2][0], y2 = st2[2][1];
        var u0 = dt[0][0], v0 = dt[0][1], u1 = dt[1][0], v1 = dt[1][1], u2 = dt[2][0], v2 = dt[2][1];
        var den = x0 * (y1 - y2) + x1 * (y2 - y0) + x2 * (y0 - y1);
        var a = (u0 * (y1 - y2) + u1 * (y2 - y0) + u2 * (y0 - y1)) / den, bb = (v0 * (y1 - y2) + v1 * (y2 - y0) + v2 * (y0 - y1)) / den;
        var c2 = (u0 * (x2 - x1) + u1 * (x0 - x2) + u2 * (x1 - x0)) / den, dd = (v0 * (x2 - x1) + v1 * (x0 - x2) + v2 * (x1 - x0)) / den;
        ctx.transform(a, bb, c2, dd, u0 - a * x0 - c2 * y0, v0 - bb * x0 - dd * y0);
        ctx.drawImage(img, 0, 0); ctx.restore(); }); } }

  function mount(holder, cfg) {
    var OWN = !!cfg.ownArt;          // Print-Your-Own page (2026-07-23): same UI, own art
    var card = cfg.card;
    if (OWN && !card) card = { index: "OWNART", title: "Your artwork", sizes: [], is_le: false, image: "" };
    // image version-buster (mirrors wl_bar.js iv): a swapped photo bumps Shopify's
    // ?v=, so the /main//thumb URL changes and no browser serves the 24h-old copy
    // 2026-09-06: main_v = the flat's own version (image #2), set by wl_art_update / wl_refresh /
    // the nightly drift check; falls back to image #1's ?v= for cards that predate it
    function iv(c) { if (c && c.main_v) return "?v=" + c.main_v; var m = /[?&]v=(\d+)/.exec((c && c.image) || ""); return m ? "?v=" + m[1] : ""; }
    var sizeFs = document.querySelector('fieldset[data-option-name*="size"]');
    var wFsOwn = OWN ? document.querySelector('fieldset[data-option-name*="width"]') : null;
    var hFsOwn = OWN ? document.querySelector('fieldset[data-option-name*="height"]') : null;
    if (OWN && !sizeFs) sizeFs = wFsOwn;
    var frFs = document.querySelector('fieldset[data-option-name*="fram"]');
    var sec = (sizeFs && sizeFs.closest(".shopify-section")) || document;
    var form = sec.querySelector("form[action*='/cart/add']") || document.querySelector("form[action*='/cart/add']");
    if (!form || form.dataset.wlc) return; form.dataset.wlc = "1";
    var priceBlock = sec.querySelector('[data-block-type="price"]');
    // the theme MORPHS the price block on variant change — never trust a cached node
    var priceMem = { node: null, orig: null };
    var stickyMem = { orig: null };   // theme's product-sticky-bar price mirrors the buy box
    function curPrice() {
      var pb = sec.querySelector('[data-block-type="price"]') || priceBlock;
      priceBlock = pb;
      var mp = pb ? pb.querySelector("sale-price") : sec.querySelector("sale-price");
      if (mp && mp !== priceMem.node) { priceMem.node = mp; priceMem.orig = mp.innerHTML; }
      return mp;
    }
    var pickerBlock = sizeFs ? (sizeFs.closest(".product-info__block-item") ||
                                sizeFs.closest("variant-picker") || sizeFs) : null;
    var stdSizes = sizeFs
      ? Array.prototype.map.call(sizeFs.querySelectorAll("label.block-swatch span"),
          function (sp) { return sp.textContent.trim(); }).filter(Boolean)
      : [];
    if (!stdSizes.length) stdSizes = card.sizes || [];
    if (OWN) stdSizes = [];             // print page: W and H are separate grids
    var f0 = /(\d+)\s*[x×]\s*(\d+)/.exec(stdSizes[0] || "100x150") || [null, "100", "150"];
    var st = { custom: false, w: 0, h: 0, look: "natural", size: [+f0[1], +f0[2]], framing: "rolled",
               drag: null, kit: false, u: .5, v: .5, aspect: (+f0[1]) / (+f0[2]),
               tab: "tpl", lastRoomTab: "tpl", quote: null,
               tpl: { img: null, h_cm: 270 },
               own: { img: null, h_cm: 270, quad: null, edit: false },
               ai: { url: null, remaining: null },
               artBase: null, art: null };
    var kit = { id: null, title: "", price: 0, url: "/products/heavy-duty-stainless-steel-installation-kit" };
    var VARP = {};                                    // variant id -> price (this product)
    var VARP2 = {};                                   // "WxH|frkey" -> standard variant price
    var frValKey = function (s) { s = (s || "").toLowerCase();
      return s.indexOf("rolled") >= 0 ? "rolled" : s.indexOf("stretch") >= 0 ? "stretched" :
        s.indexOf("natural") >= 0 ? "natural_oak" : s.indexOf("black") >= 0 ? "black_oak" :
        s.indexOf("white") >= 0 ? "white_oak" : null; };
    fetch(location.pathname.split("?")[0] + ".js").then(function (x) { return x.json(); })
      .then(function (p) { (p.variants || []).forEach(function (v) {
        VARP[v.id] = v.price / 100;
        // standard size|framing -> REAL variant price: the framing tile captions
        // read this locally, zero network (Summer 2026-07-31)
        var sz = (v.option1 || "").replace(/\(.*?\)/g, "").replace(/\s+/g, "");
        var fk = frValKey(v.option2 || "");
        if (/^\d+x\d+$/.test(sz) && fk && (v.option1 || "").indexOf("made to order") < 0)
          VARP2[sz + "|" + fk] = v.price / 100;
      }); })
      .catch(function () {});
    var bodyFont = getComputedStyle(document.body).fontFamily;

    var css = document.createElement("style");
    css.textContent =
      /* custom pill inherits the theme's swatch look; selected = quiet outline */
      '.wl-cpill{cursor:pointer}' +
      // selection buttons for edge/finish — SIZE-CHIP look, a size down
      // (Summer 2026-07-30: "same style as the size button, but smaller —
      // not the green button"). Selected = dark outline + bold, like .wl-cpill.on
      '.wlc4 .wlopt{border:1px solid #ddd;background:#fff;color:#1b1b1b;' + WLBTN +
        'cursor:pointer;font-family:inherit;font-size:12.5px;line-height:1.3}' +
      // phone (Summer 2026-09-07): Matte / Glossy the same box as the size chips
      '@media(max-width:749px){.wlfinb,.wlc4 .wlfinb{padding:5px 9px !important;height:30px !important;min-height:30px !important;line-height:1.2 !important;min-width:0;font-size:12.5px !important}}' +
      // 20 -> 16px (Summer 2026-08-24 r5): the border chips got their swatches back
      // AND the longer "Mirror image" label, which put the row 20px over the
      // 457px panel. The swatch is decoration, not a control, so it shrinks
      // rather than the 40px button token. Edge + border chips are the only
      // .wlopt that carry an svg, so this stays one number in one home.
      '.wlc4 .wlopt svg{height:16px;width:auto;flex:none}' +
      // the framing name and the canvas/panel spec are ONE line (Summer
      // 2026-08-24) — pNote is a span inside frNote, joined by a pipe. The
      // pipe only paints when both halves have text.
      '.wl-pnote:not(:empty)::before{content:" | "}' +
      '.wl-frtxt:empty + .wl-pnote::before{content:""}' +
      '.wlc4 .wlopt:hover{border-color:#425934}' +
      // selected = the artwork PDP size chip, everywhere (Summer 2026-08-24)
      '.wlc4 .wlopt.on{background:#f0f0ee;border:1.5px solid #425934;color:#425934;font-weight:700;box-shadow:none}' +
      // the panel's checkboxes were browser blue — the only non-brand colour in
      // the buy box (Summer 2026-08-24, "other element design to be consistent")
      '.wlc4 input[type=checkbox]{accent-color:#425934}' +
      '.wl-cpill.on{border-color:#1b1b1b!important;background:#fff!important;color:#1b1b1b!important;font-weight:600}' +
      // framing tiles: 52px icon + a NAME + PRICE caption underneath (2026-07-30 —
      // unlabelled icons hid a $136→$612 jump until after the click). Icon paints
      // as a fixed 52px square at the top; the caption is our injected .wlfrcap.
      // the 5 tiles fill the FULL column width (Summer 2026-07-31: fixed 64px
      // was "very small") — equal grid columns, icon scales but never crops
      'fieldset[data-option-name*="fram"] .variant-picker__option-values{display:grid!important;grid-template-columns:repeat(5,1fr);gap:8px;width:100%}' +
      'fieldset[data-option-name*="fram"] .block-swatch[data-value-handle][data-value-handle]{width:100%!important;height:auto!important;' +
        'min-width:0!important;min-height:0!important;padding:76px 3px 4px!important;overflow:hidden;background-color:#fff!important;' +
        'background-position:top center!important;background-size:min(70px,86%) auto!important;background-repeat:no-repeat!important;border-radius:0!important;display:block!important;vertical-align:top}' +
      'fieldset[data-option-name*="fram"] .block-swatch span{display:none!important}' +
      'fieldset[data-option-name*="fram"] .block-swatch .wlfrcap{display:block!important;font-size:11px;line-height:1.3;text-align:center;color:#4a4a44;white-space:normal}' +
      'fieldset[data-option-name*="fram"] .block-swatch .wlfrcap b{display:block;font-weight:600;color:#1b1b1b}' +
      'fieldset[data-option-name*="fram"] input:checked+label.block-swatch{outline:2px solid var(--wlsysbg,#425934)!important;outline-offset:1px}' +
      'fieldset[data-option-name*="fram"] input:checked+label.block-swatch::after{content:"✓";position:absolute;top:54px;right:8px;width:16px;height:16px;background:var(--wlsysbg,#425934);color:var(--wlsysfg,#fff);font-size:11px;line-height:16px;text-align:center}' +
      '@media (max-width:600px){' +
        'fieldset[data-option-name*="fram"] .block-swatch[data-value-handle][data-value-handle]{padding:56px 2px 3px!important;background-size:min(52px,86%) auto!important}' +
        'fieldset[data-option-name*="fram"] .block-swatch .wlfrcap{font-size:10px}' +
        'fieldset[data-option-name*="fram"] input:checked+label.block-swatch::after{top:38px;right:5px}}' +
      'fieldset[data-option-name*="fram"] .block-swatch[data-value-handle][data-value-handle]{position:relative}' +
      /* bold section headers — ours and the theme's option legends */
      '.wlsec{font-weight:600;font-size:.9375rem;color:#1b1b1b;margin:0 0 10px;font-family:inherit;letter-spacing:.01em}' +
      'fieldset[data-option-name*="size"] legend,fieldset[data-option-name*="fram"] legend{font-weight:600!important}' +
      '#wlpdptop{padding:0;border:none;margin:0 0 8px!important}' +
      // Desktop keeps ONE line (Summer): fitBadges() shrinks --wlbf until the row
      // fits. Do NOT set flex-wrap:wrap here — wrapping makes scrollWidth never
      // exceed clientWidth, so the shrink loop never fires and the row silently
      // becomes two lines. Mobile wraps instead; there is no room to shrink into.
      '#wlpdptop .wl-badgerow{display:flex;flex-wrap:nowrap;gap:6px;align-items:center;margin:0 0 8px;min-width:0}' +
      '@media(max-width:700px){#wlpdptop .wl-badgerow{flex-wrap:wrap}}' +
      '#wlpdptop .wl-badgerow .product-info__block-item{margin:0!important}' +
      '#wlpdptop .wl-artchip .feature-badge{background-color:transparent!important;color:#3a3f47!important;border:0!important;border-radius:0;padding:0!important;font-size:12.5px!important}' +
      '#wlpdptop .wl-artchip .feature-badge svg{display:none}' +
      '#wlpdptop .wl-meta{display:flex;flex-wrap:wrap;gap:6px;align-items:center}' +
      '#wlpdptop .wl-meta .product-info__block-item,#wlpdptop .wl-meta .product-info__block-item div{display:contents}' +
      '#wlpdptop .wl-meta .feature-badge{display:inline-flex!important}' +
      '#wlpdptop .wl-meta span{white-space:nowrap}' +
      '#wlpdptop{max-width:100%;overflow:hidden}' +
      '#wlpdptop .wl-badgerow{max-width:100%}' +
      '#wlpdptop .wl-meta{max-width:100%;min-width:0}' +
      '#wlpdptop .wl-tag{font-size:11px!important;padding:4px 9px!important}' +
      '#wlpdptop .wl-artchip .feature-badge{font-size:11px!important;padding:0!important}' +
      '#wlpdptop .wl-meta .wl-meta-tags{display:contents!important}' +
      '#wlpdptop .wl-meta .wl-tag{display:inline-flex!important;white-space:nowrap}' +
      // padding scales with the font too, else 4 badges never fit a 459px column
      '#wlpdptop .feature-badge{padding:4px calc(var(--wlbf,11.5px) * .62)!important;font-size:var(--wlbf,11.5px)!important;white-space:nowrap}' +
      '#wlpdptop .feature-badge svg{width:calc(var(--wlbf,11.5px) + 4px);height:calc(var(--wlbf,11.5px) + 4px);flex:none}' +
      // Summer 2026-07-30: on artwork pages the four green badges LEAD the left
      // column (above "See it on your wall"), like the print page. They move into
      // #wlbadgetop on desktop, so the #wlpdptop badge styles are mirrored here.
      '#wlbadgetop{max-width:100%;overflow:hidden}' +
      '#wlbadgetop .wl-badgerow{display:flex;flex-wrap:nowrap;gap:6px;align-items:center;margin:0 0 8px;min-width:0;max-width:100%}' +
      '@media(max-width:700px){#wlbadgetop .wl-badgerow{flex-wrap:wrap}}' +
      '#wlbadgetop .wl-badgerow .product-info__block-item{margin:0!important}' +
      '#wlbadgetop .feature-badge{padding:4px calc(var(--wlbf,11.5px) * .62)!important;font-size:var(--wlbf,11.5px)!important;white-space:nowrap}' +
      '#wlbadgetop .feature-badge svg{width:calc(var(--wlbf,11.5px) + 4px);height:calc(var(--wlbf,11.5px) + 4px);flex:none}' +
      '.wl-infocol{padding:16px;box-sizing:border-box}' +
      '.wl-pgrid{margin-top:0!important;column-gap:40px!important}' +
      '@media(max-width:899px){.wl-pgrid{display:flex!important;flex-direction:column}.wl-infocol{order:-1;min-width:0;max-width:100%}.wlc4{margin-left:0!important;margin-right:0!important}}' +
      '#wlpdptop .wl-meta{min-width:0}' +
      '#wlpdptop .wl-meta .product-info__block-item{margin:0!important}' +
      '.wlc4{font-family:' + bodyFont + ';margin:10px 0}' +
      '.wlc4 .nt,.wlwall .nt{font-size:11.5px;color:#6b6b6b;line-height:1.5}' +
      '.wlc4 .body,.wlwall .body{font-size:.875rem;color:#1b1b1b;line-height:1.5}' +
      // checkout-card blocks: low-contrast shade, each an unbreakable line
      // full wording stays unbreakable: 11px on desktop, shrinks on a phone so the
      // longest block (shipping) still fits 335px without overflowing
      // six short, unbreakable, low-contrast blocks — no bold (Summer 2026-07-14)
      // .wlship = the shipping/made-to-order chips, which now live under the price
      // OUTSIDE the .wlc4 box — they need the chip skin too
      '.wlc4 .wlchip,.wlship .wlchip{display:inline-block;background:rgba(27,27,27,.06);border-radius:3px;padding:3px 6px;margin:0 4px 4px 0;white-space:nowrap;font-size:11px;line-height:1.5;font-weight:400;color:#1b1b1b}' +
      '.wlc4 label{white-space:normal!important;min-width:0}.wlc4 label>span{white-space:normal!important;min-width:0}' +
      '.wlc4 .nt .wlchip{color:#1b1b1b;font-weight:400}' +
      '.wlc4 input{font-size:13px;padding:6px;border:1px solid #d8d3cb;width:62px;font-family:inherit}' +
      '.wlc4 .btn,.wlwall .btn{border:1px solid var(--wlsysbg,#1b1b1b);background:var(--wlsysbg,#1b1b1b);color:var(--wlsysfg,#fff);border-radius:var(--wlsysrad,0);padding:9px 16px;font-family:inherit;font-size:var(--wlsysfs,11.5px);letter-spacing:var(--wlsysls,.04em);text-transform:var(--wlsystt,none);cursor:pointer}' +
      '.wlc4 .ghost,.wlwall .ghost{border:1px solid #c9c4ba;background:transparent;color:#1b1b1b;border-radius:var(--wlsysrad,0);padding:4px 9px;font-family:inherit;font-size:10.5px;letter-spacing:.02em;text-transform:none;cursor:pointer}' +
      // The control row (buttons + "Size is an estimate…") takes its OWN full-width
      // line: it used to be a third item on the nowrap caption line, which squeezed
      // it to zero width and truncated the note on My room / AI photo.
      '.wlwall .wctl{display:flex!important;flex-wrap:wrap;gap:6px;align-items:center;margin:0!important;flex:1 0 100%;white-space:normal}' +
      '.wlwall .wctl:empty{display:none!important}' +
      '.wlc4 .dt{width:23px;height:23px;border-radius:50%;border:2px solid #fff;outline:1px solid #ddd;cursor:pointer;padding:0}' +
      '.wlc4 .dt.on{outline:2px solid #1b1b1b}' +
      '.wlc4 .dt.none{background:linear-gradient(135deg,#fff 44%,#c33 47%,#c33 53%,#fff 56%)}' +
      // Summer 2026-07-31: ALL 14 colour-filter dots on ONE line on a phone —
      // 19px dots + 3px gaps = ~305px, inside the narrowest (print-page) column.
      // No colour is dropped; they shrink to fit.
      '@media(max-width:480px){.wlc4 .wlcfrow{gap:3px!important}.wlc4 .dt{width:19px;height:19px}' +
      '#wlbigwrap .lkc{gap:3px!important}#wlbigwrap .lkc .dt{width:19px!important;height:19px!important}' +
      // Summer 2026-07-31: labels shortened, type near-normal (12px, was a 10px
      // clamp). One line on standard phones; only the narrowest screens wrap.
      '.wlc4.wl-addonrow,.wlc4.wl-addonrow label>span,' +
      // the canvas/panel spec line reads at the SAME size as the add-on lines
      // (Summer 2026-08-24) — it was the only 13px row left among 12px siblings
      '.product-info .wlc4 .wl-frtxt,.product-info .wlc4 .wl-pnote{font-size:12px!important;letter-spacing:0}' +
      '.wl-infocol .wlc4.wl-addonrow{margin-left:-10px!important;margin-right:-10px!important}}' +
      '.wlc4 .lk,.wlwall .lk{background:none;border:none;color:#8a6d3b;text-decoration:underline;cursor:pointer;font-size:11.5px;padding:0;font-family:inherit}' +
      // ---- palette: taken from the THEME's own colour scheme (Prestige exposes
      // these on the section) — no invented beige. Fallbacks = the live values.
      '.wlwall{border:none;padding:0;margin:0 0 18px;font-family:' + bodyFont + ';' +
      '--wlbd:rgb(var(--border-color,210 209 209));--wltx:rgb(var(--text-color,43 41 41));' +
      '--wlmute:rgb(var(--text-color,43 41 41)/.55);--wlac:rgb(var(--button-background,66 89 52));' +
      '--wlacfg:rgb(var(--button-text-color,255 255 255));--wlpg:rgb(var(--background,239 239 239));' +
      // one surface tone, lighter than the page, shared by the control strip above
      // the image and the caption strip below it (Summer 2026-07-15)
      '--wlsurf:color-mix(in srgb, var(--wlpg) 30%, #fff)}' +
      // ---- PRIMARY tabs: what am I looking at. The live tab is white and joins the
      // panel below (no bottom edge); the other stays page-grey and keeps its edge,
      // so the two rows can never be mistaken for one another.
      '.wlwall .wtop{display:flex;gap:0;margin:8px 0 0;border:1px solid var(--wlbd);border-bottom:0;width:100%}' +
      // sits BETWEEN the page grey and the white panel: on the page background it
      // blended into the page and the label was hard to read (Summer)
      // three tabs since 2026-08-24: flex:1 would give each an equal third and
      // clip "Enhance Image" (117px of text in a 101px box, measured live on a
      // 375px screen). flex:1 1 auto sizes each to its own label first, then
      // shares what is left — so the long one borrows from "Gallery".
      // Summer 2026-09-07 redesign: the three ways to see the print are the
      // headline of the panel — Fraunces, taller, olive underline on the live one
      '.wlwall .wtt{flex:1 1 auto;min-width:0;border:none;border-right:1px solid var(--wlbd);' +
      'background:color-mix(in srgb, var(--wlpg) 45%, #fff);color:var(--wlmute);' +
      'padding:14px 8px;font:500 15px/1.2 Fraunces,Georgia,serif;letter-spacing:.005em;cursor:pointer;white-space:nowrap;' +
      'overflow:hidden;text-overflow:ellipsis;box-shadow:inset 0 -1px 0 var(--wlbd);transition:color .15s,background .15s}' +
      '.wlwall .wtt:hover{color:var(--wltx)}' +
      '.wlwall .wtt:last-child{border-right:none}' +
      '.wlwall .wtt.on{background:#eef3ea;color:var(--wlac);font-weight:600;box-shadow:inset 0 -2px 0 var(--wlac)}' +
      '@media(max-width:480px){.wlwall .wtt{font-size:14px;padding:12px 4px}}' +
      '.wlwall .wpane-gal{border:1px solid var(--wlbd);border-top:0;padding:8px}' +
      // the enhance pane wears the gallery pane's skin so it joins the tab row
      // the same way (mobile only — the desktop block below strips it back).
      // NO side padding: the widget used to sit full-width below the wall, and
      // 8px each side was enough to wrap its "Example 2" tab onto a second row.
      '.wlwall .wpane-enh{border:1px solid var(--wlbd);border-top:0;padding:8px 0}' +
      '.wlwall .wpane-enh iframe{display:block;width:100%;border:0}' +
      // Summer 2026-07-15: the theme hides its thumbnail strip on a phone (.hidden
      // on the list). Show it — you need to see how many images there are.
      '.wlwall .wpane-gal .product-gallery__thumbnail-list{display:block!important;margin-top:8px}' +
      '.wlwall .wpane-gal .product-gallery__thumbnail-scroller{overflow-x:auto;-webkit-overflow-scrolling:touch}' +
      // the theme re-applies its .wl-pgrid (display:flex) to whatever wraps the
      // gallery — so hide panes with a class that outranks it, not inline style.
      '.wlwall .wpane.wpx{display:none !important}' +
      // mobile carries the title in the tab itself; desktop needs it spelled out
      '.wlwall .wtitle{display:none}' +
      // Summer 2026-07-15: the tabs are a MOBILE device. Desktop has the room to
      // show the gallery the original way — stacked under the wall preview — so
      // drop the tab row and reveal both panes. MUST stay after the .wpx rule
      // directly above: same specificity, so source order picks the winner.
      '@media(min-width:750px){' +
      '.wlwall .wtop{display:none}' +
      '.wlwall .wpane.wpx{display:block !important}' +
      '.wlwall .wpane-gal{margin-top:14px}' +
      // desktop: the enhance section has always sat bare between the room and the
      // gallery — no pane border, just the 10px breathing room it had before
      '.wlwall .wpane-enh{border:0;padding:0;margin:10px 0}' +
      '.wlwall .wtitle{display:block;font-weight:600;font-size:.9375rem;color:var(--wltx);margin:0 0 8px;letter-spacing:.01em}' +
      '}' +
      // THUMBNAIL STRIP UNDER THE ROOM (Summer 2026-08-24, second pass).
      // First pass that morning hid the gallery pane outright on a phone, which
      // also took the thumbnails away — and with them the only sign that the
      // product has 11 photos, not one. They are back, but as a STRIP: the pane
      // is revealed while it still carries .wpx, and everything in it except the
      // thumbnail row is hidden, so the big carousel does NOT reappear above the
      // size buttons. The full gallery still belongs to the Gallery tab.
      // Room tab only (not the enhancer) and gallery pages only — .wlgal is off
      // on the frame-your-art page, whose gallery is frame samples the room view
      // is already showing.
      // Side effect, wanted: the "tap a thumbnail to jump to Gallery" shortcut
      // (paneGal click handler) works again on a phone.
      '@media(max-width:749px){' +
      '.wlwall.wlgal.wl-tab-wall .wpane-gal.wpx{display:block!important;border:0;padding:0;margin-top:8px}' +
      '.wlwall.wlgal.wl-tab-wall .wpane-gal.wpx > .wtitle,' +
      '.wlwall.wlgal.wl-tab-wall .wpane-gal.wpx .product-gallery__image-list,' +
      '.wlwall.wlgal.wl-tab-wall .wpane-gal.wpx open-lightbox-button{display:none!important}' +
      '.wlwall.wlgal.wl-tab-wall .wpane-gal.wpx .product-gallery__thumbnail-list{margin-top:0}' +
      '}' +
      // ---- SECONDARY row: which room. Pills sitting ON the white panel, so they
      // read as controls inside the tab — not as a second row of tabs.
      '.wlwall .wtabs{display:flex;flex-wrap:nowrap;gap:5px;margin:0;padding:7px 8px;background:var(--wlsurf);' +
      'border:1px solid var(--wlbd);border-top:0;border-bottom:0;width:100%;box-sizing:border-box;align-items:center}' +
      // square, not pill (Summer 2026-07-15)
      '.wlwall .wt{border:1px solid var(--wlbd);background:transparent;color:var(--wlmute);padding:5px 9px;' +
      'font-size:11.5px;cursor:pointer;font-family:inherit;white-space:nowrap;border-radius:0}' +
      '.wlwall .wt:hover{color:var(--wltx)}' +
      // 2026-09-07 (Summer): the room-view buttons wear the SAME skin as the
      // size chips — 1px hairline, dark-green label; chosen = soft grey fill,
      // 1.5px olive border, olive bold. One visual language on the page.
      '.wlwall .wtabs{gap:6px}' +
      '.wlwall .wtabs .wt{border:1px solid #ddd;background:transparent;color:#004d00;padding:5px 9px;' +
      'font-size:12.5px;font-weight:400;line-height:1.3;letter-spacing:0;border-radius:0;min-height:30px}' +
      '.wlwall .wtabs .wt:hover{border-color:#bdbdbd}' +
      '.wlwall .wtabs .wt.on{background:#f0f0ee;border:1.5px solid var(--wlac);color:var(--wlac);font-weight:700}' +
      // Demo · Mark my wall · Photo-real + 4 icons must fit a 375px phone (measured 2026-09-07)
      '@media(max-width:480px){.wlwall .wtabs .wt{padding:5px 5px !important;font-size:11.5px !important}.wlwall .wtabs{gap:3px !important;padding:7px 6px !important}.wlwall .wtabs .fv{width:21px !important;min-width:21px !important;padding:0 !important}.wlwall .wtabs .fv svg{width:16px;height:16px}}' +

      // Detail zoom (Summer 2026-09-07): the tile viewer lives INSIDE the room box
      // the section's own frame + a height that suits the screen; no JS measuring
      '.wlwall:not(.has-zoom) .wpane.wpane-zoom{display:none !important}' +
      '.wlwall .wpane-zoom{border:1px solid var(--wlbd);padding:8px}' +
      // See it on your wall = the same sealed box on desktop (Summer 2026-09-07:
      // "only the top half had a box"). The pieces inside stop drawing their own edges.
      '@media(min-width:750px){.wlwall .wpane-wall{border:1px solid var(--wlbd);padding:8px}' +
      '.wlwall .wpane-wall .wtabs{border:0 !important;padding-left:0;padding-right:0;padding-top:0}' +
      '.wlwall .wpane-wall .wcap{border:0 !important;border-top:1px solid var(--wlbd) !important}' +
      '.wlwall .wpane-wall .aiview img{border:0}}' +
      '@media(min-width:750px){.wlwall .wpane-zoom{margin-top:14px}}' +
      '.wlwall .zoomv{position:relative;width:100%;background:#141414;overflow:hidden;touch-action:none;' +
      'height:clamp(300px,44vw,560px)}' +
      '@media(max-width:749px){.wlwall .wpane-zoom{border:0;padding:0}.wlwall .zoomv{height:min(64vw,320px)}}' +
      '.wlwall .zoomv .zosd{position:relative !important;width:100%;height:100% !important}' +   // OpenSeadragon forces position:relative on its element, so give it a real height
      '.wlwall .zoomv .zhint{position:absolute;left:8px;top:8px;background:rgba(20,20,20,.62);color:#fff;font:11px/1.3 Helvetica,Arial;padding:4px 8px;border-radius:2px;pointer-events:none;letter-spacing:.02em}' +
      '.wlwall .zoomv .zrule{position:absolute;left:8px;bottom:10px;max-width:calc(100% - 150px);color:#fff;font:11px/1.3 Helvetica,Arial;pointer-events:none;text-shadow:0 1px 2px rgba(0,0,0,.8)}' +
      // Summer 2026-09-07: short on the phone — the bar and the number say it
      '.wlwall .zoomv .zrule small{margin-left:5px;font-size:10.5px;opacity:.85}' +
      '@media(max-width:749px){.wlwall .zoomv .zrule small{display:none}}' +
      // the two lower sections keep their titles, not the rule beside them
      '.wlwall .wpane-wall > .wtitle::after,.wlwall .wpane-zoom > .wtitle::after,.wlwall .wpane-gal > .wtitle::after{display:none !important}' +
      // the small map: white edge you can see, bright green frame inside it
      '.wlwall .zoomv .navigator{border:3px solid #fff !important;background:transparent !important;' +
      'opacity:1 !important;box-shadow:0 2px 10px rgba(0,0,0,.45)}' +
      // the little frame: bright green with a dark edge, so it reads on any painting
      '.wlwall .zoomv .navigator .displayregion{border:3px solid #7ce04a !important;' +
      'box-shadow:0 0 0 1px rgba(0,0,0,.55),0 0 0 1px rgba(0,0,0,.55) inset}' +
      '.wlwall .zoomv .zrule i{display:block;width:100px;height:0;border-bottom:2px solid #fff;border-left:2px solid #fff;border-right:2px solid #fff;height:6px;margin-bottom:3px}' +
      '.wlwall .zoomv .zctl{position:absolute;right:8px;bottom:8px;display:flex;gap:4px}' +
      '.wlwall .zoomv .zctl button{width:34px;height:34px;border:1px solid rgba(255,255,255,.6);background:rgba(20,20,20,.62);color:#fff;font:16px/1 Helvetica,Arial;cursor:pointer;border-radius:2px;padding:0}' +
      '.wlwall .zoomv .zctl button.zfit{width:auto;padding:0 10px;font-size:11px;letter-spacing:.06em;text-transform:uppercase}' +
      '.wlwall .zoomv .zctl button:hover{background:#425934;border-color:#425934}' +
      // ---- Mark my wall / Photo-real: the same chips, on the room picture (Summer 2026-09-07)
      '.wlwall .cvw .wstep{position:absolute;left:50%;top:8px;transform:translateX(-50%);z-index:4;background:rgba(20,20,20,.62);color:#fff;font:11px/1.3 Helvetica,Arial;padding:5px 9px;border-radius:2px;pointer-events:none;letter-spacing:.02em;max-width:calc(100% - 70px);text-align:center}' +   // centred: clear of the corner dots
      '.wlwall .cvw .wstep b{font-weight:700;margin-right:7px}' +
      '.wlwall .cvw .wact{position:absolute;right:8px;bottom:8px;z-index:4;display:flex;gap:4px;align-items:center;flex-wrap:wrap;justify-content:flex-end}' +
      '.wlwall .cvw .wact .wactx{display:contents}' +
      '.wlwall .cvw .wact button{height:34px;min-height:34px;border:1px solid rgba(255,255,255,.6);background:rgba(20,20,20,.62);color:#fff;font:11px/1 Helvetica,Arial;letter-spacing:.06em;text-transform:uppercase;cursor:pointer;border-radius:2px;padding:0 12px;margin:0;width:auto;white-space:nowrap}' +
      '.wlwall .cvw .wact button:hover{background:#425934;border-color:#425934}' +
      '.wlwall .cvw .wact button:disabled{opacity:.65;cursor:default}' +
      '.wlwall .cvw .wact button.gdone,.wlwall .cvw .wact button.aigo,.wlwall .cvw .wact button.whok{background:#425934;border-color:#425934}' +
      '.wlwall .cvw .wact .whpill{display:flex;align-items:center;gap:6px;height:34px;padding:0 10px;background:rgba(20,20,20,.62);color:#fff;font:11px/1 Helvetica,Arial;border:1px solid rgba(255,255,255,.6);border-radius:2px;box-sizing:border-box}' +
      '.wlwall .cvw .wact .whpill input{width:52px;height:26px;border:1px solid rgba(255,255,255,.7);background:#fff;color:#1b1b1b;text-align:center;font:13px/1 Helvetica,Arial;padding:0 3px;border-radius:2px;margin:0}' +
      '.wlwall .cvw .wstage{position:relative;z-index:4;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;padding:20px;background:var(--wlpg);gap:6px;box-sizing:border-box}' +
      '.wlwall .cvw .wstage .wsn{font:11px/1.3 Helvetica,Arial;letter-spacing:.1em;text-transform:uppercase;color:var(--wlac);font-weight:700}' +
      '.wlwall .cvw .wstage .body{font-size:16px;color:var(--wltx);margin:2px 0 0}' +
      '.wlwall .cvw .wstage .nt{font-size:12.5px;max-width:420px}' +
      '.wlwall .cvw .wstage .btn{margin-top:12px}' +
      // PHONE (Summer 2026-09-07: "not very mobile friendly"): the same sealed box
      // as desktop; the action chips leave the picture and sit in ONE ROW under
      // it, small, so no chip can ever cover a corner dot.
      '@media(max-width:749px){.wlwall .wpane-wall{border:1px solid var(--wlbd)}' +
      '.wlwall .wpane-wall .wtabs{border:0 !important}' +
      '.wlwall .wpane-wall .wcap{border:0 !important;border-top:1px solid var(--wlbd) !important}' +
      '.wlwall .wpane-wall .aiview img{border:0}' +
      '.wlwall .cvw{display:flex;flex-direction:column}' +
      '.wlwall .cvw .wcv,.wlwall .cvw .wstage{order:0}.wlwall .cvw .wact{order:1}.wlwall .cvw .aiview{order:2}' +
      '.wlwall .cvw .wact{position:static !important;width:100%;box-sizing:border-box;flex-wrap:nowrap;gap:4px;padding:4px 0 0;justify-content:stretch}' +
      '.wlwall .cvw .wact button{flex:1 1 0;min-width:0;height:30px;min-height:30px;padding:0 4px;font-size:10px;letter-spacing:0;overflow:hidden;text-overflow:ellipsis}' +'.wlwall .cvw .wact button.aigo,.wlwall .cvw .wact button.gdone{flex:1.6 1 0;background:#425934;border-color:#425934}' +
      '.wlwall .cvw .wact .whpill{flex:1 1 0;height:30px;justify-content:center}' +
      '.wlwall .cvw .wstep{font-size:10.5px;padding:4px 7px}' +
      '.wlwall .cvw .wact .whpill input{height:24px}' +
      '.wlwall .cvw .wstage .body{font-size:14.5px}.wlwall .cvw .wstage .nt{font-size:12px}}' +
      
      // wall-height box: same size as the caption beside it, also on the phone
      // (Summer 2026-09-07); 16px only while typing so iPhones do not zoom
      '.wlwall .wcap .whcm{font-size:min(12.5px,2.75vw) !important;height:20px !important}' +
      '.wlwall .wcap .whcm:focus{font-size:16px !important}' +
      // phone: four tabs + icons must fit one row (Summer 2026-09-07); the
      // full-view magnifier goes — pinch does that job on a phone
      '@media(max-width:480px){.wlwall .fv{width:24px;min-width:24px;padding:0}.wlwall .wtabs .fv{margin-left:0}}' +
      '.wlwall .wt.on{background:var(--wlac);border-color:var(--wlac);color:var(--wlacfg);font-weight:600}' +
      // ---- "Enhance this image" beside the uploaded thumbnail (Summer 2026-08-24).
      // A PHONE control only: it exists to reach the Enhance Image TAB, and the
      // tab row itself only exists under 750px — desktop already shows the
      // enhance pane on screen under the room, so there is nothing to jump to.
      // Quiet height 30px with a 44px tap area grown by ::after (DESIGN-RULES §1.3).
      ".wlwall .wlthumbs{align-items:center}" +
      ".wlwall .wlenhjump{height:30px;padding:0 10px;border:1px solid var(--wlac);background:#fff;" +
      "color:var(--wlac);font-size:11.5px;font-weight:600;letter-spacing:.01em;font-family:inherit;" +
      "line-height:1;cursor:pointer;border-radius:0;white-space:nowrap;flex:none;position:relative}" +
      ".wlwall .wlenhjump::after{content:'';position:absolute;left:0;right:0;top:-7px;bottom:-7px}" +
      "@media(min-width:750px){.wlwall .wlenhjump{display:none}}" +
      '.wlwall .cvw{position:relative}' +
      // pan-y, NOT none: a finger anywhere on the room used to grab the artwork and
      // swallow the page scroll. The canvas now scrolls the page vertically; only
      // .wdrag (sized to the art) claims the gesture. Horizontal stays ours = swipe.
      '.wlwall canvas{width:100%;display:block;border:1px solid var(--wlbd);touch-action:pan-y;background:var(--wlpg)}' +
      '.wlwall .wdrag{position:absolute;touch-action:pan-y;cursor:grab;z-index:2}' +   // pan-y: a vertical swipe on the photo still scrolls the page (Summer 2026-09-07)
      '.wlwall .wdrag:active{cursor:grabbing}' +
      '.wlwall .aiview{border:none;background:transparent;padding:4px 0 0;min-height:0}' +
      '.wlwall .aiview img{width:100%;display:block;border:1px solid var(--wlbd)}' +
      // icons: plain marks on the panel, no boxes competing with the pills
      '.wlwall .fv{background:transparent;border:none;cursor:pointer;padding:5px;font-family:inherit;line-height:0;flex:none;color:var(--wlmute)}' +
      '.wlwall .hintbox{display:none}' +
      '.wlwall .ownguide{background:#fff;border:1px solid var(--wlac);border-top:0;padding:10px 12px;font-size:12.5px;color:#1b1b1b;display:flex;gap:12px;align-items:center;justify-content:space-between}' +
      // stroke:currentColor beats the SVG's hardcoded stroke attribute, so the
      // icons follow the theme text colour instead of a fixed near-black
      '.wlwall .fv svg{width:17px;height:17px;display:block;stroke:currentColor}' +
      '.wlwall .fv:hover{color:var(--wltx)}' +
      // size · frame · wall height all on ONE line — shrinks on a phone to fit
      // size · frame · wall height all on ONE line. The left label truncates before
      // the row can ever push past the viewport.
      '.wlwall .wcap{display:flex;justify-content:space-between;gap:6px;align-items:center;font-size:min(12.5px,2.75vw);color:var(--wltx);background:var(--wlsurf);border:1px solid var(--wlbd);border-top:0;padding:5px 8px;white-space:nowrap}' +
      // flex-BASIS 0, not auto (Summer 2026-08-24): flex line-breaking uses each
      // item's HYPOTHETICAL size, which for basis:auto is its full untruncated
      // text. On a wide phone "150x120 cm - Natural Oak Frame - custom" plus the
      // wall-height box passed the row width, so the row WRAPPED before the
      // ellipsis ever got a chance. Basis 0 contributes nothing to that sum, so
      // the two halves can never break apart; the label truncates instead.
      '.wlwall .wcap .capl{flex:1 1 0;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.wlwall .wcap .whwrap{flex:0 0 auto;white-space:nowrap;font-size:inherit}' +
      // the "(max 420)" hint costs the frame name its place on a phone; the input
      // enforces the cap anyway, so drop the hint rather than the frame
      '@media(max-width:749px){.wlwall .wcap .whmax{display:none}}' +
      '.wlwall .wcap .hint{font-size:11px;color:#8a8a8a;text-align:right}' +
      // The box, not the digits (Summer 2026-08-24): the theme forces every input
      // to 16px under 700px wide (its iOS auto-zoom fix, and it carries
      // !important) so the font-size below only ever wins on desktop. A 16px
      // font with the browser's default 24px line-height made this a 30px slab
      // beside a 17px caption row. Fix the BOX instead - fighting the 16px would
      // make iPhones zoom the page every time the field is tapped.
      '.wlwall .whcm{font-size:min(12px,2.6vw);padding:0 3px;border:1px solid var(--wlbd);width:40px;'
      + 'height:20px;line-height:18px;box-sizing:border-box;text-align:center;vertical-align:middle;font-family:inherit}' +
      // type="number" was added 2026-08-24 so the 420cm cap is refused while you
      // type instead of silently corrected on blur. It also brought spinner arrows,
      // which ate the field and clipped "270" to "27(". The cap stays, the arrows go.
      '.wlwall .whcm::-webkit-outer-spin-button,.wlwall .whcm::-webkit-inner-spin-button,' +
      '.wlwall .whcm2::-webkit-outer-spin-button,.wlwall .whcm2::-webkit-inner-spin-button' +
      '{-webkit-appearance:none;margin:0}' +
      '.wlwall .whcm,.wlwall .whcm2{-moz-appearance:textfield;appearance:textfield}' +
      '.wlwall .cfm{border:none;background:transparent;padding:6px 0}' +
      // Summer 2026-07-15: the ask-first upload panel. Bordered box with real
      // breathing room so it never reads as part of the image gallery below it.
      // Shared by "My room" and "In-situ" so both offer the same interface.
      '.wlwall .upnl{border:1px solid var(--wlbd);background:var(--wlpg);padding:26px 18px;min-height:200px;' +
      'display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center}' +
      '.wlwall .upnl .btn{margin-top:14px}' +
      '.wl-infocol .wlc4{font-size:13px}.wl-infocol .nt{font-size:12px;color:#5d5a52}' +
      '.wl-infocol fieldset label.block-swatch{padding:6px 11px!important;min-height:0!important;font-size:12px!important}' +
      '.wlm-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px;margin-top:8px}' +
      '.wlm-grid img{width:100%;aspect-ratio:1/1.05;object-fit:cover;border:1px solid #e6e2dc;display:block}' +
      '.wlm-grid select,.wlm-grid input{font-size:12px;padding:4px;border:1px solid #d8d3cb;font-family:inherit;max-width:100%;box-sizing:border-box}' +
      '.wlm-grid select{width:100%}' +
      '.wlm-grid .ttl{font-size:12px;line-height:1.35;margin:6px 0 4px;color:#1b1b1b}' +
      '.wlm-grid .pr{font-size:12.5px;color:#1b1b1b}' +
      // Summer 2026-07-14: 3 across on a phone too, smaller text. MUST sit after the
      // base rules above (equal specificity — source order decides), and !important
      // because the theme's own select styling outranks ".wlm-grid select".
      '@media(max-width:560px){' +
      '.wlm-grid{grid-template-columns:repeat(3,minmax(0,1fr))!important;gap:6px!important}' +
      // clamp the title to 2 lines so every column's dropdowns/price sit on the
      // same rows — ragged titles knocked the three cells out of alignment
      '.wlm-grid .ttl{font-size:9.5px!important;line-height:1.25!important;margin:4px 0 2px!important;' +
      'display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:24px}' +
      '.wlm-grid .pr{font-size:9.5px!important}' +
      // room on the right so the native arrow does not sit on the option text
      '.wlm-grid select,.wlm-grid input{font-size:9.5px!important;padding:2px 13px 2px 2px!important}' +
      '.wlm-grid .ghost{font-size:9px!important;padding:3px 4px!important}' +
      '.wlm-grid .wlm-c{font-size:9px!important}}' +
      // Summer 2026-08-24: the band is page-wide on .com.au and .com, both
      // breakpoints. Inner padding tracks the theme's own --container-gutter so
      // the cells line up with the gallery above; on a phone it drops to 12px,
      // which is the whole point of the change (318px of cards -> 366px).
      // These rules come AFTER the 560px block above on purpose — the mobile
      // ones repeat !important AND add a class, so they outrank it.
      '.wlsetband{margin:34px 0 0;padding:30px var(--container-gutter,3rem) 34px}' +
      '.wlsetband .wlm-grid{gap:22px;margin-top:12px}' +
      '.wlsetband .wlm-grid .ttl{font-size:13px;line-height:1.4;margin:8px 0 6px;' +
      'display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:37px}' +
      '.wlsetband .wlm-grid .pr{font-size:14px}' +
      '.wlsetband .wlm-grid select,.wlsetband .wlm-grid input{font-size:13px;padding:7px 8px}' +
      '.wlsetband .wlm-grid .ghost{font-size:11.5px;padding:6px 10px}' +
      '@media(max-width:749px){' +
      '.wlsetband{margin:24px 0 0;padding:22px 12px 26px}' +
      '.wlsetband .wlm-grid{gap:10px!important;margin-top:10px}' +
      '.wlsetband .wlm-grid .ttl{font-size:11.5px!important;line-height:1.3!important;' +
      'margin:6px 0 4px!important;min-height:30px}' +
      '.wlsetband .wlm-grid .pr{font-size:12px!important}' +
      '.wlsetband .wlm-grid select,.wlsetband .wlm-grid input{font-size:10px!important;' +
      'padding:4px 11px 4px 3px!important}' +
      '.wlsetband .wlm-grid .ghost{font-size:10px!important;padding:4px 6px!important}' +
      '.wlsetband .wlm-grid .wlm-c{font-size:10px!important}}' +
      '.wlm-chip{border:1px solid #d8d3cb;background:#fff;color:#444;padding:6px 12px;font-size:11.5px;cursor:pointer;font-family:inherit}' +
      '.wlm-chip.on{border-color:#1b1b1b;background:#1b1b1b;color:#fff}' +
      '.wlm-addbtn{display:block;width:100%;background:var(--wlsysbg,#425934);border:none;color:#fff;padding:14px;letter-spacing:.14em;text-transform:uppercase;font-size:12px;cursor:pointer;font-family:inherit;margin-top:10px}' +
      '.wlm-addbtn:hover{background:#3c4526}' +
      '#wlbigwrap{position:fixed;inset:0;z-index:2147482500;background:rgba(20,20,20,.9);display:none;align-items:center;justify-content:center;padding:16px}' +
      '#wlbig{background:#fff;padding:16px;max-width:1100px;width:100%;max-height:96vh;overflow:auto;font-family:' + bodyFont + '}' +
      '#wlbig .chip{border:1px solid #d8d3cb;background:#fff;padding:6px 10px;font-size:11px;cursor:pointer;font-family:inherit}' +
      '#wlbig .chip.on{border-color:#1b1b1b;background:#1b1b1b;color:#fff}';
    document.head.appendChild(css);

    // ================= 1. MOCKUP — heading, tabs, canvas, caption, actions ========
    var MAG = '<svg viewBox="0 0 24 24" fill="none" stroke="#1b1b1b" stroke-width="2"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21"/><path d="M8 10.5h5M10.5 8v5"/></svg>';
    // ENH = this page sells the image enhancement: the print page (OWN), or any
    // page whose description ships the widget in #wlenhsec. Artwork PDPs do
    // neither, and must show no enhancement anywhere (Summer 2026-08-24).
    var ENH = OWN || !!document.getElementById("wlenhsec");
    var wall = document.createElement("div");
    // wl-tab-wall = the Room tab is the live one (mobile). wlgal = this page has
    // a real photo gallery worth advertising, i.e. NOT the frame-your-art page,
    // whose gallery is frame samples the room view already shows.
    wall.className = "wlwall wl-tab-wall" + (OWN ? "" : " wlgal");
    wall.innerHTML =
      // Summer 2026-08-24: THREE mobile tabs. The enhancement preview used to sit
      // far below the thumbnail strip, where nobody on a phone ever scrolled — it
      // is a tab of its own now. Desktop is untouched: .wtop is hidden ≥750px and
      // every pane is revealed, so the three panes stack exactly as before.
      '<div class="wtop">' +
      ' <button type="button" class="wtt on" data-p="wall">Room view</button>' +
      // shown once the artwork's zoom tiles are found on the server (zoomProbe)
      (OWN ? '' : ' <button type="button" class="wtt wttzoom" data-p="zoom" style="display:none">Detail zoom</button>') +
      '' +
      // Summer 2026-08-24: the enhancement is the customer's-own-image service.
      // It belongs to the print page and its own product page — NEVER an artwork
      // PDP, where the file is already a print master and no #wlenhsec ships in
      // the description, so the tab opened an empty box on a phone.
      (ENH ? ' <button type="button" class="wtt" data-p="enh">Enhance Image</button>' : '') +
      ' <button type="button" class="wtt" data-p="gal">Gallery</button>' +
      '</div>' +
      '<div class="wpane wpane-wall">' +
      '<div class="wtitle">See it on your wall</div>' +       // inside the box, like Detail zoom (Summer 2026-09-07)
      '<div class="wtabs">' +
      ' <button type="button" class="wt on" data-t="tpl">Demo room</button>' +
      ' <button type="button" class="wt" data-t="own">My room</button>' +
      // AI photo tab is artwork-pages only — Summer 2026-07-30: renders cost
      // money and the print page doesn't need them
      // Summer 2026-09-07: Photo-real is the LAST STEP of My room now, not a tab of its own


      ' <span style="flex:1"></span>' +
      ' <button type="button" class="fv winfo" title="How this works" aria-label="How this works">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="#1b1b1b" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 11v6"/><circle cx="12" cy="7.5" r=".5" fill="#1b1b1b"/></svg></button>' +
      ' <button type="button" class="fv wsave" title="Save image" aria-label="Save image">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="#1b1b1b" stroke-width="2"><path d="M12 3v12M7 10l5 5 5-5"/><path d="M4 19h16"/></svg></button>' +
      ' <button type="button" class="fv wemail" title="Email it to me" aria-label="Email it to me">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="#1b1b1b" stroke-width="2"><rect x="3" y="5" width="18" height="14" rx="1"/><path d="M3 7l9 6 9-6"/></svg></button>' +
      ' <button type="button" class="fv wfull" title="Full view" aria-label="Full view">' + MAG + '</button></div>' +
            // Summer 2026-09-07: help and buttons sit ON the picture, like Detail zoom.
      // .wstep = the one step you are on (top left) · .wact = the one or two
      // buttons for that step (bottom right) · .wstage = the "nothing uploaded
      // yet" panel, same frame as the picture so the page never jumps.
      '<div class="cvw"><canvas class="wcv" height="10"></canvas><div class="wdrag"></div>' +
      '<div class="aiview" style="display:none"></div>' +
      '<div class="wstep" style="display:none"></div>' +
      
      '<div class="wact" style="display:none"><span class="wactx"></span><button type="button" class="gdone" style="display:none">Done</button></div>' +
      '<div class="wstage" style="display:none"></div>' +
'</div>' +
      '<div class="ownguide" style="display:none"><span class="gtxt"></span></div>' +
      '<div class="wcap" style="flex-wrap:wrap;row-gap:5px"><span class="capl">&nbsp;</span>' +
      '<span class="whwrap nt" style="white-space:nowrap">Wall height <input class="whcm" inputmode="numeric" type="number" min="150" max="600" step="1"> cm <span class="whmax"></span></span>' +
      '<span class="wctl"></span></div>' +

      '<div class="wmsg nt" style="margin-top:6px"></div>' +
      '</div>' +
      // the enhance widget's home at EVERY width — #wlenhsec is seated in here by
      // seat() below. Desktop shows it between the room and the gallery (Summer's
      // 2026-08-23 ruling, unchanged); mobile shows it as the middle tab.
      // Detail zoom — its OWN section (Summer 2026-09-07): on desktop it stacks
      // between "See it on your wall" and the gallery; on the phone it is the
      // middle tab. Hidden entirely until the artwork's tiles are found.
      (OWN ? '' :
        '<div class="wpane wpane-zoom wpx"><div class="wtitle">Detail zoom</div>' +
        '<div class="zoomv"><div class="zosd"></div><div class="zhint">Zoom in to see the brushwork · drag to move</div>' +
        '<div class="zrule"><i></i><span></span></div>' +
        '<div class="zctl"><button type="button" data-z="in" title="Closer">+</button><button type="button" data-z="out" title="Further">−</button>' +
        '<button type="button" class="zfit" data-z="fit" title="Whole print">Fit</button></div></div></div>') +
      (ENH ? '<div class="wpane wpane-enh wpx"></div>' : '') +
      '<div class="wpane wpane-gal wpx"><div class="wtitle">Image Gallery</div></div>';
    if (pickerBlock && pickerBlock.parentElement)
      pickerBlock.parentElement.insertBefore(wall, pickerBlock);
    else holder.appendChild(wall);
    var wq = function (s) { return wall.querySelector(s); };
    // ---- top tabs: "See it on your wall" (the mockup) | "Image Gallery" (the
    // theme's swipeable photo gallery, moved up out of the page bottom) --------
    (function topTabs() {
      var paneWall = wall.querySelector(".wpane-wall"), paneGal = wall.querySelector(".wpane-gal"),
          paneEnh = wall.querySelector(".wpane-enh");
      var paneZoom = wall.querySelector(".wpane-zoom");
      var PANES = { wall: paneWall, zoom: paneZoom, enh: paneEnh, gal: paneGal };
      var gal = document.querySelector(".product-gallery, product-gallery");
      if (gal && paneGal) {
        paneGal.appendChild(gal);                              // relocate, don't rebuild
        // The theme injects the WL badge / spec / tag block INSIDE product-gallery,
        // and it lands AFTER we run — so retry briefly, then lift it back out so it
        // shows under BOTH tabs instead of being buried in the gallery pane.
        var lift = function () {
          var g = paneGal.querySelector("product-gallery, .product-gallery"); if (!g) return false;
          var x = Array.prototype.find.call(g.children, function (c) {
            return c.tagName === "DIV" && !c.className && !c.querySelector("img") &&
                   (c.textContent || "").trim().length > 4; });
          if (!x) return false;
          x.classList.add("wlspecs");
          wall.insertAdjacentElement("afterend", x); reorderPdp(); return true;
        };
        if (!lift()) { var n = 0, iv = setInterval(function () {
          if (lift() || ++n > 25) clearInterval(iv); }, 150); }
      }
      // three panes since 2026-08-24 — one live, the rest carry .wpx. Desktop
      // overrides .wpx back to display:block, so this is a mobile-only effect.
      var show = function (p) {
        if (p === "zoom" && !st.zoomInfo) p = "wall";
        if (!PANES[p]) p = "wall";
        wall.querySelectorAll(".wtt").forEach(function (x) { x.classList.toggle("on", x.dataset.p === p); });
        Object.keys(PANES).forEach(function (k) {
          if (PANES[k]) PANES[k].classList.toggle("wpx", k !== p); });
        if (p === "zoom") zoomTab();          // builds the viewer the first time
        // names the live tab so CSS can react — the gallery's thumbnail strip stays
        // on screen under the room (Summer 2026-07-15) but not under the enhancer
        wall.classList.toggle("wl-tab-enh", p === "enh");
        wall.classList.toggle("wl-tab-wall", p === "wall");
        if (p === "gal") window.dispatchEvent(new Event("resize"));   // let the carousel re-measure
      };
      // the thumbnail strip's "Enhance this image" button drives the tabs too
      st.ownShowPane = show;
      wall.querySelectorAll(".wtt").forEach(function (b) {
        b.onclick = function () { show(b.dataset.p); };
      });
      // Swipe left on the room to reach the gallery without hunting for the tab.
      // Ignores gestures that start on .wdrag (that is an artwork drag) or on a
      // control, and only fires when the move is clearly horizontal.
      var swipe = function (pane, skipSel, ok) {
        if (!pane) return;
        var sx = 0, sy = 0, live = false;
        pane.addEventListener("touchstart", function (e) {
          var t = e.touches[0];
          live = !e.target.closest(skipSel); sx = t.clientX; sy = t.clientY;
        }, { passive: true });
        pane.addEventListener("touchend", function (e) {
          if (!live) return; live = false;
          var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
          if (dx < -45 && Math.abs(dx) > Math.abs(dy) * 1.6) ok();
        }, { passive: true });
      };
      swipe(paneWall, ".wdrag,button,input,select,a,.wtabs", function () { show("gal"); });
      // thumbnails are on screen even while the room tab is live — tapping one
      // should bring the gallery up with it (the theme moves the carousel itself)
      if (paneGal) paneGal.addEventListener("click", function (e) {
        var t = e.target.closest(".product-gallery__thumbnail");
        if (!t || !paneGal.classList.contains("wpx")) return;
        show("gal");
        // the carousel was display:none when the theme handled this tap, so it had
        // nothing to scroll — replay the tap now that it is actually on screen
        setTimeout(function () { t.click(); }, 60);
      });
      // …and carry on past the LAST gallery image to land back on the room
      // (Summer: "I cannot swipe further to the first see it on your wall").
      swipe(paneGal, ".product-gallery__thumbnail", function () {
        var car = paneGal.querySelector(".product-gallery__carousel");
        if (!car) return;
        if (car.scrollLeft + car.clientWidth >= car.scrollWidth - 6) show("wall");
      });
    })();

    var setElRef = null;   // the real "Complete the Set" box, set once it is built
    // Complete the Set is a PAGE-WIDE band (Summer 2026-08-24) — it used to sit
    // inside the narrow buy column, so three companions shared ~565px on desktop
    // and 318px on a phone. Its home is now the last child of the main-product
    // section's spacing wrapper, which is already full-bleed on every viewport,
    // so no 100vw hack and no horizontal overflow. seatSet() runs on every
    // reorderPdp pass — a theme morph or a breakpoint cross cannot drag it back.
    function seatSet() {
      if (!setElRef) return;
      var band = document.querySelector(".shopify-section--main-product .section-spacing") ||
                 (sec && sec.querySelector(".section-spacing"));
      if (band) { if (setElRef.parentElement !== band) band.appendChild(setElRef); return; }
      // no full-bleed wrapper on this template — never leave the box unmounted;
      // fall back to its pre-2026-08-24 home under the buy block
      if (!setElRef.isConnected) {
        var fB = (sec && sec.querySelector("form[action*='/cart/add']")) ||
                 document.querySelector("form[action*='/cart/add']");
        var bB = fB && (fB.closest(".product-info__block-item") || fB.parentElement);
        if (bB) bB.insertAdjacentElement("afterend", setElRef);
      }
    }
    // ---- block order (Summer 2026-07-15). Two different layouts:
    //   MOBILE  — one column: ATC -> specs -> description -> the set.
    //   DESKTOP — the theme's two columns, untouched on the right. The image
    //             display + tags join the description in the LEFT column
    //             (Summer: "on top of the description, as originally designed").
    // NB: hold direct refs — ".wlc4" is a shared utility class on six rows, so
    // querying it here dragged whichever control row came first down the page.
    // Summer 2026-07-31: the set-discount promo rides DIRECTLY under Add to cart.
    // Round 5: the promo renders INSIDE the buy block (buy-buttons.liquid), so
    // it travels with the button automatically — pinning must NOT run then, or
    // the buy block would be torn out and re-inserted after itself (custom
    // elements re-fire connectedCallback = double-bound listeners). The move
    // branch only remains for a stale template still carrying the old block.
    function pinPromo(buyBlock) {
      var pr = document.querySelector(".wl-setpromo--pdp");
      var it = pr && pr.closest(".product-info__block-item");
      if (it && buyBlock && it !== buyBlock && it.previousElementSibling !== buyBlock)
        buyBlock.insertAdjacentElement("afterend", it);
    }
    // Re-appending a node that is ALREADY in place still detaches and re-inserts
    // it — and a detached iframe RELOADS. That is why the enhancement preview
    // blanked and re-rendered on the 1.5s / 4s / 9s passes (measured live
    // 2026-08-24: box 0 -> 261 -> 648 -> 854 px over five seconds). Move nodes
    // only when the order is actually wrong.
    function orderKids(parent, list) {
      var kids = list.filter(Boolean), i, ok = true;
      if (!kids.length) return false;
      for (i = 0; i < kids.length; i++) if (kids[i].parentElement !== parent) { ok = false; break; }
      if (ok) {
        var cur = Array.prototype.filter.call(parent.children, function (c) {
          return kids.indexOf(c) >= 0; });
        if (cur.length === kids.length) {
          for (i = 0; i < kids.length; i++) if (cur[i] !== kids[i]) { ok = false; break; }
          if (ok) return false;                       // already exactly right
        }
      }
      kids.forEach(function (n) { parent.appendChild(n); });
      return true;
    }
    function reorderPdp() {
      var desc = document.querySelector(".product-content-below-gallery");
      if (!desc) return false;
      // remember desc's home in the product grid BEFORE any move — the desktop
      // column must return there even when the mobile branch ran first (a load
      // in a narrow window used to wedge the page in one column for good)
      if (!reorderPdp._home && desc.parentElement &&
          !desc.parentElement.closest(".product-info__block-list") &&
          desc.parentElement.id !== "wlleftcol")
        reorderPdp._home = { p: desc.parentElement, n: desc.nextElementSibling };
      var specs = document.querySelector(".wlspecs");
      if (window.matchMedia("(max-width:749px)").matches) {
        // resolve the form LIVE — a stale ref after theme morphs left the
        // description stranded in #wlband when crossing the 749px line (2026-07-30)
        var fLive = (sec.querySelector("form[action*='/cart/add']") ||
                     document.querySelector("form[action*='/cart/add']") || form);
        var buyB = fLive && (fLive.closest(".product-info__block-item") || fLive.parentElement);
        if (!buyB) return false;
        if (pickerBlock && pickerBlock.parentElement && wall.parentElement !== pickerBlock.parentElement)
          pickerBlock.parentElement.insertBefore(wall, pickerBlock);   // back out of #wlleftcol
        // same rule as orderKids: only move what is out of place, or the iframe
        // inside the wall reloads on every pass (Summer 2026-08-24)
        if (buyB.nextElementSibling !== desc) buyB.insertAdjacentElement("afterend", desc);
        if (specs && desc.previousElementSibling !== specs)
          desc.insertAdjacentElement("beforebegin", specs);
        seatSet();          // full-width band, below the whole product block
        pinPromo(buyB);
        // badges return to their #wlpdptop home on mobile (desktop lifts them
        // into #wlbadgetop above the wall — Summer 2026-07-30)
        var bt0 = document.getElementById("wlbadgetop");
        if (bt0) { var fr0 = bt0.querySelector(".wl-badgerow"),
                       tp0 = document.getElementById("wlpdptop");
          if (fr0 && tp0) tp0.insertBefore(fr0, tp0.firstChild);
          bt0.remove(); }
        var oc = document.getElementById("wlleftcol");
        if (oc && !oc.children.length) oc.remove();
        var ob0 = document.getElementById("wlband");
        if (ob0) ob0.remove();
        if (window.__wlEnhSeat) window.__wlEnhSeat();   // keep enhance section glued under the wall
        return true;
      }
      // Desktop: one wrapper holds the whole left column, so the grid places it
      // as a single item in column 1 instead of auto-flowing three loose children.
      var col = document.getElementById("wlleftcol");
      if (!col) {
        col = document.createElement("div");
        col.id = "wlleftcol";
        var hm = reorderPdp._home;
        if (hm && hm.p && hm.p.isConnected)
          hm.p.insertBefore(col, (hm.n && hm.n.parentElement === hm.p) ? hm.n : null);
        else desc.parentElement.insertBefore(col, desc);
      }
      // Print page (Summer 2026-07-30): the four green badges sit ABOVE the wall
      // preview. Artwork pages (same day): badges lead too — the .wl-badgerow
      // lifts out of #wlpdptop into #wlbadgetop; the Art#/tag chip row stays
      // below the wall with the rest of #wlpdptop.
      var want = [];
      if (OWN && specs) want.push(specs);
      if (!OWN) {
        var frTop = document.querySelector(".wl-badgerow");
        if (frTop) {
          var bt = document.getElementById("wlbadgetop");
          if (!bt) { bt = document.createElement("div"); bt.id = "wlbadgetop"; }
          if (frTop.parentElement !== bt) bt.appendChild(frTop);
          want.push(bt);
        }
      }
      want.push(wall);
      if (!OWN && specs) want.push(specs);
      // 2026-07-30 final: description STAYS in the left column (Summer's original
      // layout) — the "dead right half" it caused is fixed by making the buy
      // panel STICKY instead, so it rides beside the long content and the cart
      // button never leaves the screen. (A centred-band detour was reverted:
      // side-by-side + sticky beats a single column below the fold.)
      var ob1 = document.getElementById("wlband");
      if (ob1) ob1.remove();
      want.push(desc);
      orderKids(col, want);          // no-op when the order is already right
      // desktop: the set builder mounts under the buy block too - the promo
      // states the offer first, the builder acts on it (Summer 2026-07-31)
      var fD = (sec.querySelector("form[action*='/cart/add']") ||
                document.querySelector("form[action*='/cart/add']") || form);
      pinPromo(fD && (fD.closest(".product-info__block-item") || fD.parentElement));
      seatSet();          // full-width band, below both columns
      if (window.__wlFitBadges) setTimeout(window.__wlFitBadges, 60);  // width changed
      // appendChild(wall/desc) above MOVES them past #wlenhsec on every re-run
      // (1.5s/4s/9s timers) — re-seat synchronously so the order never flips
      // (root-caused live 2026-08-23; the iframe heartbeat alone is lazy-loaded
      // and can be absent, which is how the flip stuck on Summer's screen)
      if (window.__wlEnhSeat) window.__wlEnhSeat();
      return true;
    }
    // 2026-09-24 SPEED: one pass NOW, before the cover lifts, so the desktop two
    // columns are already in place at reveal (the 150ms timer alone landed after it:
    // a layout jump in Google's phone test). Idempotent; the timer below still runs.
    try { reorderPdp(); } catch (eR0) {}
    (function () { var n = 0, iv = setInterval(function () {
      if (reorderPdp() || ++n > 25) clearInterval(iv); }, 150); })();
    // the "Complete the Set" panel can mount after the arranger has settled and
    // would re-take the slot under Add to cart - re-run (idempotent) a few times
    [1500, 4000, 9000].forEach(function (ms) { setTimeout(function () { reorderPdp(); }, ms); });
    // crossing the 749px line (rotation, window resize, a pane un-hiding) re-runs
    // the arranger — it is idempotent in both directions now
    try {
      var mqRe = window.matchMedia("(max-width:749px)");
      var reFlow = function () { reorderPdp(); };
      if (mqRe.addEventListener) mqRe.addEventListener("change", reFlow);
      else if (mqRe.addListener) mqRe.addListener(reFlow);
    } catch (e0) {}

    wall.__st = st;
    // ⓘ guide popup — trust notes + how to use the three views (hidden by default)
    wq(".winfo").onclick = function () {
      var ov = document.getElementById("wlguide");
      if (!ov) {
        ov = document.createElement("div"); ov.id = "wlguide";
        ov.style.cssText = "position:fixed;inset:0;z-index:2147482900;background:rgba(20,20,20,.55);display:flex;align-items:center;justify-content:center;padding:16px";
        var ownGuide =
          '<h3 style="font-weight:600;font-size:1.1rem;margin:0 0 4px">See it on your wall — how it works</h3>' +
          '<p style="margin:0 0 14px;color:#6b6659;font-size:12px">Two ways to preview your image at true size before you order.</p>' +
          '<p style="margin:0 0 2px"><b>Demo room</b></p>' +
          '<p style="margin:0 0 12px">Upload your image and it appears here at real scale. Drag it to move, pull a corner to resize — the size boxes and the price follow. With several pieces, the thumbnails under the room switch between them. Set the wall height to match your ceiling.</p>' +
          '<p style="margin:0 0 2px"><b>My room</b></p>' +
          '<p style="margin:0 0 12px">Three steps on the picture: upload a photo of your wall, drag the 4 dots to its corners, confirm the wall height. Your image then appears in your room at true size. Best for checking proportions in your actual space.</p>' +
          '<p style="margin:0 0 2px"><b>Good to know</b></p>' +
          '<p style="margin:0 0 12px">Preview sizes are estimates — they depend on the wall height you set and how precisely you mark the corners. The file you upload is the file we print, untouched.</p>' +
          '<p style="margin:0 0 2px"><b>Your privacy</b></p>' +
          '<p style="margin:0 0 16px">Your photos are used only to build your preview and print your order. They are not shared.</p>';
        ov.innerHTML = '<div style="background:#fff;max-width:560px;width:100%;max-height:88vh;overflow:auto;padding:26px 28px;font-family:inherit;font-size:13.5px;line-height:1.65;color:#2b2925">' +
          (OWN ? ownGuide :
          '<h3 style="font-weight:600;font-size:1.1rem;margin:0 0 4px">See it on your wall — how it works</h3>' +
          '<p style="margin:0 0 14px;color:#6b6659;font-size:12px">Two ways to see the artwork on a wall, one way to see the print up close, and the gallery.</p>' +
          '<p style="margin:0 0 2px"><b>1. Demo room</b></p>' +
          '<p style="margin:0 0 12px">The quickest look: a gallery wall with the artwork at real scale. Drag it to move, pull a corner to resize — the price updates with the size. Set the wall height to match your ceiling.</p>' +
          '<p style="margin:0 0 2px"><b>2. My room</b></p>' +
          '<p style="margin:0 0 12px">Three steps on the picture: upload a photo of your wall, put the 4 dots where the wall meets the floor and the ceiling, confirm the wall height. The artwork then appears in your room at true size. Then press <b>Make the photo-real view</b>: a realistic photo of the artwork hanging in your room, behind your furniture, in your light. Free, up to 5 a day, about 20 to 40 seconds each. Switch between Plain and Photo-real at the top of the picture, and Share the photo with whoever decides with you.</p>' +
          '<p style="margin:0 0 2px"><b>3. Detail zoom</b></p>' +
          '<p style="margin:0 0 12px">The print itself, up close. Drag to move, pinch or use + and − to zoom, double-tap to jump in. The small bar in the corner tells you how many centimetres of the finished print you are looking at — on a ' +
          (function () { try { var d0 = orderDims(); return d0[0] + " × " + d0[1] + " cm"; } catch (e) { return "large"; } })() + ' print, a single brushstroke can be wider than your hand. Only what is on screen loads, so it stays fast.</p>' +
          '<p style="margin:0 0 2px"><b>4. Gallery</b></p>' +
          '<p style="margin:0 0 12px">The photographs: the print framed, in rooms, and the detail crops.</p>' +
          '<p style="margin:0 0 2px"><b>Good to know</b></p>' +
          '<p style="margin:0 0 12px">Preview sizes are estimates — they depend on the wall height you set and how precisely you mark the corners. Photo-real views are true to the artwork; light and colour are approximate. Detail zoom shows the artwork file we print from.</p>' +
          '<p style="margin:0 0 2px"><b>Your privacy</b></p>' +
          '<p style="margin:0 0 16px">Your room photo is used only to build your preview. It is not shared, and you can replace or remove it at any time.</p>') +
          '<button type="button" class="wlgx" style="border:1px solid #1b1b1b;background:#1b1b1b;color:#fff;padding:9px 18px;font-size:11px;letter-spacing:.06em;cursor:pointer;font-family:inherit">Got it</button></div>';
        document.body.appendChild(ov);
        ov.onclick = function (e) { if (e.target === ov) ov.style.display = "none"; };
        ov.querySelector(".wlgx").onclick = function () { ov.style.display = "none"; };
      } else ov.style.display = "flex";
    };
    // one-line client log so upload failures stop being invisible (fire-and-forget)
    var clog = function (step, extra) { try {
      fetch(API + "/api/clog", { method: "POST", headers: { "content-type": "application/json" },
        body: JSON.stringify(Object.assign({ step: step, dm: !!(window.Shopify && Shopify.designMode),
          ua: navigator.userAgent.slice(0, 90), ix: card.index }, extra || {})) }); } catch (e) {} };
    wall.__clog = clog;
    wall.__qd = function () { var cv = wq(".wcv"); return artCorners(cv); };
    // field-error visibility (2026-08-12): any uncaught error from this module
    // reaches the clog feed — a phone that silently loses the room view now
    // leaves a trace we can read at /api/clog-list. Max 3 per page view.
    var errN = 0;
    window.addEventListener("error", function (e) {
      if (errN >= 3 || !e.filename || e.filename.indexOf("customiser") < 0) return;
      errN++;
      clog("js-err", { m: String(e.message || "").slice(0, 140), at: e.lineno + ":" + e.colno });
    });

    // ================= 2. SIZE — Custom pill + AUTO-APPLYING ratio-locked inputs ==
    var valRow = sizeFs ? (sizeFs.querySelector(".variant-picker__option-values") || sizeFs) : null;
    var pill = document.createElement("label");
    pill.className = "block-swatch wl-cpill"; pill.innerHTML = "<span>Custom</span>";
    if (valRow) valRow.appendChild(pill);
    var WLC_NOTE = "Any size — longest side 100–600 cm. The price updates as you type.";
    var cRow = document.createElement("div");
    cRow.className = "wlc4"; cRow.style.display = "none";
    cRow.innerHTML =
      '<input class="wlc-w" placeholder="W" inputmode="numeric"> × ' +
      '<input class="wlc-h" placeholder="H" inputmode="numeric"> cm' +
      // Fix ratio on the ARTWORK custom boxes too (Summer 2026-08-24). A custom
      // size off the artwork's own shape is a squashed print, so it ships TICKED,
      // the same as the Print & Frame page. Unticking restores free typing.
      // Distinct class from the print page's .wlfixrb: that one is driven by a
      // delegated listener on sizeBox, which does not exist on artwork pages.
      '<label class="wlfixr" style="display:inline-flex;align-items:center;gap:5px;cursor:pointer;' +
      'white-space:nowrap;margin-left:10px"><input type="checkbox" class="wlcfixb" checked ' +
      'style="width:14px;height:14px;flex:none;margin:0"><span>Fix ratio</span></label>' +
      '<div class="nt wlc-note" style="margin-top:4px">' + WLC_NOTE + '</div>';
    if (sizeFs) sizeFs.appendChild(cRow);
    var themeCanvasLine = Array.prototype.find.call(
      sec.querySelectorAll(".product-info__block-item"),
      function (b) { return !b.querySelector("fieldset,variant-picker") &&
        !b.querySelector("form[action*='/cart/add']") &&
        /\d{3}g/.test(b.textContent) && /panel/i.test(b.textContent); });
    if (themeCanvasLine) themeCanvasLine.style.display = "none";
    var matLine = document.createElement("div");   // lives in the recipe row under the checkout
    matLine.className = "body";
    matLine.style.cssText = "font-size:12px;color:#6b6b6b;margin-top:3px;line-height:1.5";

    // ================= 3. FRAMING — full option text under the icons =============
    var frNote = document.createElement("div");
    frNote.className = "wlc4 body";
    // uniform 10px line rhythm inside the framing section (Summer 2026-07-30)
    frNote.style.cssText = "margin:10px 0 0";
    // ONE spec line (Summer 2026-08-24): "Rolled Giclee Canvas Print | 380g
    // Premium Linen Canvas - 1 panel". .wl-frtxt is the framing half; .wl-pnote
    // IS pNote (grabbed below) — it is a child here, never a sibling, so a theme
    // morph can only take the whole line or none of it.
    frNote.innerHTML = '<span class="wl-frtxt"></span><span class="wl-pnote"></span>';
    var frTxt = frNote.querySelector(".wl-frtxt");
    if (frFs) frFs.appendChild(frNote);

    // ================= 4. COLOUR FILTER ==========================================
    var lRow = document.createElement("div");
    lRow.className = "wlc4";
    lRow.style.marginTop = "8px";
    lRow.innerHTML = '<p class="wlsec">Colour Filter</p><div class="wlcfrow" style="display:flex;gap:6px;flex-wrap:wrap">' +
      '<button type="button" class="dt none on" data-k="natural" title="None"></button>' +
      Object.keys(TINTS).map(function (k) {
        return '<button type="button" class="dt" data-k="' + k + '" title="' + LABELS[k] +
          '" style="background:' + TINTS[k] + '"></button>'; }).join("") +
      '</div><div class="nt wlc-ln" style="margin-top:4px">None — as painted.</div>';
    if (!OWN) {
      if (pickerBlock && pickerBlock.parentElement)
        pickerBlock.insertAdjacentElement("afterend", lRow);
      else holder.appendChild(lRow);
    }

    // ================= 5. INSTALLATION KIT + PRICE note ==========================
    var kitRow = document.createElement("div");
    kitRow.className = "wlc4 body wl-addonrow"; kitRow.style.display = "none";
    lRow.insertAdjacentElement("afterend", kitRow);
    fetch("/products/heavy-duty-stainless-steel-installation-kit.js")
      .then(function (x) { return x.json(); }).then(function (p) {
        kit.id = p.variants[0].id; kit.price = p.variants[0].price / 100; kit.title = p.title;
        var was = (p.variants[0].compare_at_price ? p.variants[0].compare_at_price / 100 : 40);
        // Summer 2026-07-15: normal body text size (the 11.5px shrink is reverted);
        // it may take two lines at that size and that is fine.
        kitRow.innerHTML = '<label style="cursor:pointer;display:flex;align-items:center;gap:6px">' +
          '<input type="checkbox" class="wlkit" style="width:15px;height:15px;flex:none"> ' +
          '<span>Add the <a href="' + kit.url + '" target="_blank" class="wlkitlink" style="color:inherit;text-decoration:underline;text-underline-offset:2px">stainless steel installation kit</a> ' +
          '(+' + money(kit.price) + ' <s style="color:#8a8a8a">A$' + was + "</s>) " +
          '<span class="wlhelp" tabindex="0" title="One A$19 kit covers your whole order — mounting hardware for every artwork in it, however many pieces you order." ' +
          'style="display:inline-flex;align-items:center;justify-content:center;width:15px;height:15px;' +
          'border:1px solid #8a8a8a;border-radius:50%;font-size:10px;color:#6b6b6b;cursor:help">?</span></span></label>' +
          '<div class="wlhelpnote nt" style="display:none;margin:3px 0 0 21px">One A$19 kit covers your whole order — mounting hardware for every artwork in it, however many pieces you order.</div>';
        kitRow.style.display = "";
        kitRow.querySelector(".wlkitlink").onclick = function (e) { e.stopPropagation(); };
        var hlp = kitRow.querySelector(".wlhelp"), hnote = kitRow.querySelector(".wlhelpnote");
        if (hlp) hlp.onclick = function (e) { e.preventDefault(); e.stopPropagation();
          hnote.style.display = hnote.style.display === "none" ? "" : "none"; };
        kitRow.querySelector(".wlkit").onchange = function () { st.kit = this.checked; price(); };
      }).catch(function () {});
    // ================= OWN ART (print page, spec 2026-07-23) ====================
    // Upload lives ON the wall preview; size = Standard/Custom radio pair; extras
    // (300 DPI enhancement + install kit) sit AFTER the framing options; no proof box.
    if (OWN) {
      st.enh = false; st.proof = false; st.ownRef = null; st.ownUrl = null; st.ownThumb = null; st.ownPx = null;
      // enhancement-preview handoff (2026-08-23): the enhance widget (iframe or
      // ?wlenh= arrival from the enhancement page) names the customer's already-
      // rendered file so the order can trace it. Ref format: enh/<job id>.
      st.enhRef = null;
      try {
        var qEnh = new URLSearchParams(location.search).get("wlenh");
        if (qEnh && /^[\w-]{6,60}$/.test(qEnh)) {
          st.enhRef = "enh/" + qEnh; st.enh = true; st.enhFromQuery = true; }
      } catch (e0) {}
      // A ref the widget ANNOUNCES is only this order's file if the customer
      // enhanced the picture they just uploaded here. The widget also remembers
      // its last job in its own localStorage and re-announces it on load — so a
      // job from the standalone enhancement page, days old, was landing on the
      // print order as "Image enhancement: yes — file enh/<that job>" and
      // pointing production at a completely different picture (reproduced live
      // 2026-08-25: uploaded 14c552ef-9, order carried enh/719b80747b5a).
      // Only take a ref that arrives AFTER this page hands the widget the
      // current upload; the ?wlenh= handoff above is explicit and still stands.
      st.enhSeeded = false;
      window.addEventListener("message", function (ev) {
        var d = ev && ev.data;
        if (d && d.wlEnhRef && /^[\w-]{6,60}$/.test(String(d.wlEnhRef))) {
          if (!st.enhSeeded) return;   // an earlier file's job, not this order's
          st.enhRef = "enh/" + d.wlEnhRef; st.enh = true;
          var ceB = document.querySelector(".wlenh"); if (ceB) ceB.checked = true;
        }
      });

      // ---- upload plumbing (2026-07-23: chunked to R2, 500 MB, PS-openable formats) ----
      var artInp = document.createElement("input");
      artInp.type = "file";
      artInp.accept = "image/jpeg,image/png,image/webp";   // HEIC = email job (Summer 2026-08-24)
      artInp.style.cssText = "position:absolute;width:1px;height:1px;opacity:0";
      holder.appendChild(artInp);
      // the file strip lives ON the preview image, bottom, readable background
      var fileLine = document.createElement("div");
      fileLine.className = "nt wl-filestrip";
      function stripText(t, showReplace, warn) {
        fileLine.innerHTML = "";
        var s = document.createElement("span"); s.textContent = t; fileLine.appendChild(s);
        if (warn) { var wsp = document.createElement("span");
          wsp.textContent = " " + warn;
          wsp.style.cssText = "color:#8a2f2f;font-weight:600"; fileLine.appendChild(wsp); }
        if (showReplace) {
          var a = document.createElement("button"); a.type = "button"; a.className = "wl-replace";
          a.textContent = "Replace file";   // white button, not a link (Summer 2026-07-31)
          a.style.cssText = "background:#fff;border:1px solid #b9b3a6;color:#1b1b1b;" +
            "padding:3px 10px;font-size:11.5px;cursor:pointer;font-family:inherit;margin-left:8px";
          a.onclick = function (ev) { ev.preventDefault();
            if (st.ownReplaceActive) st.ownReplaceActive(); else startUpload(); };
          fileLine.appendChild(a);
        }
        fileLine.style.display = t ? "block" : "none";
      }
      function dpiNote() {
        // an upload in flight OWNS the strip — price refreshes used to call this
        // ~0.3s in and wipe "Uploading…" for the remaining 10–20s (Summer
        // 2026-07-30: "it disappears way earlier than the file appears")
        if (st.upBusy > 0) {
          stripText(st.upNote || "Uploading your file — the full original, untouched…", false);
          if (st.ownZone) st.ownZone(); return; }
        var inf = st.ownActiveInfo ? st.ownActiveInfo() : { name: st.ownName, px: st.ownPx };
        if (!inf || !inf.name) {
          if (st.sample) stripText("Sample image — upload your own file to order.", false);
          else stripText("", false);
          if (st.ownZone) st.ownZone(); return; }
        // Summer 2026-07-30: the filename/px/verdict live in the upload box on
        // the right — the strip on the wall stays EMPTY in steady state and only
        // carries transient messages (uploading %, errors, the sample note).
        stripText("", false);
        if (st.ownZone) st.ownZone();
      }
      st.ownDpiNote = dpiNote;
      st.ownMsg = function (t) { if (t) stripText(t, !!st.ownName); else dpiNote(); };
      function startUpload() { artInp.value = ""; artInp.click(); }
      st.ownStartUpload = startUpload;
      function parseDims(buf, ext) {     // cheap header reads — dimensions only, never a decode
        try {
          var b = new Uint8Array(buf), dv = new DataView(buf);
          if (ext === "psd" && b[0] === 0x38) return { w: dv.getUint32(18), h: dv.getUint32(14) };
          if (ext === "tif" || ext === "tiff") {
            var le = b[0] === 0x49, off = le ? dv.getUint32(4, true) : dv.getUint32(4);
            if (off + 2 > buf.byteLength) return null;
            var n = le ? dv.getUint16(off, true) : dv.getUint16(off), w = 0, h = 0;
            for (var i = 0; i < n && off + 2 + i * 12 + 12 <= buf.byteLength; i++) {
              var e = off + 2 + i * 12, tag = le ? dv.getUint16(e, true) : dv.getUint16(e);
              var typ = le ? dv.getUint16(e + 2, true) : dv.getUint16(e + 2);
              var val = typ === 3 ? (le ? dv.getUint16(e + 8, true) : dv.getUint16(e + 8))
                                  : (le ? dv.getUint32(e + 8, true) : dv.getUint32(e + 8));
              if (tag === 256) w = val; if (tag === 257) h = val;
            }
            return w && h ? { w: w, h: h } : null;
          }
        } catch (e2) {}
        return null;
      }
      async function sniffExt(f, extGuess) {
        // the FILE's first bytes decide the type, never the filename (Summer
        // 2026-07-31): a good image with a lying extension used to die on the
        // worker's magic-byte check ("That file doesn't match its type")
        try {
          var b = new Uint8Array(await f.slice(0, 16).arrayBuffer());
          var asc = function (o, s) { for (var i2 = 0; i2 < s.length; i2++)
            if (b[o + i2] !== s.charCodeAt(i2)) return false; return true; };
          if (b[0] === 0xFF && b[1] === 0xD8) return "jpg";
          if (b[0] === 0x89 && asc(1, "PNG")) return "png";
          if (asc(0, "RIFF") && asc(8, "WEBP")) return "webp";
          if (asc(4, "ftyp")) return "heic";
        } catch (e) {}
        return extGuess;
      }
      async function chunkUpload(f, ext) {
        var jh = { "content-type": "application/json" };
        ext = await sniffExt(f, ext);
        var init = await fetch(API + "/api/own-init", { method: "POST", headers: jh,
          body: JSON.stringify({ ext: ext, size: f.size, name: f.name }) })
          .then(function (x) { return x.json(); }).catch(function () { return { ok: false }; });
        if (!init.ok) return { fail: init.message || "Upload failed — please try again." };
        // 5 MB parts (the R2 multipart minimum). Progress is BYTE-REAL
        // (Summer 2026-07-31: "big files show no feedback"): fetch() cannot
        // report upload bytes, so the % used to freeze for the whole 5 MB part
        // — XHR upload.onprogress ticks it continuously, small files included.
        var CH = 5 * 1048576, n = Math.ceil(f.size / CH), parts = [];
        var lastPct = -1;
        function pctShow(sent) {
          var pct = Math.min(99, Math.floor(sent / f.size * 100));
          if (pct === lastPct) return; lastPct = pct;
          st.upPct = pct;
          st.upNote = "Uploading your file — " + pct + "% (the full original, untouched)…";
          stripText(st.upNote, false);
          st.zoneMsg = "Uploading — " + pct + "%…";
          if (st.ownZone) st.ownZone();
        }
        pctShow(0);
        for (var i = 0; i < n; i++) {
          var base = i * CH, bl = f.slice(base, Math.min(f.size, base + CH)), r = null;
          for (var a = 0; a < 2 && !(r && r.ok); a++)     // one silent retry per chunk
            r = await new Promise(function (res) {
              var x = new XMLHttpRequest();
              x.open("POST", API + "/api/own-part?key=" + encodeURIComponent(init.key) +
                "&uploadId=" + encodeURIComponent(init.uploadId) + "&part=" + (i + 1));
              x.upload.onprogress = function (e) {
                if (e.lengthComputable) pctShow(base + Math.min(e.loaded, bl.size)); };
              x.onload = function () { try { res(JSON.parse(x.responseText)); } catch (e2) { res(null); } };
              x.onerror = x.ontimeout = x.onabort = function () { res(null); };
              x.send(bl);
            });
          if (!r || !r.ok) { st.upPct = null;
            return { fail: (r && r.message) || "Upload failed — please try again." }; }
          parts.push({ partNumber: i + 1, etag: r.etag });
          pctShow(Math.min(f.size, base + CH));
        }
        st.upPct = null;
        st.upNote = "Finishing upload — almost there…";
        stripText(st.upNote, false);
        st.zoneMsg = "Finishing upload — almost there…";
        if (st.ownZone) st.ownZone();
        var done = await fetch(API + "/api/own-done", { method: "POST", headers: jh,
          body: JSON.stringify({ key: init.key, uploadId: init.uploadId, parts: parts }) })
          .then(function (x) { return x.json(); }).catch(function () { return { ok: false }; });
        if (!done.ok) return { fail: done.message || "Upload failed — please try again." };
        return { ref: init.ref, url: API + done.url };
      }
      // cart/checkout thumbnail (2026-07-24, white-square root fix): Shopify cannot
      // ingest the raw print master as a variant image (500 MB, HEIC, 20 MP+ JPEG all
      // refused → white square in cart). The client already decodes every accepted
      // file for the preview, so render a small JPEG here and store it next to the
      // raw file; the worker attaches THIS to the cart line, never the raw file.
      async function thumbUp(ref, img) {
        try {
          if (!ref || !img) return null;
          var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
          if (!w || !h) return null;
          var s = Math.min(1, 1000 / Math.max(w, h));
          var c = document.createElement("canvas");
          c.width = Math.max(1, Math.round(w * s)); c.height = Math.max(1, Math.round(h * s));
          c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
          var blob = await new Promise(function (res) { c.toBlob(res, "image/jpeg", 0.82); });
          if (!blob) return null;
          var r = await fetch(API + "/api/own-thumb?ref=" + encodeURIComponent(ref),
            { method: "POST", body: blob }).then(function (x) { return x.json(); });
          return r && r.ok ? API + r.url : null;
        } catch (e) { return null; }
      }
      artInp.onchange = async function () {
        var f = artInp.files[0]; if (!f) return;
        // INSTANT feedback the moment a file is picked — a big file used to sit
        // silent for seconds while decoding (Summer 2026-07-30)
        st.upPiece = 0; st.upName = f.name;   // hub rows key off this (sets)
        st.zoneMsg = "Reading your file…"; if (st.ownZone) st.ownZone();
        if (st.ownRowMsg) st.ownRowMsg(0, null);
        var ext = (String(f.name).split(".").pop() || "").toLowerCase();
        if (ext === "jpeg") ext = "jpg";
        // trust the file's actual bytes over its name — renamed exports and
        // AI-generated files often carry the wrong extension (Summer 2026-07-24)
        try {
          var hd = new Uint8Array(await f.slice(0, 16).arrayBuffer());
          var ascAt = function (o, s2) { for (var k2 = 0; k2 < s2.length; k2++)
            if (hd[o + k2] !== s2.charCodeAt(k2)) return false; return true; };
          if (hd[0] === 0xFF && hd[1] === 0xD8) ext = "jpg";
          else if (hd[0] === 0x89 && ascAt(1, "PNG")) ext = "png";
          else if (ascAt(0, "RIFF") && ascAt(8, "WEBP")) ext = "webp";
          else if (ascAt(4, "ftyp")) ext = "heic";
        } catch (eSn) {}
        var OKX = { jpg: 1, png: 1, webp: 1 };
        if (ext === "heic" || ext === "heif") { var mH = "Email HEIC files to summer@wallliberation.com.au — we will handle it by hand.";
          st.zoneMsg = null; st.upPiece = null; st.upName = null; if (st.ownZone) st.ownZone();
          if (st.ownRowMsg) st.ownRowMsg(0, mH); else stripText(mH, !!st.ownName); return; }
        if (!OKX[ext]) { var m1 = "JPEG, PNG or WebP please — export your file as one of those and upload again.";
          st.zoneMsg = null; st.upPiece = null; st.upName = null; if (st.ownZone) st.ownZone();
          if (st.ownRowMsg) st.ownRowMsg(0, m1); else stripText(m1, !!st.ownName); return; }
        if (f.size > 500 * 1048576) { var m2 = "Files up to 500 MB — email larger ones to summer@wallliberation.com.au.";
          st.zoneMsg = null; st.upPiece = null; st.upName = null; if (st.ownZone) st.ownZone();
          if (st.ownRowMsg) st.ownRowMsg(0, m2); else stripText(m2, !!st.ownName); return; }
        clog("own-pick", { kb: Math.round(f.size / 1024), ext: ext });
        // the preview drives sizing and the wall — a file the browser cannot
        // display is rejected outright (Summer 2026-07-24)
        var burl = URL.createObjectURL(f);
        var dec = await new Promise(function (res) {
          var im = new Image();
          im.onload = function () { res(im); }; im.onerror = function () { res(null); };
          im.src = burl; });
        if (!dec) { URL.revokeObjectURL(burl);
          var m3 = "Your browser can't display this file — export it as JPEG or PNG and upload that.";
          st.zoneMsg = null; st.upPiece = null; st.upName = null; if (st.ownZone) st.ownZone();
          if (st.ownRowMsg) st.ownRowMsg(0, m3); else stripText(m3, !!st.ownName);
          return; }
        st.ownName = f.name; st.ownRef = null; st.ownUrl = null; st.ownThumb = null;
        st.sample = false;                        // the real file replaces the trial
        st.upBusy++; if (st.ownGate) st.ownGate();
        st.zoneMsg = "Uploading your file — please keep this page open…";
        st.upNote = "Uploading your file — the full original, untouched…";
        if (st.ownZone) st.ownZone();
        stripText(st.upNote, false);
        st.artBase = dec; st.art = dec; st.p1Art = dec; st.active = 0;
        st.ownPx = { w: dec.naturalWidth, h: dec.naturalHeight };
        st.aspect = st.ownPx.w / st.ownPx.h;
        if (!st.ratioUser && st.ownApplyRatio) st.ownApplyRatio(0);
        if (st.ownShowOverlay) st.ownShowOverlay();
        drawAll();
        var up = await chunkUpload(f, ext);
        if (up && up.ref) { st.ownRef = up.ref; st.ownUrl = up.url;
          st.ownThumb = await thumbUp(up.ref, dec);
          // one upload, both previews (Summer 2026-08-23): tell the enhance
          // widget about the file so it shows there too — it queues an
          // enhancement only when the customer clicks, never automatically.
          try {
            window.__wlEnhOwn = { ref: up.ref, thumb: st.ownThumb };  // heartbeat re-sends (iframe may load late)
            // this file replaces whatever was here before, so any enhancement
            // ref carried over from an earlier image is stale — drop it and
            // open the gate for a ref raised against THIS upload (2026-08-26)
            if (!st.enhFromQuery) st.enhRef = null;
            st.enhSeeded = true;
            document.querySelectorAll('iframe[src*="enhance-widget"]').forEach(function (f2) {
              if (f2.contentWindow) f2.contentWindow.postMessage(
                { wlEnhOwn: window.__wlEnhOwn }, "*");
            });
          } catch (e9) {}
          // pre-attach the cart image NOW so Shopify has it processed long
          // before add-to-cart (2026-07-30 — cart icons appeared 10-20s late)
          st.ownImgId = null;
          fetch(API + "/api/own-preattach", { method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify({ ref: up.ref }) })
            .then(function (x) { return x.json(); })
            .then(function (rp) { if (rp && rp.ok) st.ownImgId = rp.image_id; })
            .catch(function () {});
          if (st.ownRowMsg) st.ownRowMsg(0, null); }
        else if (st.ownRowMsg) st.ownRowMsg(0, (up && up.fail) || "Upload failed — please try again.");
        st.upBusy = Math.max(0, st.upBusy - 1);
        st.zoneMsg = null; st.upNote = null; st.upPct = null;
        st.upPiece = null; st.upName = null;
        dpiNote();
        if (st.ownAutoEnh) st.ownAutoEnh();
        if (st.ownPieceRefresh) st.ownPieceRefresh();
        if (st.ownBulkTotal) st.ownBulkTotal();
        if (st.ownGate) st.ownGate();
        if (st.ownRoomBtns) st.ownRoomBtns();
      };

      // ---- the button ON the wall ----
      var upOverlay = document.createElement("div");
      upOverlay.className = "wl-upov";
      upOverlay.style.cssText = "position:absolute;inset:0;display:flex;flex-direction:column;" +
        "align-items:center;justify-content:flex-start;padding-top:14%;pointer-events:none;z-index:5";
      upOverlay.innerHTML =
        '<div class="wlupnote" style="font:12.5px Helvetica;color:#4a4a44;background:rgba(255,255,255,.88);' +
        'padding:8px 14px;border-radius:2px;max-width:84%;text-align:center;line-height:1.5">' +
        'Your image will appear here.<br>' +
        '<span style="font-size:11px">' +
        '<a class="wl-sample" style="pointer-events:auto;cursor:pointer;text-decoration:underline;text-underline-offset:2px;color:inherit">or try a sample image</a></span></div>';
      upOverlay.addEventListener("click", function (ev) {
        if (ev.target && ev.target.classList.contains("wl-sample")) {
          ev.preventDefault(); ev.stopPropagation();
          if (st.ownSample) st.ownSample(); } });
      setTimeout(function () {
        var cvw = wall.querySelector(".cvw");
        if (cvw) { cvw.style.position = "relative"; cvw.appendChild(upOverlay);
          cvw.appendChild(fileLine); }
      }, 0);
      st.ownShowOverlay = function () {
        if (st.art || st.tab !== "tpl") { upOverlay.style.display = "none"; return; }
        upOverlay.style.display = "flex";
        var nt = upOverlay.querySelector(".wlupnote");
        var inf = st.ownActiveInfo ? st.ownActiveInfo() : { name: st.ownName };
        nt.innerHTML = inf && inf.name
          ? "This format can't be displayed in the preview \u2014 your file is received, and we check every file before printing."
          : 'Your image will appear here.<br>' +
            '<span style="font-size:11px">' +
            '<a class="wl-sample" style="pointer-events:auto;cursor:pointer;text-decoration:underline;text-underline-offset:2px;color:inherit">or try a sample image</a></span>';
      };

      // ---- extras AFTER the framing options (kit row re-anchors here via reseat) ----
      var enhRow = document.createElement("div");
      // wl-enhrow (2026-08-24) is the intl guard's exemption hook: every other
      // .wl-addonrow is hidden outside AU/NZ, this one is not — the enhancement is
      // a digital service that sells worldwide, and the .com description already
      // tells overseas customers to tick it. See wl_intl_build.py GUARD_SNIPPET.
      enhRow.className = "wlc4 body wl-addonrow wl-enhrow";
      enhRow.innerHTML = '<label style="cursor:pointer;display:flex;align-items:center;gap:6px">' +
        '<input type="checkbox" class="wlenh" style="width:15px;height:15px;flex:none"> ' +
        // Summer 2026-08-24: the label says what the customer GETS — the file is
        // rebuilt and sent to them to approve before anything prints. No link on
        // the label (her call): the ? note carries the explanation instead.
        // prices through money() so an overseas visitor never sees A$ — this row
        // is shown outside Australia since 2026-08-24
        '<span>Enhance my image &amp; send me the full preview (+' +
        money(5, true) + ' <s style="color:#8a8a8a">' + money(19, true) + '</s>) ' +
        '<span class="wlhelpE" tabindex="0" style="display:inline-flex;align-items:center;justify-content:center;' +
        'width:15px;height:15px;border:1px solid #8a8a8a;border-radius:50%;font-size:10px;color:#6b6b6b;cursor:help">?</span></span></label>' +
        '<div class="wlenote nt" style="display:none;margin:3px 0 0 21px">One ' + money(5, true) + ' covers every image in your order. ' +
        'We rebuild each file into a 300 dpi print master, ready to print up to 3 metres, and you review the result before we print. ' +
        'If we recommend the enhancement, it\'s worth taking.</div>';
      (function () { var h = enhRow.querySelector(".wlhelpE"), n0 = enhRow.querySelector(".wlenote");
        h.onclick = function (e) { e.preventDefault(); e.stopPropagation();
          n0.style.display = n0.style.display === "none" ? "" : "none"; }; })();
      if (frFs) (frFs.closest(".product-info__block-item") || frFs).insertAdjacentElement("afterend", enhRow);
      else holder.appendChild(enhRow);
      (function () { var wn = document.createElement("div");
        wn.className = "wlenhwarn nt";
        wn.style.cssText = "display:none;margin:2px 0 0 21px;color:#8a2f2f;font-weight:600";
        enhRow.appendChild(wn); })();
      enhRow.querySelector(".wlenh").onchange = function () {
        st.enh = this.checked;
        if (!this.checked) st.enhDismissed = true;
        price(); };
      // "Quality-check my image" checkbox REMOVED 2026-08-24 (Summer's call).
      // st.qc stays wired: designState() still writes it, the cart stamp at
      // "Quality check" still reads it, and sj-print still holds an order that
      // carries the property — so old ?wld= permalinks and old orders keep
      // working. Nothing sets it true any more, so no NEW order is ever held.
      st.qc = false;

      // ---- SIZE: Standard / Custom radio pair (theme W/H grids hidden) ----
      // v4 (Summer 2026-07-24): pieces selector gets its OWN heading ABOVE the Size
      // heading; every piece is ONE compact line — [thumb] Standard/Custom toggle
      // sharing the same size boxes, Upload/Replace button inline, file info under.
      function pieceMarkup(idx) {
        var g = "wlsz" + idx;
        // COMPACT rows (Summer 2026-07-30): number · tick · size controls ·
        // replace. Thumbnails, names and prices live in the white file hub above.
        return '<div class="wlpc" data-i="' + idx + '" style="margin-top:' + (idx ? 10 : 0) + 'px">' +
          // ONE line (Summer 2026-08-24): Standard | Custom | W x H | Fix ratio.
          // The word "size" is gone from both buttons and the Original/Flexible
          // ratio PAIR is now the single .wlfixr checkbox at the end of the row.
          // Widths are measured, not guessed: this row is 435px of 456 on a
          // laptop and 329px of 335 on a 375px phone.
          '<div class="pcrow" style="display:flex;align-items:center;gap:5px;flex-wrap:wrap">' +
          '<b class="pcnum" style="display:none;min-width:13px">' + (idx + 1) + ".</b>" +
          '<button type="button" class="wlopt wlszstd on">Standard</button>' +
          '<button type="button" class="wlopt wlszcus">Custom</button>' +
          '<span class="wlstdpanel" style="display:flex;gap:3px;align-items:center">' +
          '<select class="wlselw"></select> \u00d7 ' +
          '<select class="wlselh"></select>' +
          // With Fix ratio ON the height is DERIVED, so it is shown as a read-only
          // box instead of a dropdown you cannot really choose from (Summer
          // 2026-08-24: "only show any size when fix ratio is not on").
          // .wlselh stays the source of truth — stdChanged/clickHidden/orderDims
          // all read it — and .wlhro only mirrors it.
          '<span class="wlhro" style="display:none" aria-hidden="true"></span></span>' +
          '<span class="wlcuspanel" style="display:none;gap:3px;align-items:center">' +
          '<input class="wlcw2" inputmode="numeric" placeholder="W"> \u00d7 ' +
          '<input class="wlch2" inputmode="numeric" placeholder="H"></span>' +
          '<label class="wlfixr" style="display:inline-flex;align-items:center;gap:5px;cursor:pointer;white-space:nowrap">' +
          '<input type="checkbox" class="wlfixrb" checked style="width:14px;height:14px;flex:none;margin:0">' +
          '<span>Fix ratio</span></label></div>' +
          '<div class="pcinfo nt" style="display:none;margin:3px 0 0 2px"></div>' +
          '<div class="pcerr nt" style="color:#8a2f2f;display:none;margin:3px 0 0"></div></div>';
      }
      var pcsBox = document.createElement("div");
      pcsBox.className = "wlc4";
      // 2026-07-30: pieces moved BELOW size and collapsed to one line \u2014 it was
      // the first block on the page, putting the rarest decision before upload
      // and size. One click on the line = a 2-piece set, tabs appear for more.
      // Number of pieces shows STRAIGHT AWAY, first block above the uploader \u2014
      // no collapsed "+ add more" line, no explainer sentence (Summer 2026-07-31)
      pcsBox.innerHTML =
        '<div class="wl-pcbody">' +
        '<p class="wlsec" style="margin-bottom:10px">Number of pieces</p>' +
        '<div class="wltabs" style="display:flex;gap:8px;flex-wrap:wrap;align-items:center">' +
        [[1, "1", ""], [2, "2", "10"], [3, "3", "15"]].map(function (t) {
          var off = t[2] ? ' <small class="toff" style="color:#425934">(' + t[2] + "% off)</small>" : "";
          return '<button type="button" class="wltab' + (t[0] === 1 ? " on" : "") + '" data-n="' + t[0] + '">' +
            t[1] + off + "</button>"; }).join("") +
        '<button type="button" class="wltab" data-n="4">' +
        '<span class="t4l">4+</span> <small class="toff" style="color:#425934">(20% off)</small>' +
        '<span class="t4c" style="display:inline-flex;flex-direction:column;line-height:1;font-size:9px">' +
        '<span class="t4up" style="padding:1px 4px">\u25b2</span><span class="t4dn" style="padding:1px 4px">\u25bc</span></span></button>' +
        "</div></div>";
      var sizeBox = document.createElement("div");
      sizeBox.className = "wlc4";
      sizeBox.innerHTML =
        '<p class="wlsec" style="margin-bottom:10px">Size \u2014 width \u00d7 height, cm</p>' +
        // the "Original ratio" / "Flexible ratio" button pair was RETIRED
        // 2026-08-24 (Summer): it was one boolean wearing two buttons. The
        // .wlfixr checkbox inside each piece row carries it now.
        '<div class="wlpieces2">' + pieceMarkup(0) + "</div>" +
        '<div class="wl-lowres nt" style="display:none;margin:6px 0 0;color:#8a6d3b;font-weight:600">' +
        'We recommend the image enhancement below.</div>' +
        '<div class="wlsave nt" style="display:none;margin:6px 0 0;color:#425934;font-weight:600"></div>' +
        '<div class="wlseterr nt" style="color:#8a6d3b;display:none;margin:6px 0 0"></div>';
      // hide the W/H FIELDSETS only — the theme puts width + height + framing in ONE
      // block-item, so hiding the block buried the framing options with it. Hide via
      // CSS and keep sizeBox OUTSIDE the block: the theme re-renders the fieldsets
      // (and anything injected between them) on every variant change.
      var wOptName = wFsOwn && wFsOwn.getAttribute("data-option-name"),
          hOptName = hFsOwn && hFsOwn.getAttribute("data-option-name");
      var hideSel = [wOptName, hOptName].filter(Boolean).map(function (n) {
        return 'fieldset[data-option-name="' + n + '"]'; }).join(",");
      var ownCss = document.createElement("style");
      ownCss.textContent =
        (hideSel ? hideSel + "{display:none!important}" : "") +
        // tighter page top (Summer 2026-07-23)
        ".shopify-section--main-product .section-spacing{padding-top:12px!important}" +
        // file strip ON the preview image, bottom, readable background
        ".wl-filestrip{position:absolute;left:0;right:0;bottom:0;z-index:6;display:none;" +
        "background:rgba(255,255,255,.88);padding:6px 10px;font-size:11.5px;line-height:1.45;color:#2b2b2b}" +
        ".wl-filestrip .wl-replace{margin-left:8px;text-decoration:underline;text-underline-offset:2px;color:inherit;white-space:nowrap}" +
        // standard-size dropdowns match the custom W/H boxes. appearance:none —
        // iOS Safari otherwise paints selects as round pill buttons (2026-07-30);
        // that kills the native caret, so a small SVG arrow is drawn instead.
        ".wlstdpanel select{width:74px;padding:8px;border:1px solid var(--wlbd,#ccc);font-size:inherit;" +
        "-webkit-appearance:none!important;appearance:none!important;border-radius:0!important;padding-right:18px!important;" +
        "background:#fff url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22%20width=%228%22%20height=%225%22%3E%3Cpath%20d=%22M0%200l4%205%204-5z%22%20fill=%22%236b6b6b%22/%3E%3C/svg%3E') no-repeat right 6px center!important}" +
        // custom W/H boxes: same square treatment on iOS
        ".wlcuspanel input{-webkit-appearance:none!important;appearance:none!important;border-radius:0!important}" +
        // FAQ: two columns on desktop — the theme's own TOC rail (sticky) + questions
        "@media(min-width:1000px){.faq>.faq__toc{display:grid!important;position:sticky;top:96px;align-self:flex-start}.faq{gap:56px}}" +
        // the upload zone (2026-07-30): dashed drop target, olive on hover/drag,
        // solid quiet border once a file is in
        // EMPTY state (Summer 2026-08-24): "button on the left, JPEG/PNG/WebP on
        // the same line, no bg colour". The dashed box is gone at rest — it only
        // comes back while a file is being dragged over (see .drag below), so the
        // drop target is still announced at the one moment it matters.
        ".wl-upzone .wl-upzbtn{display:flex;align-items:center;gap:10px;width:100%;box-sizing:border-box;" +
        "text-align:left;cursor:pointer;background:none;border:0;padding:0;font-family:inherit}" +
        ".wl-upzone .wl-upzbtn:hover .wl-upzface{background:#35482a!important;border-color:#35482a!important}" +
        ".wl-upzone.drag .wl-upzbtn{outline:1.5px dashed var(--wlsysbg,#425934);outline-offset:6px}" +
        ".wl-upzone.has .wl-upzbtn{border:1px solid #d8d3cb;padding:10px 14px}" +
        ".wl-upzone .wl-upzti{display:block;font-weight:600;font-size:.9375rem;color:#1b1b1b;margin:0 0 3px}" +
        ".wl-upzone.has .wl-upzti{margin:0}" +
        ".wl-upzone .wl-upzsub{display:block;line-height:1.3}" +
        ".wl-upzone .wl-upzst{display:block;margin-top:2px}" +
        // add-to-cart nudge flash (disabled button clicked)
        ".wl-flash{outline:2px solid var(--wlsysbg,#425934)!important;outline-offset:3px}" +
        // STICKY buy panel (desktop): rides beside the long left column so the
        // cart button never scrolls away — and no dead grey half either
        "@media(min-width:750px){safe-sticky.product-info{position:sticky!important;top:16px;align-self:flex-start}}" +
        // phones: the add-on labels must WRAP (they clipped at 390px), and the
        // pieces tabs shrink so 1/2/3/4+ hold one row
        "@media(max-width:480px){" +
        ".wlc4 label{white-space:normal!important}" +
        ".wltabs{gap:6px!important}" +
        // the four tabs still have to hold ONE row at 375px — specificity has to
        // beat .product-info .wlc4 .wltab above, so it is spelled out in full
        ".product-info .wlc4 .wltabs .wltab{padding:7px 9px!important;font-size:13px;gap:3px}" +
        "}" +
        // ---- panel readability pass (Summer 2026-07-30) ----
        // 2026-08-23 (Summer, "get rid of all the grey"): the grey panel fill is
        // GONE — this page now reads like the artwork PDPs, on the plain page
        // background. Padding stays so the content keeps its inset.
        "safe-sticky.product-info{padding:20px!important;box-sizing:border-box}" +
        // phones give the panel the page gutter and nothing more (Summer
        // 2026-08-24) — the 14px side inset on top of the page's own 20px made
        // this the narrowest column on the site. Top/bottom inset stays.
        "@media(max-width:749px){safe-sticky.product-info{padding:14px 0!important}}" +
        // headings: the \"SEE IT ON YOUR WALL\" typography (11px olive uppercase)
        // ON a grey bar, so each section reads as a visual segment (Summer
        // 2026-07-30 — bar back, hairline off inside the bars)
        "fieldset[data-option-name*=\"fram\"] legend{display:flex!important;align-items:center;width:auto;box-sizing:border-box;" +
        "font-family:var(--wl-sans,Montserrat,sans-serif)!important;font-size:11px!important;font-weight:600!important;" +
        "letter-spacing:.16em!important;text-transform:uppercase!important;color:#425934!important;" +
        "background:none!important;padding:0!important;margin:0 0 10px!important;line-height:1.4!important}" +
        ".product-info .wlc4 .wlsec{background:none!important;padding:0!important;" +
        "width:100%;box-sizing:border-box}" +
        "fieldset[data-option-name*=\"fram\"] .variant-picker__option-info{display:block}" +
        // ONE text colour in the panel: BLACK. (Theme rules kept greying pockets
        // of it at higher specificity — enforced here. Accents that stay
        // coloured do so via inline styles: red gate note, olive headings.)
        ".product-info .wlc4,.product-info .wlc4 .body,.product-info .wlc4 .nt,.product-info .wlc4 label" +
        "{color:#1b1b1b!important}" +
        ".wlc4 .nt{font-size:12.5px}" +
        // consistent breathing room on every control row — specificity must beat
        // the site-wide compact-spacing pass in wl-overrides.css (margin:2px)
        ".product-info .wlc4{margin:16px 0!important}" +
        // option BUTTONS — one style everywhere, matching the pieces tabs
        // ONE button design across the site (Summer 2026-08-24: "use the button
        // design of this page"). Read off the live artwork PDP size chip:
        //   unselected  1px #ddd, white
        //   selected    #f0f0ee fill, 1.5px #425934, #425934 bold
        // The solid-olive selected state that used to live here was this page's
        // own invention and is gone. Unselected TEXT stays #1b1b1b, not the
        // artwork chip's green — the 2026-07-30 "one text colour in the panel:
        // BLACK" rule below is enforced with !important and wins anyway.
        ".wlc4 .wlopt{border:1px solid #ddd;background:#fff;color:#1b1b1b;" + WLBTN +
        "cursor:pointer;font-family:inherit;font-size:12.5px;line-height:1.3}" +
        "@media(max-width:749px){.wlfinb{padding:5px 9px !important;height:30px !important;min-height:30px !important;line-height:1.2 !important;min-width:0;font-size:12.5px !important}}" +
        ".wlc4 .wlopt:hover{border-color:#425934}" +
        // pieces tabs are the same button as every other option (Summer
        // 2026-08-24: "all button same height and padding")
        ".product-info .wlc4 .wltab{" + WLBTN + "height:40px;border:1px solid #ddd;background:#fff;cursor:pointer;font-family:inherit;color:#1b1b1b}" +
        ".product-info .wlc4 .wltab.on{background:#f0f0ee;border:1.5px solid #425934;font-weight:700}" +
        ".product-info .wlc4 .wltab.on,.product-info .wlc4 .wltab.on .toff{color:#425934!important}" +
        ".product-info .wlc4 .wltab .toff{color:#425934}" +
        ".product-info .wlc4 .wltab:hover{border-color:#425934}" +
        // …and the typed/dropdown fields match that height exactly
        ".product-info .wlc4 input.wlborder,.product-info .wlc4 .wlstdpanel select," +
        ".product-info .wlc4 .wlcuspanel input{height:40px!important;box-sizing:border-box!important;" +
        "font-size:12.5px!important;padding:6px 8px!important;border:1px solid #ddd}" +
        // 52px still shows "600" with room for the caret; the inline widths that
        // used to live in pieceMarkup are gone so one rule governs both panels
        ".product-info .wlc4 .wlstdpanel select{width:52px!important;padding:6px 15px 6px 6px!important}" +
        // the derived height: same box as the select it replaces, no caret, and
        // visibly not editable (Summer 2026-08-24)
        ".product-info .wlc4 .wlhro{width:52px;height:40px;box-sizing:border-box;" +
        "align-items:center;justify-content:center;border:1px solid #ddd;background:#f6f4ef;" +
        "color:#1b1b1b;font-size:12.5px;line-height:1.3;font-family:inherit;cursor:default}" +
        ".product-info .wlc4 .wlcuspanel input{width:52px!important}" +
        ".wlc4 .wlopt.on{background:#f0f0ee;border:1.5px solid #425934;font-weight:700}" +
        // the panel-wide black-text rule has to lose to the selected state, on
        // both <button> and <label> options (edge / border chips are labels)
        ".product-info .wlc4 .wlopt.on,.product-info .wlc4 .wlopt.on span{color:#425934!important}" +
        // framing tiles fill the width; white, same as the artwork PDPs.
        // GRID, not a nowrap flex line (Summer 2026-08-23): the Australia-
        // delivery note (.wl-audel) is a 6th child of this row, and nowrap
        // squeezed the five tiles to 17px to fit it beside them. Grid gives
        // the tiles five equal columns and lets the note span 2/-1 on its
        // own line, exactly like the artwork pages.
        "fieldset[data-option-name*=\"fram\"] .variant-picker__option-values{display:grid!important;grid-template-columns:repeat(5,1fr);gap:8px;width:100%}" +
        "fieldset[data-option-name*=\"fram\"] .block-swatch[data-value-handle][data-value-handle]{" +
        "flex:1 1 0;width:auto!important;max-width:none!important;padding:76px 4px 6px!important;" +
        "background-size:72px 72px!important}" +
        "fieldset[data-option-name*=\"fram\"] input:checked+label.block-swatch::after{top:56px;right:8px}" +
        "fieldset[data-option-name*=\"fram\"] .block-swatch .wlfrcap{font-size:11.5px;color:#1b1b1b}" +
        // Summer 2026-07-31: all FIVE framing tiles on ONE line on a phone
        // (was flex-basis 30% = a 3+2 wrap). ~60px tiles, smaller icons/caps.
        "@media(max-width:480px){" +
        "fieldset[data-option-name*=\"fram\"] .variant-picker__option-values{display:grid!important;grid-template-columns:repeat(5,1fr);gap:4px}" +
        "fieldset[data-option-name*=\"fram\"] .block-swatch[data-value-handle][data-value-handle]{flex:1 1 0;min-width:0;padding:40px 1px 3px!important;background-size:36px 36px!important;background-position:top 3px center!important}" +
        "fieldset[data-option-name*=\"fram\"] input:checked+label.block-swatch::after{top:24px;right:3px;width:14px;height:14px;line-height:14px;font-size:10px}" +
        "fieldset[data-option-name*=\"fram\"] .block-swatch .wlfrcap{font-size:9px;line-height:1.25}}" +
        // add-on rows share the SAME 10px line rhythm as the framing lines
        ".product-info .wlc4.wl-addonrow{margin:16px 0!important}" +
        // the aftercare block bleeds to the panel edges (no wash — 2026-08-23)
        ".wl-aftersec{margin:16px -20px -20px;padding:16px 20px 20px;box-sizing:border-box}" +
        // the aftercare bleed mirrors the panel padding — side inset is 0 now
        "@media(max-width:749px){.wl-aftersec{margin:14px 0 -14px;padding:14px 0}}" +
        // Upload is the PRIMARY action on this page until a file exists, so it is
        // a solid green button (Summer 2026-08-24). DESIGN-RULES.md lists "Upload
        // your image" as Primary; it had been wearing the outline treatment since
        // 2026-07-30. Add to cart is disabled until upload, so only one solid
        // primary is ever live at a time.
        ".wl-upzone .wl-upzface{display:inline-flex;align-items:center;justify-content:center;" +
        "background:#425934!important;border:1.5px solid #425934!important;color:#fff!important;" +
        "font-weight:600!important;margin:0;flex:none;min-height:40px;box-sizing:border-box;" +
        "padding:6px 14px;line-height:1.3;font-size:12.5px}" +
        // the file name sits at body size, not headline size
        ".wl-upzone.has .wl-upzti{font-size:12.5px;font-weight:600}" +
        // upload box: thumbnail beside the file name once a file is in — kept at
        // the image's own proportions
        ".wl-upzone .wl-upzthumb{height:44px;border:1px solid #d8d3cb;overflow:hidden;flex:none}" +
        ".wl-upzone.has .wl-upzbtn{display:grid!important;grid-template-columns:auto 1fr;gap:2px 10px;align-items:center;text-align:left}" +
        ".wl-upzone.has .wl-upzthumb{grid-row:1/3}" +
        // hub mode (sets): plain block, the piece list lays itself out
        ".wl-upzone.hub .wl-upzbtn{display:block!important;cursor:default}" +
        // price chips: wrap when the column is narrow — nowrap overflowed the
        // buy box and gave the page a horizontal scrollbar (audit 2026-08-01 r3)
        "@media(min-width:750px){.wlship{display:flex;flex-wrap:wrap;gap:4px;align-items:center}" +
        ".wlship .wlchip{font-size:10px;padding:2px 5px;margin:0;flex:none}}" +
        // ---- PHONE: the QUIET 30px control (Summer 2026-08-24) --------------
        // MUST BE LAST in this stylesheet. An earlier copy of these rules sat
        // above the 40px desktop rules and lost the cascade even with
        // !important — equal specificity, so source order decided it.
        // 30 comes from wl_tokens.css ALLOWED-BUTTON-HEIGHTS, which is what
        // wl_doctor checks. NOTE: DESIGN-RULES.md prints 32 for the same Quiet
        // control — the two documents disagree and Summer has been asked to
        // settle it. Conform to the tokens file; never widen the allowed set to
        // fit a number this file picked.
        // Measured at 375px: size row 329px of the 335px the panel now gives.
        "@media(max-width:480px){" +
        ".product-info .wlc4 .wlopt,.product-info .wlc4 .wltab{min-height:30px!important;height:auto!important;" +
        // 6px, not 7: at 7 the 14.95px line box plus borders cleared the 30px floor,
        // so every button computed 31-32 and none of them matched. At 6 the floor binds.
        "padding:6px 8px!important;font-size:11.5px!important}" +
        // the four tabs must hold ONE row at 375px: the shared 7px inner flex gap
        // costs ~16px across them, so it drops to 3px here (proved 2026-08-24)
        ".product-info .wlc4 .wltabs .wltab{height:30px!important;padding:6px 9px!important;" +
        "font-size:12px!important;gap:3px!important}" +
        ".product-info .wlc4 .wltabs .wltab .t4c{font-size:8px}" +
        ".product-info .wlc4 input.wlborder,.product-info .wlc4 .wlstdpanel select," +
        ".product-info .wlc4 .wlcuspanel input{height:30px!important;font-size:11.5px!important}" +
        ".product-info .wlc4 .wlstdpanel select{width:48px!important;padding:5px 15px 5px 6px!important}" +
        ".product-info .wlc4 .wlhro{width:48px!important;height:30px!important;font-size:11.5px!important}" +
        ".product-info .wlc4 .wlcuspanel input{width:48px!important;padding:5px 6px!important}" +
        ".product-info .wlc4 .wlfixr{font-size:11.5px;white-space:nowrap}" +
        ".product-info .wlc4 .pcrow{gap:4px!important}" +
        ".product-info .wlc4.wl-edgerow > div{gap:6px!important}" +
        // the edge chips carry a 20px swatch; at the 30px phone height that plus
        // 7px padding each side overflows to 37px, leaving them the only buttons
        // on the page taller than the rest. The swatch steps down with them.
        ".product-info .wlc4 .wlopt svg{height:14px!important}" +
        ".wl-upzone .wl-upzface{min-height:30px!important;padding:6px 10px!important;font-size:11.5px!important}" +
        ".wl-upzone .wl-upzbtn{gap:8px!important}" +
        "}";
      document.head.appendChild(ownCss);
      // ---- the upload ZONE — first block of the panel (2026-07-30) ----
      // Upload is the heart of this page but lived as a small black button in
      // the size row. Order is now Upload → Size → (add pieces) → Framing.
      var upZone = document.createElement("div");
      upZone.className = "wlc4 wl-upzone";
      upZone.innerHTML =
        '<button type="button" class="wl-upzbtn">' +
        '<span class="wl-upzthumb" style="display:none"></span>' +
        '<span class="wl-upzface btn">Upload your image</span>' +
        '<span class="wl-upzti" style="display:none"></span>' +
        '<span class="wl-upzsub nt">JPEG, PNG, WebP \u00b7 500 MB</span>' +
        '<span class="wl-upzst nt" style="display:none"></span></button>' +
        // set feedback lives HERE with the files, not under size (Summer 2026-07-31)
        '<div class="wl-lowres nt" style="display:none;margin:6px 0 0;color:#8a6d3b;font-weight:600">' +
        'We recommend the image enhancement below.</div>' +
        '<div class="wlsave nt" style="display:none;margin:6px 0 0;color:#425934;font-weight:600"></div>';
      upZone.querySelector(".wl-upzbtn").onclick = function (ev) {
        if (ev.target && ev.target.classList.contains("wl-sample")) {
          ev.preventDefault(); ev.stopPropagation();
          if (st.ownSample) st.ownSample(); return; }
        if (st.bulkN > 1) return;   // hub mode: each row owns its upload button
        if (st.upBusy > 0 || st.upPiece != null) return; startUpload(); };
      ["dragover", "dragenter"].forEach(function (ev) {
        upZone.addEventListener(ev, function (e) { e.preventDefault(); upZone.classList.add("drag"); }); });
      ["dragleave", "drop"].forEach(function (ev) {
        upZone.addEventListener(ev, function (e) {
          if (ev === "drop") { e.preventDefault();
            var fs = e.dataTransfer && e.dataTransfer.files;
            if (fs && fs.length) { artInp.files = fs; artInp.dispatchEvent(new Event("change")); } }
          upZone.classList.remove("drag"); }); });
      function upZoneRefresh() {
        var ti = upZone.querySelector(".wl-upzti"), sub = upZone.querySelector(".wl-upzsub"),
            stl = upZone.querySelector(".wl-upzst"), th = upZone.querySelector(".wl-upzthumb"),
            face = upZone.querySelector(".wl-upzface");
        var inf = infoOfPiece(0);
        var pieceTag = st.bulkN > 1 ? " — piece 1" : "";
        // busy state wins over everything — the customer must SEE the upload.
        // SETS are excluded (Summer 2026-07-31: "not just the first image"):
        // the ⏳ takeover used to REPLACE the whole file hub during piece
        // uploads — progress now renders on the uploading row itself below.
        if (st.zoneMsg && st.bulkN <= 1) {
          if (face) face.style.display = "none";
          ti.style.display = ""; ti.textContent = "⏳ " + st.zoneMsg;
          sub.style.display = "none";
          // a moving bar under the % (Summer 2026-07-31) — existing palette only
          if (st.upPct != null) {
            stl.style.display = "block"; stl.style.color = "#1b1b1b";
            stl.innerHTML = '<span style="display:block;height:4px;background:#d8d3cb;margin-top:6px">' +
              '<span style="display:block;height:4px;width:' + st.upPct +
              '%;background:#425934"></span></span>';
          } else stl.style.display = "none";
          upZone.classList.add("has");
          return;
        }
        // SETS: the white box is the FILE HUB — one line per piece with
        // thumbnail, number, name, pixels, quality and price after discount
        // (Summer 2026-07-30). Size rows below stay compact.
        if (st.bulkN > 1) {
          if (face) face.style.display = "none";
          ti.style.display = "none"; sub.style.display = "none";
          if (th) th.style.display = "none";
          upZone.classList.add("has"); upZone.classList.add("hub");
          stl.style.display = "block"; stl.style.color = "#1b1b1b"; stl.innerHTML = "";
          for (var hz = 0; hz < st.bulkN; hz++) {
            var infH = infoOfPiece(hz), imH = imgOfPiece(hz), refH = fileOfPiece(hz);
            var upThis = st.upPiece === hz;   // this row's file is in flight
            var pickFor = (function (ii) { return function (ev4) {
              if (ev4) { ev4.preventDefault(); ev4.stopPropagation(); }
              if (st.upPiece != null) return;   // one upload at a time
              if (ii === 0) startUpload();
              else { var rEl = rowEl(ii); if (rEl && rEl.__pick) rEl.__pick(); }
            }; })(hz);
            // TABLE layout (Summer 2026-07-31): fixed columns — thumb box 56px |
            // number+name (ellipsis) | action button. Meta chips on row 2. Long
            // file names can never push the button around; an empty piece keeps
            // the exact same shape.
            var row = document.createElement("div");
            row.style.cssText = "display:grid;grid-template-columns:56px minmax(0,1fr) auto;" +
              "grid-column-gap:10px;grid-row-gap:3px;align-items:center;text-align:left;margin:7px 0;min-width:0";
            var tcell = document.createElement("span");
            tcell.style.cssText = "grid-row:1/3;width:56px;height:44px;display:flex;align-items:center;" +
              "justify-content:center;border:1px solid #d8d3cb;background:#fff;overflow:hidden" +
              (imH ? ";cursor:pointer" : "");
            if (imH) {
              var hc = document.createElement("canvas");
              var hs = 100 / Math.max(imH.width, imH.height);
              hc.width = Math.max(1, Math.round(imH.width * hs));
              hc.height = Math.max(1, Math.round(imH.height * hs));
              hc.getContext("2d").drawImage(imH, 0, 0, hc.width, hc.height);
              tcell.title = "Show piece " + (hz + 1) + " on the wall";
              tcell.innerHTML = '<img src="' + hc.toDataURL("image/jpeg", .8) +
                '" style="max-width:100%;max-height:100%;display:block">';
              (function (ii) { tcell.onclick = function (ev3) { ev3.stopPropagation();
                if (st.ownSelectPiece) st.ownSelectPiece(ii); }; })(hz);
            } else {
              tcell.textContent = "○"; tcell.style.color = "#c4beb2";
            }
            row.appendChild(tcell);
            var nameCell = document.createElement("span");
            nameCell.style.cssText = "min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:12.5px";
            nameCell.innerHTML = "<b>" + (hz + 1) + " · </b>";
            var nmt = document.createElement("span");
            nmt.textContent = upThis ? (st.upName || "Uploading…")
              : infH.name ? infH.name : "No image yet";
            nmt.style.cssText = (upThis || infH.name) ? "font-weight:600" : "color:#55524a";
            nameCell.appendChild(nmt);
            if (infH.name) nameCell.title = infH.name;
            row.appendChild(nameCell);
            var act = document.createElement("button");
            act.type = "button";
            if (upThis) {
              act.textContent = "Uploading…"; act.disabled = true;
              act.style.cssText = "background:#fff;border:1px solid #b9b3a6;color:#55524a;" +
                "padding:3px 10px;font-size:11.5px;font-family:inherit;min-width:88px";
            } else if (infH.name) {
              act.textContent = "Replace";
              act.style.cssText = "background:#fff;border:1px solid #b9b3a6;color:#1b1b1b;" +
                "padding:3px 10px;font-size:11.5px;cursor:pointer;font-family:inherit;min-width:88px";
            } else {
              act.textContent = "Upload file";
              act.style.cssText = "background:#fff;border:1.5px solid #425934;color:#425934;font-weight:600;" +
                "padding:3px 10px;font-size:11.5px;cursor:pointer;font-family:inherit;min-width:88px";
            }
            // another row's upload in flight: the button waits (one at a time)
            if (st.upPiece != null && !upThis) { act.disabled = true; act.style.opacity = ".55"; }
            act.onclick = pickFor;
            row.appendChild(act);
            var meta = document.createElement("span");
            meta.style.cssText = "grid-column:2/4;display:flex;align-items:center;gap:7px;flex-wrap:wrap;min-width:0";
            if (upThis) {
              // live status + moving bar ON the row — the hub never disappears
              var ust = document.createElement("span");
              ust.textContent = "⏳ " + (st.zoneMsg || "Uploading…");
              ust.style.cssText = "color:#55524a;font-size:11.5px;font-weight:600";
              meta.appendChild(ust);
              if (st.upPct != null) {
                var ubar = document.createElement("span");
                ubar.style.cssText = "flex-basis:100%;display:block;height:4px;background:#d8d3cb";
                ubar.innerHTML = '<span style="display:block;height:4px;width:' + st.upPct +
                  '%;background:#425934"></span>';
                meta.appendChild(ubar);
              }
            } else if (infH.name) {
              if (infH.px) { var pxs = document.createElement("span");
                pxs.textContent = infH.px.w + " × " + infH.px.h + " px";
                pxs.style.cssText = "color:#55524a;font-size:11.5px"; meta.appendChild(pxs); }
              var netH = pieceNet(hz);
              if (netH != null) { var prc = document.createElement("span");
                // the set discount SHOWS on each hub row: gross struck, net paid
                // (Summer 2026-07-31)
                var qH = hz === 0 ? (st.quote && st.quote.ok ? st.quote.total : null)
                                  : (pcOf(hz) || {}).quote;
                var grossH = qH != null ? Math.ceil(qH) : null;
                if (grossH != null && grossH > netH)
                  prc.innerHTML = '<s style="color:#8a8a8a;font-weight:400;margin-right:5px">' +
                    money(grossH, true) + "</s>" + money(netH, true);
                else prc.textContent = money(netH, true);
                prc.title = "This piece's price after the set discount";
                prc.style.cssText = "background:rgba(66,89,52,.12);color:#2e3c25;font-weight:700;" +
                  "padding:1px 8px;font-size:12px"; meta.appendChild(prc); }
              var vdH = refH ? verdictFor(hz) : null;
              if (vdH) { var fl = document.createElement("span");
                var badV = /enhancement|Low resolution/i.test(vdH.t);
                fl.textContent = badV ? "low resolution" : "quality ✓";
                fl.style.cssText = badV
                  ? "background:rgba(138,109,59,.16);color:#8a6d3b;font-weight:600;padding:1px 8px;font-size:11.5px"
                  : "background:rgba(66,89,52,.10);color:#425934;font-weight:600;padding:1px 8px;font-size:11.5px";
                meta.appendChild(fl); }
            } else {
              for (var sj = 0; sj < st.bulkN; sj++) {
                if (sj === hz || !fileOfPiece(sj)) continue;
                var rlk = document.createElement("a"); rlk.href = "#";
                rlk.textContent = "use piece " + (sj + 1) + "\u2019s image";
                rlk.style.cssText = "font-size:12px;color:inherit;text-decoration:underline;text-underline-offset:2px";
                (function (from, to, el2) { el2.onclick = function (ev5) {
                  ev5.preventDefault(); ev5.stopPropagation(); copyFileFrom(from, to); }; })(sj, hz, rlk);
                meta.appendChild(rlk);
              }
              if (!meta.children.length) { var hint = document.createElement("span");
                hint.textContent = "JPEG, PNG, WebP \u00b7 500 MB";
                hint.style.cssText = "color:#55524a;font-size:11.5px"; meta.appendChild(hint); }
            }
            row.appendChild(meta);
            if (st.pcErrs && st.pcErrs[hz]) {   // upload error shows HERE, by the button
              var erow = document.createElement("span");
              erow.textContent = st.pcErrs[hz];
              erow.style.cssText = "grid-column:1/4;color:#8a2f2f;font-weight:600;font-size:12px";
              row.appendChild(erow);
            }
            stl.appendChild(row);
          }
          return;
        }
        upZone.classList.remove("hub");
        if (!inf || !inf.name) {
          if (face) { face.style.display = "";
            face.textContent = "Upload your image" + pieceTag; }
          ti.style.display = "none";
          sub.style.display = ""; stl.style.display = "none";
          if (th) th.style.display = "none";
          upZone.classList.remove("has"); return;
        }
        upZone.classList.add("has");
        if (face) face.style.display = "none";
        ti.style.display = "";
        // the image thumbnail lives HERE, next to its file name — at the image's
        // own proportions, never cropped to a square (Summer 2026-07-30)
        var im0 = imgOfPiece(0);
        if (th && im0) {
          if (th.dataset.src !== inf.name) { th.dataset.src = inf.name;
            var tc = document.createElement("canvas");
            var ts2 = 88 / Math.max(im0.width, im0.height);
            tc.width = Math.max(1, Math.round(im0.width * ts2));
            tc.height = Math.max(1, Math.round(im0.height * ts2));
            tc.getContext("2d").drawImage(im0, 0, 0, tc.width, tc.height);
            var tw = Math.max(18, Math.min(78, Math.round(44 * im0.width / im0.height)));
            th.style.width = tw + "px"; th.style.height = "44px";
            th.innerHTML = '<img src="' + tc.toDataURL("image/jpeg", .8) + '" alt="" ' +
              'style="width:100%;height:100%;display:block">'; }
          th.style.display = "inline-block";
        } else if (th) th.style.display = "none";
        // the tick is EARNED: it only shows when the file has actually landed on
        // our server. A failed upload used to show "✓ name" while a red error
        // sat elsewhere — worst possible mix (Summer 2026-07-30).
        var ref0 = fileOfPiece(0);
        var uploading = st.upBusy > 0 && !ref0;
        var failed = !ref0 && !uploading;
        ti.textContent = (ref0 ? "✓ " : uploading ? "Uploading… " : "⚠ ") + inf.name + pieceTag;
        sub.style.display = "none";
        var bits = [];
        // SAY WHY IT FAILED (Summer 2026-08-24). This line was hardcoded to
        // "please try again", so a customer who had hit the daily upload cap was
        // told to do the one thing that cannot work — the server's own sentence
        // (which tells them to email the file instead) was written into st.pcErrs
        // and only ever rendered in the multi-piece hub, never here.
        if (failed) bits.push((st.pcErrs && st.pcErrs[0]) || "Upload failed — please try again.");
        else if (inf.px) bits.push(inf.px.w + " × " + inf.px.h + " px");
        else bits.push("received — we check every file before printing");
        var vd = failed ? null : verdictFor(0);
        if (vd) bits.push(vd.t);
        stl.textContent = bits.join(" · ") + "  ";
        stl.style.color = failed ? "#8a2f2f" : (vd ? vd.c : "#6b6b6b");
        var a = document.createElement("a"); a.href = "#";
        a.textContent = failed ? "Try again" : "Replace file";
        // white button, not an underlined link (Summer 2026-07-31)
        a.style.cssText = "background:#fff;border:1px solid #b9b3a6;color:#1b1b1b;" +
          "padding:3px 10px;font-size:11.5px;cursor:pointer;font-family:inherit;margin-left:8px;text-decoration:none";
        a.onclick = function (ev2) { ev2.preventDefault(); ev2.stopPropagation(); startUpload(); };
        stl.appendChild(a);
        stl.style.display = "block";
      }
      st.ownZone = upZoneRefresh;
      // one container = one reseat unit when the theme morphs the blocks
      var ownStack = document.createElement("div");
      ownStack.className = "wl-ownstack";
      // "+ Add more pieces" sits ABOVE the upload hub as a white button
      // (Summer 2026-07-31) — the old underline inside the pieces block is hidden
      // order (Summer 2026-07-31): Number of pieces → upload hub → size
      ownStack.appendChild(pcsBox); ownStack.appendChild(upZone); ownStack.appendChild(sizeBox);
      var wBlockOwn = wFsOwn && (wFsOwn.closest(".product-info__block-item") || wFsOwn);
      if (wBlockOwn) wBlockOwn.insertAdjacentElement("beforebegin", ownStack);
      else holder.appendChild(ownStack);
      st.ownSizeBox = ownStack; st.ownFsNames = { w: wOptName, h: hOptName };
      // NB 2026-07-30: a "move description to a full-width band" pass (seatBelow)
      // was REVERTED the same day — it fought reorderPdp(), which owns the
      // wall+specs+description left column (Summer's 2026-07-15 layout), and a
      // theme morph could wipe the wall entirely. Any lower-half re-layout must
      // go through reorderPdp, not around it.
      // ---- sample trial (2026-07-30): one click puts a real WL artwork on the
      // wall so the configurator demonstrates itself before any upload. Preview
      // only — add-to-cart still needs the customer's own file.
      var SAMPLE_URL = API + "/flat/92010L.jpg";   // Path of Water (Werribee Gorge 203×103) — Summer's pick 2026-07-30
      function loadSample() {
        loadImg(SAMPLE_URL).then(function (img) {
          if (!img || st.ownName) return;            // a real upload wins
          st.sample = true;
          st.artBase = img; st.art = img; st.aspect = img.width / img.height;
          st.ownPx = { w: img.width, h: img.height };   // ratio snapping works in the demo too
          // 2026-08-24: this used to re-implement the "short side 100" rule inline
          // and then call ownSetCustom() directly, which FORCES Custom mode. So the
          // 2:1 sample landed on "Custom 200x100" even though 200 and 100 are both
          // standard values. ownApplyRatio is the real rule: it tries
          // snapToStdIfExact FIRST and only falls back to Custom when the pair is
          // not on the grid — and it carries the 600 cm clamp this copy had lost.
          // st.ownPx is set on the line above, which is its only precondition.
          if (st.ownApplyRatio) st.ownApplyRatio(0);
          if (st.ownShowOverlay) st.ownShowOverlay();
          drawAll(); dpiNote();
          track("wl_sample_trial", {});
        });
      }
      st.ownSample = loadSample;
      // ---- design permalink (2026-07-30): oversize is a multi-session
      // decision. One link restores sizes, framing, finish, extras and the
      // uploaded files (their R2 refs) — nothing to re-upload.
      var FR_HANDLE = { rolled: "rolled", stretched: "stretched", natural_oak: "natural-oak",
        black_oak: "black-oak", white_oak: "white-oak" };
      function designState() {
        var d = orderDims();
        var o = { v: 1, f: st.framing, e: st.edge, b: st.border || 0, bt: st.borderType || "mirror", fin: st.finish,
          enh: st.enh ? 1 : 0, kit: st.kit ? 1 : 0, qc: st.qc ? 1 : 0, n: st.bulkN, p: [] };
        o.p.push({ w: d[0], h: d[1], c: st.custom ? 1 : 0, ref: st.ownRef || 0, url: st.ownUrl || 0,
          th: st.ownThumb || 0, nm: st.ownName || 0, px: st.ownPx ? st.ownPx.w + "x" + st.ownPx.h : 0 });
        for (var i = 1; i < st.bulkN; i++) { var pc = st.pieces[i - 1] || {};
          var sz = st.ownSizeOf ? st.ownSizeOf(i) : null; sz = sz || [0, 0];
          o.p.push({ w: sz[0], h: sz[1], c: pc.mode === "custom" ? 1 : 0, ref: pc.ref || 0,
            url: pc.url || 0, th: pc.thumb || 0, nm: pc.name || 0, px: pc.px || 0 }); }
        return o;
      }
      function designLink() {
        var j = JSON.stringify(designState());
        var b64 = btoa(unescape(encodeURIComponent(j))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
        return location.origin + location.pathname + "?wld=" + b64;
      }
      // 2026-08-17 (Summer): the visible "Copy design link" row is gone — the
      // permalink now rides inside the mockup email instead (wemail handler
      // sends body.link; the worker prints it as "Open my design"). The ?wld=
      // restore below is unchanged, so links already in the wild keep working.
      st.designLink = designLink;
      // "Upload your artwork to order." sits directly UNDER the greyed
      // add-to-cart button it explains (Summer 2026-07-30)
      (function () {
        var se0 = sizeBox.querySelector(".wlseterr");
        if (se0) { se0.style.cssText +=
            ";margin:-14px 0 0;text-align:center;color:#8a2f2f;font-weight:600;font-size:13px";
          (form.closest(".product-info__block-item") || form).insertAdjacentElement("afterend", se0); }
      })();
      // ---- aftercare section (Summer 2026-07-30): everything below the cart
      // button + gate note (design link · sample pack · ask anything) sits on
      // its OWN background, visually separate from the configurator
      function seatAfter() {
        // WHITELIST, never a positional sweep — a "grab everything after the
        // form" version swallowed the entire description into the aftercare
        // box during init races (2026-07-30, 58k-px panel).
        var fb = (sec.querySelector("form[action*='/cart/add']") || form);
        fb = fb.closest(".product-info__block-item") || fb;
        var host = fb && fb.parentElement; if (!host) return;
        var wrap = host.querySelector(":scope > .wl-aftersec");
        if (!wrap) { wrap = document.createElement("div"); wrap.className = "wl-aftersec"; }
        if (!wrap.isConnected) fb.insertAdjacentElement("afterend", wrap);
        var picks = [];
        Array.prototype.forEach.call(host.children, function (b) {
          if (b === wrap || b === fb) return;
          if (/^\s*Not sure yet\?/.test((b.textContent || "").slice(0, 200))) {
            b.classList.add("wl-samplerow");   // guard hides it intl — the sample pack is AU-only (2026-08-01 r3)
            picks.push(b); }
          // free art finding line (Summer 2026-09-17) — every market, never .wl-samplerow
          else if (b.querySelector && b.querySelector(".wl-findrow")) picks.push(b);
        });
        var ask = document.getElementById("wl-ask-inline");
        if (ask) { var ab = ask.closest(".product-info__block-item") ||
                            (ask.parentElement && ask.parentElement.closest(".wlc4")) || ask.parentElement;
          if (ab && ab.parentElement === host) picks.push(ab); }
        picks.forEach(function (b) { if (b && b.parentElement !== wrap) wrap.appendChild(b); });
      }
      seatAfter();
      st.ownSeatAfter = seatAfter;
      // The reveal signal used to live here as a fixed 500ms timer, which said
      // "ready" whether or not the build had finished. It now fires at the real
      // end of the build (search wl-c-ready below) — Summer 2026-08-24.
      (function restoreDesign() {
        var m = /[?&]wld=([^&]+)/.exec(location.search); if (!m) return;
        var o = null;
        try { o = JSON.parse(decodeURIComponent(escape(atob(m[1].replace(/-/g, "+").replace(/_/g, "/"))))); }
        catch (e9) { return; }
        if (!o || o.v !== 1 || !o.p || !o.p.length) return;
        st.frUser = true;                     // the saved framing must win over auto-oak
        function restorePiece(p, i) {
          if (i === 0) {
            if (p.w && p.h) {
              if (p.c) applyCustom(+p.w, +p.h);
              else { var sw = sizeBox.querySelector(".wlselw"), sh = sizeBox.querySelector(".wlselh");
                if (sw && sh) { sw.value = String(p.w); sh.value = String(p.h);
                  if (sw.onchange) sw.onchange(); } } }
            if (p.ref) { st.ownRef = p.ref; st.ownUrl = p.url || null; st.ownThumb = p.th || null;
              st.ownImgId = null;
              fetch(API + "/api/own-preattach", { method: "POST",
                headers: { "content-type": "application/json" },
                body: JSON.stringify({ ref: p.ref }) })
                .then(function (x) { return x.json(); })
                .then(function (rp) { if (rp && rp.ok) st.ownImgId = rp.image_id; })
                .catch(function () {});
              st.ownName = p.nm || "your file";
              var mm = /^(\d+)x(\d+)$/.exec(p.px || ""); st.ownPx = mm ? { w: +mm[1], h: +mm[2] } : null;
              loadImg(p.th || p.url).then(function (im) { if (!im) return;
                st.p1Art = im;
                if (st.active === 0) { st.art = im; st.artBase = im; st.aspect = im.width / im.height; }
                if (st.ownShowOverlay) st.ownShowOverlay(); drawAll(); dpiNote();
                if (st.ownPieceRefresh) st.ownPieceRefresh(); if (st.ownGate) st.ownGate(); });
              if (st.ownPieceRefresh) st.ownPieceRefresh(); }
          } else {
            var pc = st.pieces[i - 1], el = rowEl(i); if (!pc || !el) return;
            pc.mode = p.c ? "custom" : "std";
            if (p.c) { pc.w = p.w; pc.h = p.h;
              if (st.ownSzBtns) st.ownSzBtns(el, true);
              el.querySelector(".wlstdpanel").style.display = "none";
              el.querySelector(".wlcuspanel").style.display = "flex";
              el.querySelector(".wlcw2").value = p.w; el.querySelector(".wlch2").value = p.h; }
            else { pc.sw = String(p.w); pc.sh = String(p.h);
              el.querySelector(".wlselw").value = String(p.w); el.querySelector(".wlselh").value = String(p.h); }
            if (p.ref) { pc.ref = p.ref; pc.url = p.url || null; pc.thumb = p.th || null;
              pc.imgId = null;
              fetch(API + "/api/own-preattach", { method: "POST",
                headers: { "content-type": "application/json" },
                body: JSON.stringify({ ref: p.ref }) })
                .then(function (x) { return x.json(); })
                .then(function (rp) { if (rp && rp.ok) pc.imgId = rp.image_id; })
                .catch(function () {});
              pc.name = p.nm || "your file"; pc.px = p.px || "";
              loadImg(p.th || p.url).then(function (im) { if (im) { pc.img = im; rowRefresh(i); thumbsRefresh(); } }); }
            if (el.__requote) el.__requote();
            rowRefresh(i);
          }
        }
        setTimeout(function () {
          var f = document.querySelector('fieldset[data-option-name*="fram"]');
          var lb = f && f.querySelector('label[data-value-handle*="' + (FR_HANDLE[o.f] || "rolled") + '"]');
          var inp = lb && f.querySelector("#" + CSS.escape(lb.getAttribute("for") || ""));
          if (lb && !(inp && inp.checked)) lb.click();
          readSel();
          st.finish = o.fin || "Matte";
          finRow.querySelectorAll(".wlfinb").forEach(function (fb) {
            fb.classList.toggle("on", fb.dataset.v === st.finish); });
          if (o.e) { st.edge = o.e; var er2 = edgeRow.querySelector('input[value="' + o.e + '"]');
            if (er2) { er2.checked = true; er2.dispatchEvent(new Event("change", { bubbles: true })); } }
          if (o.b) { st.border = o.b; var bi = borderRow.querySelector(".wlborder"); if (bi) bi.value = o.b; }
          if (o.bt) { st.borderType = o.bt; var bt2 = borderRow.querySelector('input[name="wlbordertype"][value="' + o.bt + '"]');
            if (bt2) { bt2.checked = true; bt2.dispatchEvent(new Event("change", { bubbles: true })); } }
          if (st.borderChipsDim) st.borderChipsDim();
          if (o.enh) { st.enh = true; var ce = enhRow.querySelector(".wlenh"); if (ce) ce.checked = true; }
          // the qc checkbox is gone (2026-08-24) — an OLD permalink carrying qc:1
          // still restores the flag onto the order, it just has no box to tick
          if (o.qc) st.qc = true;
          if (o.kit) { var kt = 0, ki = setInterval(function () {   // kit row loads async
            var ck = kitRow.querySelector(".wlkit");
            if (ck) { ck.checked = true; st.kit = true; clearInterval(ki); price(); }
            else if (++kt > 20) clearInterval(ki); }, 300); }
          if (st.ownEdgeVis) st.ownEdgeVis();
          var n2 = Math.min(10, +o.n || 1);
          if (n2 > 4) st.n4 = n2;
          if (n2 > 1) setPieces(n2);
          o.p.forEach(function (p, i) { if (i < n2) restorePiece(p, i); });
          price().then(function () { drawAll(); dpiNote(); if (st.ownBulkTotal) st.ownBulkTotal(); });
          var rn = document.createElement("div");
          rn.className = "nt";
          rn.style.cssText = "color:#425934;font-weight:600;margin:6px 0 0";
          rn.textContent = "Saved design restored ✓ — sizes, framing and files are loaded.";
          upZone.appendChild(rn);
        }, 900);
      })();
      // ================= PIECES v4 engine =========================================
      // The wall previews the ACTIVE piece; thumbnails under the room switch pieces;
      // one price source (pieceNet) feeds row prices AND the main total; the gate
      // holds add-to-cart until every piece has a size and an uploaded file.
      st.bulkN = 1; st.pieces = []; st.active = 0; st.p1Art = null; st.upBusy = 0;
      var piecesBox = sizeBox.querySelector(".wlpieces2");
      st.n4 = 4;
      st.ratioKeep = true;
      function szBtns(scope, custom) {   // Standard/Custom button pair state
        var s = scope.querySelector(".wlszstd"), c = scope.querySelector(".wlszcus");
        if (s) s.classList.toggle("on", !custom);
        if (c) c.classList.toggle("on", !!custom);
      }
      st.ownSzBtns = szBtns;
      (function () {
        // ---- FIX RATIO (Summer 2026-08-24) --------------------------------
        // Replaces the "Original ratio" / "Flexible ratio" button pair. The flag
        // is GLOBAL (one st.ratioKeep for the whole order) but a box is drawn in
        // every piece row, so all copies are kept in step by paintFixr().
        //   ticked   = st.ratioKeep true,  st.ratioUser false
        //   unticked = st.ratioKeep false, st.ratioUser true
        // st.ratioUser is the STICKY opt-out: only a real click sets it, so the
        // honesty auto-flip below can never undo Summer's own choice.
        function fixrBoxes() { return sizeBox.querySelectorAll(".wlfixrb"); }
        function paintFixr() {
          var on = st.ratioKeep !== false;
          Array.prototype.forEach.call(fixrBoxes(), function (b) { b.checked = on; });
          paintRatioUI();
        }
        // the height is a dropdown when the ratio is free and a read-only box when
        // it is fixed. No image means no ratio to derive from, so the dropdown
        // stays — a locked box with nothing to lock to would be a lie.
        function paintRatioUI() {
          var lock = st.ratioKeep !== false && !!st.ownPx;
          // ticking/unticking changes WHICH widths are real, so the list is rebuilt
          try { syncSizeLimits(); } catch (e) {}
          sizeBox.querySelectorAll(".wlstdpanel").forEach(function (sp) {
            var sel = sp.querySelector(".wlselh"), ro = sp.querySelector(".wlhro");
            if (!sel || !ro) return;
            sel.style.display = lock ? "none" : "";
            ro.style.display = lock ? "inline-flex" : "none";
            ro.textContent = sel.value || "";
          });
        }
        st.ownPaintRatioUI = paintRatioUI;
        // Re-derive a CUSTOM row's height from its own width, staying in Custom.
        // Width is kept because it is the side the customer last chose deliberately.
        function ratioFixCustom0() {
          if (!st.ownPx) return;
          var wI = sizeBox.querySelector(".wlcuspanel .wlcw2"),
              hI = sizeBox.querySelector(".wlcuspanel .wlch2");
          if (!wI || !hI) return;
          var w = +wI.value || 0; if (!w) return;
          var h = Math.round(w / (st.ownPx.w / st.ownPx.h));
          hI.value = h;
          if (typeof applyCustom === "function") applyCustom(w, h);
        }
        function ratioFixCustomN(i) {
          var pc = pcOf ? pcOf(i) : null, inf = infoOfPiece(i), el = rowEl(i);
          if (!pc || !inf || !inf.px || !el) return;
          var w = +(el.querySelector(".wlcw2") || {}).value || 0; if (!w) return;
          var h = Math.round(w / (inf.px.w / inf.px.h));
          el.querySelector(".wlch2").value = h;
          pc.mode = "custom"; pc.w = w; pc.h = h;
          if (el.__requote) el.__requote();
        }
        st.ownPaintFixr = paintFixr;   // new piece rows call this once mounted
        sizeBox.addEventListener("change", function (ev) {
          var b = ev.target;
          if (!b || !b.classList || !b.classList.contains("wlfixrb")) return;
          if (b.checked) {
            st.ratioKeep = true; st.ratioUser = false;
            paintFixr();
            // Ticking re-derives every sized piece from its own image — but it must
            // NOT change the size MODE. Before 2026-08-24 it called ownApplyRatio
            // unconditionally, which snaps to Standard, so ticking the box while you
            // were in Custom silently threw you into Standard.
            for (var ri = 0; ri < st.bulkN; ri++) {
              if (!(infoOfPiece(ri) && infoOfPiece(ri).px)) continue;
              if (ri === 0 && st.custom) { ratioFixCustom0(); continue; }
              var pcx = ri > 0 && pcOf ? pcOf(ri) : null;
              if (pcx && pcx.mode === "custom") { ratioFixCustomN(ri); continue; }
              if (st.ownApplyRatio) st.ownApplyRatio(ri);
            }
          } else {
            st.ratioKeep = false; st.ratioUser = true;
            paintFixr();
          }
        });
        // ownRatioHonesty was RETIRED 2026-08-24 (Summer: "when the fix ratio is
        // on it can't be removed"). It used to untick the box whenever the chosen
        // size drifted >2% off the image ratio. That was honest while a user could
        // still pick an off-ratio size with the box ticked — they no longer can:
        // Standard derives the height, Custom clamps the other side, and grid
        // rounding is accepted as the closest the size list allows. With no way to
        // create drift, an auto-untick could only ever be a false alarm (and a race
        // on st.size, refreshed 120ms late by stdChanged, made it fire for real).
        // ONLY A CLICK MOVES THE TICK NOW. Do not reintroduce a self-moving control.
        st.ownRatioHonesty = function () {};
      })();
      // If a custom W×H is EXACTLY a standard size, it IS standard — select it
      // as such (Summer 2026-07-30: a square upload became "custom 100×100" and
      // 80×80 typed as custom was refused by the custom-minimum rule).
      function snapToStdIfExact(i, w, h) {
        var elI = rowEl(i); if (!elI) return false;
        var sw = elI.querySelector(".wlselw"), sh = elI.querySelector(".wlselh");
        if (!sw || !sh) return false;
        var wv = Array.prototype.map.call(sw.options, function (o) { return o.value; });
        var hv = Array.prototype.map.call(sh.options, function (o) { return o.value; });
        if (wv.indexOf(String(w)) < 0 || hv.indexOf(String(h)) < 0) return false;
        sw.value = String(w); sh.value = String(h);
        if (st.ownSzBtns) st.ownSzBtns(elI, false);
        elI.querySelector(".wlstdpanel").style.display = "flex";
        elI.querySelector(".wlcuspanel").style.display = "none";
        if (i === 0) { clearCustom(); stdChanged(); }
        else { var pc0 = pcOf(i); if (pc0) { pc0.mode = "std"; pc0.sw = String(w); pc0.sh = String(h); }
          if (elI.__requote) elI.__requote(); }
        return true;
      }
      st.ownSnapStd = snapToStdIfExact;
      // Put row 0 into STANDARD mode (buttons + panels). Shared by
      // snapToStdIfExact above and by the "open on a standard pair" rule below.
      function stdModeRow0() {
        var el0 = rowEl(0); if (!el0) return false;
        var sp = el0.querySelector(".wlstdpanel"), cp = el0.querySelector(".wlcuspanel");
        if (!sp || !cp) return false;
        if (st.ownSzBtns) st.ownSzBtns(el0, false);
        sp.style.display = "flex"; cp.style.display = "none";
        clearCustom(); stdChanged();
        return true;
      }
      st.ownApplyRatio = function (i) {   // default size from the image: short side 100
        var inf = infoOfPiece(i); if (!inf || !inf.px) return;
        var r = inf.px.w / inf.px.h, w2, h2;
        if (r >= 1) { h2 = 100; w2 = Math.round(100 * r); if (w2 > 600) { w2 = 600; h2 = Math.round(600 / r); } }
        else { w2 = 100; h2 = Math.round(100 / r); if (h2 > 600) { h2 = 600; w2 = Math.round(600 * r); } }
        // Summer 2026-08-24: the page must OPEN ON STANDARD, never on a random
        // custom pair. Order: an exact standard hit, then the standard PAIR
        // closest to the image's shape (stdPairForRatio — the same rule the
        // Standard button uses), and only then Custom, for the cases where no
        // standard pair is usable at all (Fix ratio off, or no size list yet).
        // A 3:2 photo used to land on "Custom 150x100" because 150 is not on the
        // grid; it now opens on Standard 120x80, the same shape, on the grid.
        if (i === 0) {
          if (!snapToStdIfExact(0, w2, h2) &&
              !(st.ownStdPair && st.ownStdPair(null) && stdModeRow0())) {
            if (st.ownSetCustom) st.ownSetCustom(w2, h2); applyCustom(w2, h2); }
          // the size the image asked for may be one Europe cannot buy — lift it
          if (st.ownIntlLift) st.ownIntlLift(); }
        else if (st.ownDragCommit && st.active === i) st.ownDragCommit(w2, h2);
        else { if (snapToStdIfExact(i, w2, h2)) return;
          var pc = pcOf(i); if (!pc) return;
          pc.mode = "custom"; pc.w = w2; pc.h = h2;
          var el = rowEl(i);
          if (el) { if (st.ownSzBtns) st.ownSzBtns(el, true);
            el.querySelector(".wlstdpanel").style.display = "none";
            el.querySelector(".wlcuspanel").style.display = "flex";
            el.querySelector(".wlcw2").value = w2; el.querySelector(".wlch2").value = h2;
            if (el.__requote) el.__requote(); } }
      };
      function discFor(n) { return n >= 4 ? .20 : n === 3 ? .15 : n === 2 ? .10 : 0; }
      function stdVals(sel) { return Array.prototype.map.call(
        sizeBox.querySelector(sel).options, function (o) { return o.value; }); }
      function pcOf(i) { return i > 0 ? st.pieces[i - 1] : null; }
      function sizeOfPiece(i) {
        if (i === 0) { var d = orderDims(); return d && d[0] && d[1] ? [d[0], d[1]] : null; }
        var pc = pcOf(i); if (!pc) return null;
        if (pc.mode === "custom") return (+pc.w && +pc.h) ? [+pc.w, +pc.h] : null;
        return (+pc.sw && +pc.sh) ? [+pc.sw, +pc.sh] : null;
      }
      st.ownSizeOf = sizeOfPiece;
      function fileOfPiece(i) { return i === 0 ? st.ownRef : (pcOf(i) || {}).ref; }
      function imgOfPiece(i) { return i === 0 ? st.p1Art : (pcOf(i) || {}).img; }
      function infoOfPiece(i) {
        if (i === 0) return { name: st.ownName, px: st.ownPx };
        var pc = pcOf(i) || {};
        var m = /^(\d+)x(\d+)$/.exec(pc.px || "");
        return { name: pc.name, px: m ? { w: +m[1], h: +m[2] } : null };
      }
      st.ownActiveInfo = function () { return infoOfPiece(st.active); };
      function tooBig(w, h) { return Math.max(+w || 0, +h || 0) > 600; }
      async function pieceQuoteD(w, h) {
        var b2 = st.framing === "rolled" ? (st.border || 0) : 0;
        var r = await quoteRaw(+w, +h, st.framing, true, b2);
        if (!r.ok) r = await quoteRaw(+w, +h, st.framing, false, b2);
        return r;
      }
      function pieceNet(i) {      // ceil per piece after the set discount — ONE source of truth
        var q;
        if (i === 0) {
          var qq = st.quote && st.quote.ok ? st.quote : null;
          // stale-size guard (2026-07-31): a quote priced for a different
          // size/framing/border is NOT this piece's price — treat as missing
          if (qq && qq.wlFor) {
            var d0 = orderDims(), b0 = (st.framing === "rolled" && st.border > 0) ? st.border : 0;
            if (!d0 || qq.wlFor !== d0[0] + "x" + d0[1] + "|" + st.framing + "|" + b0) qq = null;
          }
          q = qq ? qq.total : null;
        } else q = (pcOf(i) || {}).quote;
        return q == null ? null : Math.ceil(q * (1 - discFor(st.bulkN)));
      }
      function rowEl(i) { return piecesBox.querySelector('.wlpc[data-i="' + i + '"]'); }
      function rowMsg(i, msg) {
        // upload errors live in the FILE HUB row, next to the Upload button —
        // not under the size row three sections away (Summer 2026-07-31)
        st.pcErrs = st.pcErrs || {};
        if (msg) st.pcErrs[i] = msg; else delete st.pcErrs[i];
        if (st.ownZone) st.ownZone();
      }
      function needsEnh(i) {             // 0 fine · 1 recommended (<3000px) · 2 a must (DPI<80)
        var inf = infoOfPiece(i), sz = sizeOfPiece(i);
        if (!inf || !inf.px) return 0;
        if (sz && sz[0] && sz[1]) {
          var dpi = Math.min(inf.px.w / (sz[0] / 2.54), inf.px.h / (sz[1] / 2.54));
          if (dpi < 80) return 2;
        }
        return Math.max(inf.px.w, inf.px.h) < 3000 ? 1 : 0;
      }
      // one verdict per piece — a green light, not just warnings (2026-07-30):
      // the DPI machinery only ever spoke up when something was wrong, so a good
      // file at a good size got silence instead of confidence.
      function verdictFor(i) {
        var inf = infoOfPiece(i), sz = sizeOfPiece(i);
        if (!inf || !inf.px) return null;              // format we can't decode — checked by the studio
        var need = needsEnh(i);
        if (need === 2) return { t: "Low resolution for this size — we recommend the image enhancement below.", c: "#8a6d3b" };
        if (need === 1) return { t: "Image enhancement recommended for this file.", c: "#8a6d3b" };
        if (sz && sz[0] && sz[1]) {
          var dpi = Math.min(inf.px.w / (sz[0] / 2.54), inf.px.h / (sz[1] / 2.54));
          return { t: dpi >= 150 ? "Print quality: excellent at this size ✓"
                                 : "Print quality: good at this size ✓", c: "#425934" };
        }
        return null;
      }
      st.ownVerdict = verdictFor;
      function maybeAutoEnh() {          // a "must" file ticks the enhancement once
        if (st.enh || st.enhDismissed) return;
        for (var i = 0; i < st.bulkN; i++) if (fileOfPiece(i) && needsEnh(i) === 2) {
          var cb = enhRow.querySelector(".wlenh");
          if (cb) { cb.checked = true; st.enh = true; price(); }
          return;
        }
      }
      function gate() {
        var ok = true, why = "";
        st.gateFocus = null;
        if (st.upBusy > 0) { ok = false; why = "Your file is still uploading…"; st.gateFocus = upZone; }
        for (var i = 0; ok && i < st.bulkN; i++) {
          var sz = sizeOfPiece(i);
          if (!sz) { ok = false; why = "Set the size for piece " + (i + 1) + "."; st.gateFocus = rowEl(i) || sizeBox; break; }
          if (tooBig(sz[0], sz[1])) { ok = false; why = "Piece " + (i + 1) + ": longest side is 600 cm."; st.gateFocus = rowEl(i) || sizeBox; break; }
          if (!fileOfPiece(i)) { ok = false;
            why = st.bulkN > 1 ? "Upload the file for piece " + (i + 1) + "." : "Upload your artwork to order.";
            st.gateFocus = upZone; break; }   // uploads live in the hub now
          if (st.bulkN > 1 && pieceNet(i) == null) { ok = false;
            why = "Piece " + (i + 1) + "'s size needs attention — see the note by its row.";
            st.gateFocus = rowEl(i) || sizeBox; break; }
        }
        [form.querySelector("button[type=submit],[name=add]"),
         document.querySelector(".product-sticky-bar button[type=submit]")].forEach(function (b) {
          if (!b) return; b.disabled = !ok; b.style.opacity = ok ? "" : ".45"; b.title = ok ? "" : why;
          // a DEAD button answers nothing (2026-07-30): route the click through the
          // wrapper (pointer-events off while disabled) → scroll to + flash the
          // blocking control, so "why can't I buy" answers itself
          b.style.pointerEvents = ok ? "" : "none";
          if (!b.__wlNudge && b.parentElement) { b.__wlNudge = 1;
            b.parentElement.addEventListener("click", function (ev) {
              if (!b.disabled) return;
              var r = b.getBoundingClientRect();
              if (ev.clientX < r.left || ev.clientX > r.right ||
                  ev.clientY < r.top || ev.clientY > r.bottom) return;
              var tgt = st.gateFocus || upZone;
              try { tgt.scrollIntoView({ block: "center", behavior: "smooth" }); }
              catch (e4) { tgt.scrollIntoView(); }
              tgt.classList.add("wl-flash");
              setTimeout(function () { tgt.classList.remove("wl-flash"); }, 1600);
            }); }
          // visible feedback ON the button while the file uploads (Summer
          // 2026-07-24) — restore only our own marker text, never "Adding…"
          var UPTXT = "Uploading your image…";
          if (st.upBusy > 0) { if (b.textContent !== UPTXT) { b.__wlPreUp = b.textContent; b.textContent = UPTXT; } }
          else if (b.textContent === UPTXT) b.textContent = b.__wlPreUp || "Add to cart";
        });
        // the button ALWAYS says why it's grey (Summer 2026-07-31): the old
        // "one red line at a time" rule suppressed this note whenever a row
        // error showed — leaving a dead grey button with no explanation
        var hold2 = null;
        var se = document.querySelector(".wlseterr");
        var mb = form.querySelector("button[type=submit],[name=add]");
        // a theme morph can destroy the note node together with the old form —
        // REBUILD it, don't just re-seat it (found by the 2026-07-30 click-crawl)
        if (!se && mb) { se = document.createElement("div");
          se.className = "wlseterr nt";
          se.style.cssText = "display:none;margin:6px 0 0;text-align:center;color:#8a2f2f;font-weight:600;font-size:13px";
          mb.insertAdjacentElement("afterend", se); }
        if (se) { se.textContent = ok || hold2 ? "" : why; se.style.display = ok || hold2 ? "none" : "";
          if (mb && se.previousElementSibling !== mb) mb.insertAdjacentElement("afterend", se);
        }
        return ok;
      }
      st.ownGate = gate;
      st.ownRowMsg = rowMsg;
      st.ownAutoEnh = maybeAutoEnh;
      // ---- thumbnails under the demo room: click to put that piece on the wall ----
      var thumbsRow = document.createElement("div");
      thumbsRow.className = "wlthumbs";
      thumbsRow.style.cssText = "display:none;gap:6px;flex-wrap:wrap;align-items:center;margin:8px 0 0";
      setTimeout(function () {
        var cap = wall.querySelector(".wcap");
        if (cap) cap.insertAdjacentElement("afterend", thumbsRow);
      }, 0);
      function thumbsRefresh() {
        var any = false;
        thumbsRow.innerHTML = "";
        for (var i = 0; i < st.bulkN; i++) {
          var im = imgOfPiece(i), inf = infoOfPiece(i);
          if (!im && !inf.name) continue;
          any = true;
          var b = document.createElement("button");
          b.type = "button";
          var bw = im ? Math.max(18, Math.min(78, Math.round(44 * im.width / im.height))) : 44;
          b.style.cssText = "width:" + bw + "px;height:44px;padding:0;border:" +
            (i === st.active ? "2px solid #425934" : "1px solid var(--wlbd,#ccc)") +
            ";background:#fff;cursor:pointer;overflow:hidden;position:relative";
          b.title = "Piece " + (i + 1) + (inf.name ? " — " + inf.name : "");
          if (im) { var c = document.createElement("canvas");
            var s = 84 / Math.max(im.width, im.height);
            c.width = Math.max(1, Math.round(im.width * s)); c.height = Math.max(1, Math.round(im.height * s));
            c.getContext("2d").drawImage(im, 0, 0, c.width, c.height);
            var img = document.createElement("img"); img.src = c.toDataURL("image/jpeg", .75);
            img.style.cssText = "width:100%;height:100%;object-fit:fill"; b.appendChild(img);   // stretch, never crop (2026-07-31)
          } else b.textContent = "📄";
          if (st.bulkN > 1) { var n = document.createElement("span");
            n.textContent = i + 1;
            n.style.cssText = "position:absolute;left:1px;bottom:0;font-size:9px;background:rgba(255,255,255,.85);padding:0 3px";
            b.appendChild(n); }
          (function (idx) { b.onclick = function () { selectPiece(idx); }; })(i);
          thumbsRow.appendChild(b);
          // ---- "Enhance this image", beside piece 1's thumbnail (Summer 2026-08-24).
          // Piece 1 ONLY: window.__wlEnhOwn carries the first upload and nothing
          // else, so a button on piece 2 would open the enhancer showing piece 1.
          // st.ownRef, not st.art — the sample image never uploads, so the trial
          // artwork on the wall must not offer an enhancement of somebody else's file.
          // It lives inside the room pane, so the Enhance and Gallery tabs never
          // carry a second copy of it.
          if (i === 0 && ENH && st.ownRef) {
            var eb = document.createElement("button");
            eb.type = "button";
            eb.className = "wlenhjump";
            eb.textContent = "Enhance this image";
            eb.title = "Enhance this image";
            eb.onclick = function () {
              if (st.ownShowPane) st.ownShowPane("enh");
              // put the tab row at the top of the screen — the pane opens below
              // the room canvas, which is a full phone screen tall on its own
              try { wall.scrollIntoView({ block: "start", behavior: "smooth" }); }
              catch (e5) { wall.scrollIntoView(); }
            };
            thumbsRow.appendChild(eb);
          }
        }
        thumbsRow.style.display = any ? "flex" : "none";
      }
      st.ownThumbs = thumbsRefresh;
      function selectPiece(i) {
        st.active = i;
        var im = imgOfPiece(i);
        st.art = im || null; st.artBase = im || null;
        if (im) st.aspect = im.width / im.height;
        if (st.ownShowOverlay) st.ownShowOverlay();
        drawAll(); dpiNote(); thumbsRefresh();
      }
      st.ownSelectPiece = selectPiece;
      st.ownDragCommit = function (w2, h2) {      // corner-drag edits the ACTIVE piece
        if (st.active === 0) { applyCustom(w2, h2, true); rowRefresh(0); return; }
        var pc = pcOf(st.active); if (!pc) return;
        pc.mode = "custom"; pc.w = w2; pc.h = h2;
        var el = rowEl(st.active);
        if (el) { if (st.ownSzBtns) st.ownSzBtns(el, true);
          el.querySelector(".wlstdpanel").style.display = "none";
          el.querySelector(".wlcuspanel").style.display = "flex";
          el.querySelector(".wlcw2").value = w2; el.querySelector(".wlch2").value = h2;
          if (el.__requote) el.__requote(); }
        drawAll(); dpiNote();
      };
      function rowRefresh(i) {    // rows are pure size controls — the hub owns files
        var el = rowEl(i); if (!el) return;
        rowPrices(); gate();
        if (st.ownZone) st.ownZone();   // the hub mirrors every piece, not just #1
      }
      st.ownPieceRefresh = function () { rowRefresh(0); thumbsRefresh(); };
      function copyFileFrom(j, i) {   // reuse an already-uploaded image on another piece
        var s = { ref: fileOfPiece(j), url: j === 0 ? st.ownUrl : (pcOf(j) || {}).url,
          thumb: j === 0 ? st.ownThumb : (pcOf(j) || {}).thumb,
          imgId: j === 0 ? st.ownImgId : (pcOf(j) || {}).imgId,
          name: infoOfPiece(j).name, px: infoOfPiece(j).px, img: imgOfPiece(j) };
        if (!s.ref) return;
        if (i === 0) { st.ownRef = s.ref; st.ownUrl = s.url; st.ownThumb = s.thumb;
          st.ownImgId = s.imgId || null; st.ownName = s.name;
          st.ownPx = s.px ? { w: s.px.w, h: s.px.h } : null;
          st.p1Art = s.img || null;
          if (st.active === 0) { st.art = st.p1Art; st.artBase = st.p1Art;
            if (st.p1Art) st.aspect = st.p1Art.width / st.p1Art.height;
            drawAll(); dpiNote(); }
        } else { var pc = pcOf(i); if (!pc) return;
          pc.ref = s.ref; pc.url = s.url; pc.thumb = s.thumb;
          pc.imgId = s.imgId || null; pc.name = s.name;
          pc.px = s.px ? s.px.w + "x" + s.px.h : ""; pc.img = s.img || null; }
        rowRefresh(i); thumbsRefresh();
        if (!st.ratioUser && st.ownApplyRatio) st.ownApplyRatio(i);
        maybeAutoEnh();
        totalCalc(); gate();
      }
      function rowPrices() {   // info line + tick + reuse + per-piece quality note
        var anyNeed = 0;
        for (var i = 0; i < st.bulkN; i++) {
          var el = rowEl(i); if (!el) continue;
          var info = el.querySelector(".pcinfo");
          var held = info.dataset.hold === "1";          // a sticky error owns this line
          var inf = infoOfPiece(i), parts = [];
          // single piece: the upload box already shows name/px/verdict — the same
          // line under the size row was a duplicate (Summer 2026-07-30)
          if (st.bulkN === 1 && i === 0 && !held) {
            info.style.display = "none"; info.textContent = "";
            continue;
          }
          // SETS (Summer 2026-07-30): rows stay COMPACT — thumbnails, names,
          // prices and quality all live in the white file hub at the top.
          // Only a sticky upload error may use the row's info line.
          var need = fileOfPiece(i) ? needsEnh(i) : 0;
          if (need > anyNeed) anyNeed = need;
          if (!held) { info.style.display = "none"; info.textContent = ""; }

        }
        // quality guidance lives in ONE place (the line under the size row) —
        // the extra red line under the checkbox is gone (Summer 2026-07-24)
        var en = enhRow.querySelector(".wlenhwarn");
        if (en) { en.style.display = "none"; en.textContent = ""; }
        // sets: ONE aggregated low-res note instead of a sentence per row
        var lr = upZone.querySelector(".wl-lowres");
        if (lr) lr.style.display = (st.bulkN > 1 && anyNeed) ? "" : "none";
      }
      var bulkKey = "";
      function totalCalc() {
        if (st.ownRatioHonesty) st.ownRatioHonesty();
        var key = st.framing + "|" + (st.framing === "rolled" ? (st.border || 0) : 0);
        if (key !== bulkKey) { bulkKey = key;
          piecesBox.querySelectorAll(".wlpc").forEach(function (el) {
            var i2 = +el.dataset.i;
            if (i2 > 0 && i2 < st.bulkN && el.__requote) el.__requote(); });
        }
        rowPrices(); gate();
        frCaps();                      // tile prices follow the set (cached quotes)
        if (st.ownZone) st.ownZone();  // hub prices follow size changes too
        var sv = upZone.querySelector(".wlsave");
        if (st.bulkN < 2) { if (sv) sv.style.display = "none"; return; }
        // 2026-07-30: the set total shows as soon as every piece has a SIZE — it
        // used to wait for every FILE, so a customer pricing a 2-piece set stared
        // at the piece-1 price with no discount in sight. The gate still blocks
        // add-to-cart until the files are up; only the display moved earlier.
        var sum = 0, gross = 0, missing = 0;
        for (var i = 0; i < st.bulkN; i++) {
          var net = pieceNet(i);
          var q = i === 0 ? (st.quote && st.quote.ok ? st.quote.total : null) : (pcOf(i) || {}).quote;
          if (net == null) missing++; else { sum += net; gross += Math.ceil(q); }
        }
        sum += (st.enh ? 5 : 0) + (st.kit && kit.price ? kit.price : 0);   // enh $5 (was $10) 2026-08-23
        if (sv) sv.style.display = "none";
        // a stale total must LOOK stale — dim it until every piece prices again
        // (Summer 2026-07-30: "price disappeared, the total still remained")
        var mpD = curPrice();
        if (mpD) mpD.style.opacity = missing ? ".35" : "";
        var spD = document.querySelector(".product-sticky-bar sale-price");
        if (spD) spD.style.opacity = missing ? ".35" : "";
        if (missing) {
          // self-heal (2026-07-31): piece 1's quote went stale against its size
          // → requote instead of sitting dimmed forever. Keyed per size so a
          // failing quote can't loop.
          if (pieceNet(0) == null && sizeOfPiece(0)) {
            var hk = String(sizeOfPiece(0)) + "|" + st.framing + "|" + (st.border || 0);
            if (totalCalc._heal !== hk) { totalCalc._heal = hk;
              setTimeout(function () { price().then(function () { totalCalc(); }); }, 60); }
          }
          return;
        }
        var grossAll = gross + (st.enh ? 10 : 0) + (st.kit && kit.price ? kit.price : 0);
        // kit.price is already presentment; everything else is engine AUD, so
        // convert the AUD part and add the kit — mirrors per-line checkout.
        var kitP = (st.kit && kit.price ? +kit.price : 0);
        var presAll = toPres(grossAll - kitP) + kitP, presSum = toPres(sum - kitP) + kitP;
        var slash = grossAll > sum
          ? ' <s style="font-size:55%;color:#c0392b;font-weight:400">' + moneyMain(presAll) + "</s>" : "";
        if (sv && grossAll > sum) { sv.style.display = "";
          sv.innerHTML = "Set of " + st.bulkN + ": " + money(presSum) +
            ' — <span style="color:#c0392b">you save ' + money(grossAll - sum, true) + "</span> (" +
            Math.round(discFor(st.bulkN) * 100) + "% set discount)."; }
        var mp = curPrice();
        if (mp) { mp.innerHTML = moneyMain(presSum) + slash; mp.dataset.wlSet = "1"; wlAfterpay(sum); }
        var sp = document.querySelector(".product-sticky-bar sale-price");
        if (sp) { if (stickyMem.orig == null) stickyMem.orig = sp.innerHTML;
          sp.innerHTML = moneyMain(presSum) + slash; sp.dataset.wlSet = "1"; }
      }
      st.ownBulkTotal = totalCalc;
      // the server's set price is NORMATIVE — after /api/native-lines prices the
      // set, the page repaints to the server sum so display and cart can never
      // disagree again (2026-07-31: page $2,991 vs cart $3,184)
      st.ownSyncTotal = function (sum, kitPres) {
        // sum = server AUD total; kitPres = the presentment kit price already
        // folded in by the caller (it must not be converted a second time)
        var kp6 = +kitPres || 0, pres6 = toPres(sum - kp6) + kp6;
        var mp6 = curPrice();
        if (mp6) { mp6.style.opacity = ""; mp6.innerHTML = moneyMain(pres6); mp6.dataset.wlSet = "1"; wlAfterpay(sum); }
        var sp6 = document.querySelector(".product-sticky-bar sale-price");
        if (sp6) { sp6.style.opacity = ""; sp6.textContent = moneyMain(pres6); sp6.dataset.wlSet = "1"; }
      };
      function wirePiece(el, idx) {   // rows 2..N (idx = data-i)
        var pc = st.pieces[idx - 1] = st.pieces[idx - 1] ||
          { mode: "std", sw: "80", sh: "80", w: "", h: "" };
        var selW = el.querySelector(".wlselw"), selH = el.querySelector(".wlselh");
        // the WHOLE grid, not row 0's list — row 0's width list is filtered to
        // row 0's image ratio (2026-08-24) and this row has its own image
        (st.ownAllW || stdVals('.wlpc[data-i="0"] .wlselw')).forEach(function (v) {
          var o = document.createElement("option"); o.value = v; o.textContent = v; selW.appendChild(o); });
        (st.ownAllH || stdVals('.wlpc[data-i="0"] .wlselh')).forEach(function (v) {
          var o = document.createElement("option"); o.value = v; o.textContent = v; selH.appendChild(o); });
        selW.value = pc.sw || "80"; selH.value = pc.sh || "80";
        var stdP = el.querySelector(".wlstdpanel"), cusP = el.querySelector(".wlcuspanel");
        var err = el.querySelector(".pcerr");
        function mode(custom) {
          pc.mode = custom ? "custom" : "std";
          stdP.style.display = custom ? "none" : "flex";
          cusP.style.display = custom ? "flex" : "none";
          if (custom) cusP.querySelector(".wlcw2").focus();
          requote();
        }
        el.querySelector(".wlszstd").onclick = function () { szBtns(el, false); mode(false); };
        el.querySelector(".wlszcus").onclick = function () { szBtns(el, true); mode(true); };
        var pq = null;
        function requote() { clearTimeout(pq); pq = setTimeout(async function () {
          pc.sw = selW.value; pc.sh = selH.value;
          pc.w = el.querySelector(".wlcw2").value; pc.h = el.querySelector(".wlch2").value;
          if (pc.mode === "custom" && +pc.w && +pc.h && st.ownSnapStd &&
              st.ownSnapStd(idx, +pc.w, +pc.h)) return;
          var sz = sizeOfPiece(idx);
          err.style.display = "none"; err.textContent = "";
          if (!sz) { pc.quote = null; totalCalc(); return; }
          if (tooBig(sz[0], sz[1])) { pc.quote = null;
            err.textContent = "Longest side is 600 cm — email us for larger."; err.style.display = "";
            totalCalc(); return; }
          var r = await pieceQuoteD(sz[0], sz[1]);
          pc.quote = r.ok ? r.total : null;
          if (!r.ok) { err.textContent = r.message || "That size is not possible."; err.style.display = ""; }
          totalCalc();
          if (st.active === idx) { drawAll(); dpiNote(); }
        }, 450); }
        el.__requote = requote;
        function pSnap(changed) {   // Keep original: the other side follows this piece's image
          if (st.ratioKeep === false) return;
          var m2 = /^(\d+)x(\d+)$/.exec(pc.px || ""); if (!m2) return;
          var ratio = +m2[1] / +m2[2];
          var sel = changed === selW ? selH : selW;
          var tgt = changed === selW ? (+selW.value) / ratio : (+selH.value) * ratio;
          var best = null, bd = 1e9;
          Array.prototype.forEach.call(sel.options, function (op) {
            var v = +op.value, dd = Math.abs(v - tgt);
            if (dd < bd) { bd = dd; best = op.value; } });
          if (best != null) sel.value = best;
        }
        selW.onchange = function () { pSnap(selW); requote(); };
        selH.onchange = function () { pSnap(selH); requote(); };
        function cusSync(ev) {   // keep-ratio: typing one side fills the other
          if (st.ratioKeep !== false) {
            var m = /^(\d+)x(\d+)$/.exec(pc.px || "");
            if (m && +ev.target.value) {
              var asp = +m[1] / +m[2];
              if (ev.target.classList.contains("wlcw2"))
                el.querySelector(".wlch2").value = Math.round(+ev.target.value / asp);
              else el.querySelector(".wlcw2").value = Math.round(+ev.target.value * asp);
            }
          }
          requote();
        }
        el.querySelector(".wlcw2").addEventListener("input", cusSync);
        el.querySelector(".wlch2").addEventListener("input", cusSync);
        var inp = document.createElement("input");
        inp.type = "file"; inp.accept = artInp.accept;
        inp.style.cssText = "position:absolute;width:1px;height:1px;opacity:0";
        el.appendChild(inp);
        el.__pick = function () {
          if (st.upPiece != null) return;   // one upload at a time
          inp.value = ""; inp.click(); };
        inp.onchange = async function () {
          var f = inp.files[0]; if (!f) return;
          rowMsg(idx, null);
          // INSTANT feedback ON THIS ROW'S HUB LINE — a big file used to decode
          // and upload in silence while the hub showed nothing (Summer
          // 2026-07-31: "not just the first image"). The pcinfo line under the
          // size row is NOT used: rowPrices() keeps set rows compact and wipes it.
          st.upPiece = idx; st.upName = f.name;
          st.zoneMsg = "Reading your file…";
          if (st.ownZone) st.ownZone();
          function upOff() { st.upPiece = null; st.upName = null; st.zoneMsg = null;
            if (st.ownZone) st.ownZone(); }
          var ext = (String(f.name).split(".").pop() || "").toLowerCase();
          if (ext === "jpeg") ext = "jpg";
          var OKX = { jpg: 1, png: 1, webp: 1 };
          if (ext === "heic" || ext === "heif") { upOff(); rowMsg(idx, "Email HEIC files to summer@wallliberation.com.au — we will handle it by hand."); return; }
          if (!OKX[ext]) { upOff(); rowMsg(idx, "JPEG, PNG or WebP please — export your file as one of those."); return; }
          if (f.size > 500 * 1048576) { upOff(); rowMsg(idx, "Files up to 500 MB — email larger ones after ordering."); return; }
          var bm = null;
          try { bm = await createImageBitmap(f); } catch (e3) { bm = null; }
          if (!bm) { upOff(); rowMsg(idx, "Your browser can't display this file — export it as JPEG or PNG and upload that."); return; }
          st.zoneMsg = "Uploading your file — please keep this page open…";
          if (st.ownZone) st.ownZone();
          st.upBusy++; gate();
          var up = await chunkUpload(f, ext);
          st.upBusy = Math.max(0, st.upBusy - 1);
          st.zoneMsg = null; st.upNote = null; st.upPct = null;
          st.upPiece = null; st.upName = null;
          if (st.ownZone) st.ownZone();
          if (!up || !up.ref) { rowMsg(idx, (up && up.fail) || "Upload failed — please try again."); gate(); return; }
          pc.ref = up.ref; pc.url = up.url; pc.name = f.name;
          pc.px = bm.width + "x" + bm.height;
          pc.thumb = await thumbUp(up.ref, bm);
          pc.imgId = null;
          fetch(API + "/api/own-preattach", { method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify({ ref: up.ref }) })
            .then(function (x) { return x.json(); })
            .then(function (rp) { if (rp && rp.ok) pc.imgId = rp.image_id; })
            .catch(function () {});
          try {
            var mc = document.createElement("canvas");
            var ms = Math.min(1, 1400 / Math.max(bm.width, bm.height));
            mc.width = Math.max(1, Math.round(bm.width * ms)); mc.height = Math.max(1, Math.round(bm.height * ms));
            mc.getContext("2d").drawImage(bm, 0, 0, mc.width, mc.height);
            pc.img = new Image(); pc.img.src = mc.toDataURL("image/jpeg", .85);
            await new Promise(function (r2) { pc.img.onload = r2; pc.img.onerror = r2; });
          } catch (e2) { pc.img = null; }
          bm.close();
          rowRefresh(idx); selectPiece(idx);
          if (!st.ratioUser && st.ownApplyRatio) st.ownApplyRatio(idx);
          maybeAutoEnh();
          totalCalc();
        };
        requote();
      }
      function setPieces(n) {
        st.bulkN = n;
        pcsBox.querySelectorAll(".wltab").forEach(function (b) {
          var on = +b.dataset.n === Math.min(n, 4);
          // 2026-08-24: the .on CLASS carries the whole look now — these used to
          // paint solid olive inline, which beat the stylesheet and left the
          // pieces tabs as the only buttons on the page with a different
          // selected state. Colours live in CSS; JS only sets the class.
          b.classList.toggle("on", on);
        });
        var t4l = pcsBox.querySelector(".t4l");
        if (t4l) t4l.textContent = st.n4 > 4 ? String(st.n4) : "4+";
        var have = piecesBox.querySelectorAll(".wlpc").length;
        for (var i = have; i < n; i++) {
          piecesBox.insertAdjacentHTML("beforeend", pieceMarkup(i));
          wirePiece(rowEl(i), i);
        }
        // the new row's Fix-ratio box ships ticked (markup default) — repaint it
        // to the order's real state, or piece 3 would contradict pieces 1 and 2
        if (have < n && st.ownPaintFixr) st.ownPaintFixr();
        piecesBox.querySelectorAll(".wlpc").forEach(function (el) {
          var i2 = +el.dataset.i;
          el.style.display = i2 < n ? "" : "none";
          el.querySelector(".pcnum").style.display = n > 1 ? "" : "none";
        });
        if (st.active >= n) selectPiece(0);
        // collapsed line ↔ open tabs (2026-07-30): back to 1 piece = back to the line
        var pcb = pcsBox.querySelector(".wl-pcbody");
        if (pcb) pcb.style.display = "";   // pieces block is always visible now (2026-07-31)
        if (n < 2) price().then(function () { totalCalc(); }); else totalCalc();
        rowRefresh(0); thumbsRefresh();
        if (st.ownZone) st.ownZone();
      }
      pcsBox.querySelectorAll(".wltab").forEach(function (b) {
        b.onclick = function () {
          setPieces(+b.dataset.n === 4 ? st.n4 : +b.dataset.n); };
      });
      (function () {   // the 4+ tab carries its own always-visible stepper
        var up = pcsBox.querySelector(".t4up"), dn = pcsBox.querySelector(".t4dn");
        function bump(d, ev) { ev.stopPropagation();
          st.n4 = Math.max(4, Math.min(10, st.n4 + d));
          pcsBox.querySelector(".t4l").textContent = st.n4 > 4 ? String(st.n4) : "4+";
          if (st.bulkN >= 4) setPieces(st.n4); }
        if (up) up.onclick = function (ev) { bump(1, ev); };
        if (dn) dn.onclick = function (ev) { bump(-1, ev); };
      })();
      st.ownSizeErr = function (msg) {
        var err = piecesBox.querySelector('.wlpc[data-i="0"] .pcerr');
        if (!err) return;
        err.textContent = msg || ""; err.style.display = msg ? "" : "none";
      };
      st.ownReplaceActive = function () {
        if (st.active === 0) { startUpload(); return; }
        var el = rowEl(st.active);
        if (el && el.__pick) el.__pick();
      };
      setTimeout(function () { rowRefresh(0); gate(); }, 400);
      var selW = sizeBox.querySelector(".wlselw"), selH = sizeBox.querySelector(".wlselh");
      var ALLW = [], ALLH = [];
      function fillSel(sel, fs) {
        var vals = Array.prototype.map.call(fs ? fs.querySelectorAll("label:not(.wl-cpill)") : [],
          function (l) { return (l.textContent.trim().match(/\d{2,3}/) || [""])[0]; }).filter(Boolean);
        vals.forEach(function (v) { var o = document.createElement("option"); o.value = v; o.textContent = v; sel.appendChild(o); });
      }
      fillSel(selW, wFsOwn); fillSel(selH, hFsOwn);
      // the WHOLE grid, kept aside: with Fix ratio on, the width dropdown is
      // rebuilt from a filtered copy of this (ratioMap below) and has to be able
      // to grow back when the tick comes off.
      ALLW = Array.prototype.map.call(selW.options, function (o) { return o.value; });
      ALLH = Array.prototype.map.call(selH.options, function (o) { return o.value; });
      st.ownAllW = ALLW; st.ownAllH = ALLH;
      setTimeout(function () { try { syncSizeLimits(); } catch (e) {} }, 0);
      // Outside Australia the smallest sizes can be unsellable — the UK and EU
      // have no shipping rate for a rolled print under the A$260 threshold, so
      // /api/quote refuses it. The page still opened on 80x80 there, which left
      // the Rolled tile (the intl default since 2026-08-23) with NO price while
      // the four framed tiles showed one. Step up to the first standard size
      // that actually quotes. Asking the quote rather than hardcoding a country
      // list means this follows the threshold if it ever moves. US/AU quote at
      // the first try and are left exactly as they were.
      if (WL_AUDEL) setTimeout(function () {
        var vals = Array.prototype.map.call(selW.options, function (o) { return +o.value; })
          .filter(function (v) { return v > 0; });
        var i = 0;
        var tryNext = function () {
          if (i >= vals.length || i > 5) return;
          var v = vals[i++];
          frCapQuote(v, v, "rolled", false, 0).then(function (t) {
            if (t == null) { tryNext(); return; }
            if (i > 1) {
              selW.value = String(v); selH.value = String(v);
              // go through the select's OWN handler, exactly as a click would:
              // calling stdChanged() alone left the tile captions priced at the
              // size we had just left, which is what kept Rolled blank. The
              // theme morphs the variant asynchronously, so re-price the
              // captions again once it has settled.
              selW.onchange(); selH.onchange();
              // the theme keeps morphing the variant for several seconds after
              // this, and a caption pass that lands mid-morph prices the size we
              // just left — which is exactly what kept Rolled blank. Re-run the
              // select's own handler once the morph has settled; it re-quotes
              // whatever is selected then, so a customer who has already changed
              // the size simply gets their own size priced.
              [1200, 3000, 6000].forEach(function (ms) {
                setTimeout(function () { try { selH.onchange(); } catch (e) {} }, ms); });
            }
          });
        };
        tryNext();
      }, 900);
      function clickHidden(fs, num) {
        if (!fs) return;
        var lab = Array.prototype.find.call(fs.querySelectorAll("label:not(.wl-cpill)"),
          function (l) { return l.textContent.trim().replace(/\D/g, "") === String(num); });
        var inp = lab && fs.querySelector("#" + CSS.escape(lab.getAttribute("for") || ""));
        if (inp && !inp.checked) { inp.click(); inp.dispatchEvent(new Event("change", { bubbles: true })); }
      }
      // THE SHORT SIDE CANNOT EXCEED 300 CM (Summer 2026-08-24). The engine has
      // always refused it — "Premium Linen Canvas prints up to 300 cm on the
      // short side" — but both dropdowns offered 320/400/480/600, so 320x400
      // was two clicks away and every framing tile then showed a name and NO
      // price, with only the generic "Upload your artwork to order." on screen.
      // The big sizes must stay: 300x600 is a real size at A$3,280. So grey out
      // what the OTHER side makes impossible, rather than removing anything.
      var SHORT_MAX = 300;
      // WITH FIX RATIO ON, THE WIDTH LIST IS NOT THE WHOLE GRID (Summer
      // 2026-08-24, reported from a phone: "I choose a different standard size
      // and the selection does not land"). The height is derived, so a width is
      // only real if some height on the grid holds the image's shape. The old
      // rule (snapPairFromW) accepted a width only when a height matched to the
      // CENTIMETRE, and then quietly moved the customer to the nearest width that
      // did: on a 4:3 phone photo only 5 of the 20 widths survived that test, so
      // most picks snapped straight back to the width already showing — and on a
      // 16:9 image every pick but one landed on 320, which is "cannot change the
      // size" exactly. A dropdown must not offer what it will not accept, so the
      // list itself is now the answer: only the widths that work are on it, and
      // every one of them lands. Tolerance is the same 2% the rest of this file
      // treats as the same shape (invisible on a wall).
      var RTOL = 0.02;
      function ratioMap() {
        if (!(st.ratioKeep !== false && st.ownPx)) return null;   // free grid
        if (!ALLW.length || !ALLH.length) return null;
        var r = st.ownPx.w / st.ownPx.h, map = {}, n = 0;
        ALLW.forEach(function (wv) {
          var w = +wv; if (!w) return;
          var best = 0, bd = 1e9;
          ALLH.forEach(function (hv) {
            var h = +hv; if (!h) return;
            var d = Math.abs(h - w / r); if (d < bd) { bd = d; best = h; } });
          if (!best || Math.abs((w / best) / r - 1) > RTOL) return;
          if (w > SHORT_MAX && best > SHORT_MAX) return;   // short-side cap
          map[w] = best; n++; });
        // an awkward ratio can leave nothing usable — then the full grid stays and
        // stdSnap offers the closest pair, which is Summer's ruling for that case
        return n >= 2 ? map : null;
      }
      st.ownRatioMap = ratioMap;
      function syncSizeLimits() {
        // rebuild the width list — `hidden` on an <option> is not honoured by
        // every mobile browser, so an unusable width is not in the DOM at all
        var map = ratioMap();
        var keep = map ? ALLW.filter(function (v) { return map[+v] != null; }) : ALLW;
        if (keep.length && (selW.options.length !== keep.length ||
            Array.prototype.some.call(selW.options, function (o, i) { return o.value !== keep[i]; }))) {
          var cur = selW.value;
          selW.innerHTML = "";
          keep.forEach(function (v) {
            var o = document.createElement("option"); o.value = v; o.textContent = v;
            selW.appendChild(o); });
          selW.value = keep.indexOf(cur) >= 0 ? cur : keep[0];
        }
        // the derived height ALWAYS matches the width on show
        if (map && map[+selW.value] != null) selH.value = String(map[+selW.value]);
        [[selW, selH], [selH, selW]].forEach(function (pair) {
          var other = +pair[1].value || 0;
          Array.prototype.forEach.call(pair[0].options, function (o) {
            var v = +o.value || 0;
            // impossible only when BOTH sides would be over the short-side cap
            var bad = v > SHORT_MAX && other > SHORT_MAX;
            o.disabled = bad;
            o.textContent = bad ? o.value + " —" : o.value;
          });
        });
      }
      function stdChanged() {
        syncSizeLimits();
        // the theme replaces the fieldset nodes on variant change — re-resolve live
        if (wOptName && wFsOwn && !wFsOwn.isConnected)
          wFsOwn = document.querySelector('fieldset[data-option-name="' + wOptName + '"]') || wFsOwn;
        if (hOptName && hFsOwn && !hFsOwn.isConnected)
          hFsOwn = document.querySelector('fieldset[data-option-name="' + hOptName + '"]') || hFsOwn;
        clickHidden(wFsOwn, selW.value); clickHidden(hFsOwn, selH.value);
        assertPicked();
        if (st.ownPaintRatioUI) st.ownPaintRatioUI();   // the derived height follows W
        setTimeout(function () { readSel(); price(); drawAll(); dpiNote(); }, 120); }
      // row 0's dropdown pair — the SIZE on this page (readSel reads this, not the
      // theme). Custom mode has its own st.w/st.h, so this speaks for Standard only.
      st.ownStdSize = function () {
        if (st.custom) return null;
        var w = +selW.value || 0, h = +selH.value || 0;
        return (w && h) ? [w, h] : null; };
      // whatever the customer can actually SEE in the size row, in either mode —
      // the add-to-cart guard checks the order against this and nothing else.
      st.ownShownSize = function () {
        if (!st.custom) return st.ownStdSize();
        var cp = sizeBox.querySelector(".wlcuspanel");
        var cw = +((cp && cp.querySelector(".wlcw2")) || {}).value || 0,
            chh = +((cp && cp.querySelector(".wlch2")) || {}).value || 0;
        return (cw && chh) ? [cw, chh] : null; };
      // Shopify rebuilds the Width/Height fieldsets ~150 ms after a click and can
      // swallow the second one, leaving the variant on a size nobody asked for.
      // Nothing the customer pays for reads those radios any more, but the variant
      // id in the URL and the form should still match what is on screen — so check
      // the click landed, and click again if it did not (Summer 2026-08-24).
      var pickSeq = 0;
      function assertPicked() {
        var mine = ++pickSeq;
        [300, 800, 1600].forEach(function (ms) {
          setTimeout(function () {
            if (mine !== pickSeq) return;              // a newer size change owns the page
            var wantW = +selW.value || 0, wantH = +selH.value || 0;
            if (!wantW || !wantH) return;
            var wf = document.querySelector('fieldset[data-option-name="' + wOptName + '"]'),
                hf = document.querySelector('fieldset[data-option-name="' + hOptName + '"]');
            if (!wf || !hf) return;
            if (ownPickNum(wf) === wantW && ownPickNum(hf) === wantH) return;
            clickHidden(wf, wantW); clickHidden(hf, wantH);
          }, ms); });
      }
      // Keep original + a standard grid used to let 140×220 sit under a square
      // image — the preview stretched into a thin strip and the price followed
      // the wrong shape (Summer 2026-07-30). One side changes → the other snaps
      // to the nearest standard value that keeps the image's own ratio.
      function stdSnap(changed) {
        if (!(st.ratioKeep !== false && st.ownPx)) return;
        var ratio = st.ownPx.w / st.ownPx.h;
        var sel = changed === selW ? selH : selW;
        var tgt = changed === selW ? (+selW.value) / ratio : (+selH.value) * ratio;
        var best = null, bd = 1e9;
        Array.prototype.forEach.call(sel.options, function (op) {
          var v = +op.value, dd = Math.abs(v - tgt);
          if (dd < bd) { bd = dd; best = op.value; } });
        if (best != null && sel.value !== best) sel.value = best;
      }
      // Fix ratio + Standard: pick the standard PAIR whose shape is closest to the
      // image, instead of snapping one side off the other (Summer 2026-08-24).
      // stdSnap only moves the OTHER select, so with W parked at the 80cm floor
      // and a 2:1 image the height wanted 40 — below the grid — and it settled on
      // 80x80, a square. ownRatioHonesty then correctly unticked Fix ratio, which
      // read as the checkbox breaking itself. This fixes the cause.
      // want = the size to stay closest to. Passed when the customer already has
      // one (leaving Custom, or re-ticking); omitted only when there is nothing to
      // preserve, and then the 100cm short side is the default, as on upload.
      function stdPairForRatio(want) {
        if (!(st.ratioKeep !== false && st.ownPx)) return false;
        // the opening size must be ON the list the customer will see (2026-08-24)
        var rmap = ratioMap();
        if (rmap) {
          var pick = null, pd = 1e9;
          Object.keys(rmap).forEach(function (k) {
            var w0 = +k, h0 = rmap[k], s0 = Math.min(w0, h0);
            var near = want ? Math.abs(w0 - want[0]) + Math.abs(h0 - want[1])
                            : (s0 >= 100 ? s0 - 100 : (100 - s0) * 1.5);
            if (near < pd) { pd = near; pick = [w0, h0]; } });
          if (pick) { selW.value = String(pick[0]); selH.value = String(pick[1]); return true; }
        }
        var r = st.ownPx.w / st.ownPx.h, ws = [], hs = [];
        // skip greyed options — syncSizeLimits disables the pairs the substrate
        // cannot print, and picking one of those would quote a size we refuse
        Array.prototype.forEach.call(selW.options, function (o) { if (+o.value && !o.disabled) ws.push(+o.value); });
        Array.prototype.forEach.call(selH.options, function (o) { if (+o.value && !o.disabled) hs.push(+o.value); });
        if (!ws.length || !hs.length) return false;
        // SHAPE FIRST, BUT NOT AT ANY PRICE (Summer 2026-08-24). Shape used to be
        // scored 1000× heavier than size, so a shape 0.2% closer beat a print 1.6 m
        // smaller: a 1168×1800 upload opened on 260×400 — a 2.6 m × 4 m canvas at
        // A$1,973 — while the code's own comment promised a 100 cm short side.
        // Anything within 2% of the image's shape is invisible on a wall, so among
        // those the SIZE decides; only when nothing is that close does the closest
        // shape win outright. A short side UNDER 100 counts one and a half times
        // against itself, so a tie (80 and 120 are both 20 off) breaks upward: the
        // engine refuses typed customs under 100 and Europe has no rate down there.
        var TOL = 0.02;
        var fit = null, fd = 1e9, any = null, ad = 1e9;
        ws.forEach(function (w) { hs.forEach(function (h) {
          var err = Math.abs((w / h) / r - 1);
          var s = Math.min(w, h);
          var near = want ? Math.abs(w - want[0]) + Math.abs(h - want[1])
                          : (s >= 100 ? s - 100 : (100 - s) * 1.5);
          if (err <= TOL && near + err * 100 < fd) { fd = near + err * 100; fit = [w, h]; }
          if (err * 100 + near / 1000 < ad) { ad = err * 100 + near / 1000; any = [w, h]; }
        }); });
        var best = fit || any;
        if (!best) return false;
        selW.value = String(best[0]); selH.value = String(best[1]);
        return true;
      }
      // OUTSIDE AUSTRALIA, STEP UP TO A SIZE THAT ACTUALLY QUOTES (Summer
      // 2026-08-24). The UK/EU have no shipping rate under the threshold, so the
      // engine refuses small prints and all five framing tiles show a name and no
      // price. The page already steps up at 0.9 s — but that runs long before
      // anyone uploads, and the image's own shape then moved the size back down:
      // a plain 3:2 camera photo opened on 120×80, which Europe cannot buy. So
      // re-run it after the image lands, walking the same shape upward until one
      // quotes. AU/US quote at the first try and are left exactly as they were.
      st.ownIntlLift = function () {
        if (!WL_AUDEL || st.custom || !st.ownPx || st.ratioKeep === false) return;
        var r = st.ownPx.w / st.ownPx.h, list = [];
        Array.prototype.forEach.call(selW.options, function (ow) {
          Array.prototype.forEach.call(selH.options, function (oh) {
            var w = +ow.value, h = +oh.value;
            if (!w || !h || ow.disabled || oh.disabled) return;
            if (Math.abs((w / h) / r - 1) <= 0.02) list.push([w, h]); }); });
        list.sort(function (a, b) { return a[0] * a[1] - b[0] * b[1]; });
        var area = (+selW.value || 0) * (+selH.value || 0), i = 0;
        while (i < list.length && list[i][0] * list[i][1] < area) i++;
        (function step() {
          if (i >= list.length) return;
          var p = list[i++];
          frCapQuote(p[0], p[1], "rolled", false, 0).then(function (t) {
            if (t == null) { step(); return; }          // refused here — go bigger
            if (p[0] === +selW.value && p[1] === +selH.value) return;
            selW.value = String(p[0]); selH.value = String(p[1]);
            stdChanged();
          });
        })();
      };
      // With Fix ratio ON the standard grid is not a free W x free H — it is the
      // set of PAIRS whose shape matches the image. Picking a width therefore
      // lands on the nearest width that has an exact partner (2:1 + this grid:
      // 160/80, 200/100, 240/120, 280/140, 320/160, 400/200, 480/240, 600/300).
      // Without this, W=300 on a 2:1 image gave H=140 — 7% off — while the tick
      // still claimed the shape was fixed. A control must not lie about its state.
      // If NO width has an exact partner (an awkward ratio like 1.37:1) we fall
      // back to the closest pair stdSnap can find, which is Summer's ruling for
      // that case: "offer the closest standard pair".
      // The width the customer picked is KEPT — it is on the list because the list
      // only carries widths that work (ratioMap). The height follows it. The
      // nearest-offered-width branch below is only for the instant before the
      // list has been rebuilt (first upload), never for a normal pick.
      function snapPairFromW() {
        var map = ratioMap();
        if (!map) return false;
        var want = +selW.value || 0;
        if (map[want] == null) {
          var best = null, bd = 1e9;
          Object.keys(map).forEach(function (k) {
            var d = Math.abs(+k - want); if (d < bd) { bd = d; best = +k; } });
          if (best == null) return false;
          want = best; selW.value = String(best);
        }
        selH.value = String(map[want]);
        return true;
      }
      st.ownSnapPairW = snapPairFromW;
      st.ownStdPair = stdPairForRatio;   // used by ownApplyRatio to open on Standard
      selW.onchange = function () { if (!snapPairFromW()) stdSnap(selW); stdChanged(); };
      selH.onchange = function () { stdSnap(selH); stdChanged(); };
      var stdPanel = sizeBox.querySelector(".wlstdpanel"), cusPanel = sizeBox.querySelector(".wlcuspanel");
      function modeCustom(on) {
        stdPanel.style.display = on ? "none" : "flex";
        cusPanel.style.display = on ? "flex" : "none";
        if (on) {
          // Switching mode NEVER changes the size (Summer 2026-08-24). Custom used
          // to open on whatever was left in the boxes: empty on a fresh visit, and
          // worse, a STALE earlier value afterwards — so Standard 200x100 became
          // Custom 260x130 and the price moved without anyone asking.
          var cw = cusPanel.querySelector(".wlcw2"), ch = cusPanel.querySelector(".wlch2");
          if (+selW.value) cw.value = selW.value;
          if (+selH.value) ch.value = selH.value;
          var w = +cw.value, h = +ch.value;
          if (w && h) { st.custom = true; st.w = w; st.h = h; price().then(function () { drawAll(); }); }
          cusPanel.querySelector(".wlcw2").focus();
        } else {
          // …and the same going back: aim at the size we are leaving, not at a
          // 100cm default, or Custom 280x140 collapsed to Standard 200x100.
          var lw = +cusPanel.querySelector(".wlcw2").value,
              lh = +cusPanel.querySelector(".wlch2").value;
          clearCustom();
          if (!stdPairForRatio(lw && lh ? [lw, lh] : null)) stdSnap(selW);
          stdChanged();
        }
      }
      sizeBox.querySelector(".wlszstd").onclick = function () { szBtns(sizeBox, false); modeCustom(false); };
      sizeBox.querySelector(".wlszcus").onclick = function () { szBtns(sizeBox, true); modeCustom(true); };
      // The engine refuses a CUSTOM quote under 100 cm on the longest side (the
      // "Any size — longest side 100–600 cm" note says so), but the standard grid
      // starts at 80. That gap is why the snap-to-standard below exists: 80x80
      // typed as custom is refused, while 80x80 as the standard variant sells.
      var CUS_MIN = 100;
      var cqt = null;
      function cusType(ev) { clearTimeout(cqt); cqt = setTimeout(function () {
        if (OWN && st.ratioKeep !== false && st.ownPx && ev && ev.target) {
          var asp = st.ownPx.w / st.ownPx.h;
          if (ev.target.classList.contains("wlcw2") && +ev.target.value)
            cusPanel.querySelector(".wlch2").value = Math.round(+ev.target.value / asp);
          else if (ev.target.classList.contains("wlch2") && +ev.target.value)
            cusPanel.querySelector(".wlcw2").value = Math.round(+ev.target.value * asp);
        }
        var w = +cusPanel.querySelector(".wlcw2").value, h = +cusPanel.querySelector(".wlch2").value;
        // Mode changes only when you click (Summer 2026-08-24). This used to snap
        // to Standard whenever the typed pair happened to be on the grid, so typing
        // 240 in Custom silently threw you into Standard mid-keystroke. The snap is
        // still needed BELOW the custom minimum — 80x80 typed as custom is refused
        // by the engine, and landing it on the standard variant is what makes it
        // orderable — so it now fires only there.
        if (w && h && Math.max(w, h) < CUS_MIN && st.ownSnapStd && st.ownSnapStd(0, w, h)) return;
        if (w && h && Math.max(w, h) > 600) {
          if (st.ownSizeErr) st.ownSizeErr("Longest side is 600 cm \u2014 email us for larger.");
          if (st.ownGate) st.ownGate(); return; }
        if (w && h) { st.custom = true; st.w = w; st.h = h;
          price().then(function () { drawAll(); dpiNote(); }); } }, 500); }
      cusPanel.querySelector(".wlcw2").addEventListener("input", cusType);
      cusPanel.querySelector(".wlch2").addEventListener("input", cusType);
      // drag-resize on the wall lands HERE: tick Custom and show the dragged size
      // (the price was already updating, but the boxes stayed empty — confusing)
      // piece 0's drag commit lands in Custom even when it hits an exact standard
      // pair — its i>0 sibling tries snapToStdIfExact first. Same courtesy here.
      st.ownSetCustom = function (w2, h2) {
        if (st.ownSzBtns) st.ownSzBtns(sizeBox, true);
        stdPanel.style.display = "none"; cusPanel.style.display = "flex";
        cusPanel.querySelector(".wlcw2").value = w2;
        cusPanel.querySelector(".wlch2").value = h2;
      };
      // hide the artwork-page custom pill machinery — this page has its own radio pair
      setTimeout(function () { pill.style.display = "none"; cRow.style.display = "none"; }, 0);
      // defaults: 80 × 80, rolled
      selW.value = "80"; selH.value = "80";
      setTimeout(function () { clickHidden(wFsOwn, 80); clickHidden(hFsOwn, 80);
        var rl = frFs && frFs.querySelector('label[data-value-handle*="rolled"]');
        var ri = rl && frFs.querySelector("#" + CSS.escape(rl.getAttribute("for") || ""));
        if (ri && !ri.checked) { ri.click(); ri.dispatchEvent(new Event("change", { bubbles: true })); }
        readSel(); price(); drawAll(); }, 400);
    }

      // ---- canvas edge / white border / finish — print page AND artwork pages
      // (ported 2026-07-30). Edge: STRETCHED only (oak frames cover the sides). Visual chips
      // show what each edge means: image wraps mirrored, or a black / white side.
      function edgeSvg(kind) {
        var side = kind === "black" ? '<polygon points="40,6 48,12 48,40 40,34" fill="#26221d"/>'
          : kind === "white" ? '<polygon points="40,6 48,12 48,40 40,34" fill="#f7f5f1" stroke="#c9c2b6" stroke-width="1"/>'
          : '<polygon points="40,6 48,12 48,40 40,34" fill="url(#wlemg)"/>';
        return '<svg viewBox="0 0 52 46" width="26" height="23" aria-hidden="true">' +
          '<defs><linearGradient id="wlefg" x1="0" y1="0" x2="1" y2="1">' +
          '<stop offset="0" stop-color="#d9d2c4"/><stop offset="1" stop-color="#b9b0a0"/></linearGradient>' +
          '<linearGradient id="wlemg" x1="1" y1="0" x2="0" y2="1">' +
          '<stop offset="0" stop-color="#b9b0a0"/><stop offset="1" stop-color="#d9d2c4"/></linearGradient></defs>' +
          '<rect x="4" y="6" width="36" height="28" fill="url(#wlefg)"/>' + side + "</svg>";
      }
      var edgeRow = document.createElement("div");
      edgeRow.className = "wlc4 body wl-edgerow";
      edgeRow.style.margin = "10px 0 0";         // lives INSIDE the framing section, 10px rhythm
      edgeRow.innerHTML = '<div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center">' +
        '<span style="margin-right:2px">Edge:</span>' +
        // [value, icon, LABEL]. The VALUE is the cart property "Canvas edge" and is
        // read by wl_worker.js and line-item.liquid — it must stay "Mirror image".
        // Summer 2026-08-24 (round 5): the visible label is "Mirror image" again —
        // the shortened "Mirror" of round 3 is reverted — and the order is
        // Mirror image · White · Black on BOTH this row and the border row below,
        // so the Stretched control and the Rolled control read the same way.
        [["Mirror image", "mirror", "Mirror image"], ["White", "white", "White"], ["Black", "black", "Black"]].map(function (x, i) {
          // SAME .wlopt selection-button style as Standard/Custom size (Summer
          // 2026-07-30) — icon left, label right, olive when selected
          return '<label class="wlopt wl-echip' + (i === 0 ? " on" : "") + '" style="display:inline-flex;align-items:center;gap:5px">' +
            '<input type="radio" name="wledge" value="' + x[0] + '"' + (i === 0 ? " checked" : "") +
            ' style="position:absolute;opacity:0;width:1px;height:1px">' +
            edgeSvg(x[1]) + '<span style="font-size:12px;line-height:1.2">' + x[2] + "</span></label>"; }).join("") + "</div>";
      // canvas edge belongs INSIDE the framing options section (Summer 2026-07-30);
      // appended after mount so it lands after the frame note + canvas line
      setTimeout(function () {
        var ff = document.querySelector('fieldset[data-option-name*="fram"]');
        if (ff) { ff.appendChild(edgeRow); ff.appendChild(borderRow); }
        else if (OWN) { enhRow.insertAdjacentElement("beforebegin", edgeRow);
               enhRow.insertAdjacentElement("beforebegin", borderRow); }
      }, 0);
      st.edge = "Mirror image";
      edgeRow.addEventListener("change", function (ev) {
        if (ev.target && ev.target.name === "wledge") {
          st.edge = ev.target.value;
          edgeRow.querySelectorAll(".wl-echip").forEach(function (l) {
            l.classList.toggle("on", l.querySelector("input").checked); });
        } });
      // ---- border for ROLLED prints (Summer 2026-07-23, types 2026-08-17):
      // white / black / mirror-image, 0–20 cm each side, billed as part of the
      // printed size — colour is free, the price line updates as you type
      // border swatch: the printed border wraps the whole picture, so the chip
      // shows a full ring in that colour with the image inside — the counterpart
      // of edgeSvg(), which shows the colour on the side face only.
      function borderSvg(kind) {
        var ring = kind === "black" ? '<rect x="2" y="2" width="48" height="42" fill="#26221d"/>'
          : kind === "white" ? '<rect x="2" y="2" width="48" height="42" fill="#f7f5f1" stroke="#c9c2b6" stroke-width="1"/>'
          : '<rect x="2" y="2" width="48" height="42" fill="url(#wlbmg)"/>';
        return '<svg viewBox="0 0 52 46" width="26" height="23" aria-hidden="true">' +
          '<defs><linearGradient id="wlbfg" x1="0" y1="0" x2="1" y2="1">' +
          '<stop offset="0" stop-color="#d9d2c4"/><stop offset="1" stop-color="#b9b0a0"/></linearGradient>' +
          '<linearGradient id="wlbmg" x1="1" y1="0" x2="0" y2="1">' +
          '<stop offset="0" stop-color="#b9b0a0"/><stop offset="1" stop-color="#d9d2c4"/></linearGradient></defs>' +
          ring + '<rect x="9" y="8" width="34" height="30" fill="url(#wlbfg)"/></svg>';
      }
      var borderRow = document.createElement("div");
      borderRow.className = "wlc4 body wl-borderrow";
      borderRow.style.margin = "10px 0 0";        // lives INSIDE the framing section, 10px rhythm
      // size first, colour second (Summer 2026-08-17); colour greys out at 0 cm —
      // a coloured selection next to "0 cm" read as if a border was coming.
      // ONE line (Summer 2026-08-24): size and colour share a single flex row.
      // Summer 2026-08-24 (round 5): the swatch icons are BACK, and the labels and
      // order now match the Edge row exactly (Mirror image · White · Black) — the
      // Rolled control and the Stretched control must read the same way. The
      // "Border colour:" label of round 1 stays deleted; that is what buys the
      // width. The row wraps to a second line on a phone, which is expected.
      borderRow.innerHTML = '<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap">' +
        '<label style="cursor:pointer;display:inline-flex;align-items:center;gap:6px">' +
        'Border: <input class="wlborder" inputmode="numeric" type="number" min="0" max="20" step="1" value="0" ' +
        'style="width:44px;border:1px solid var(--wlbd,#ccc)"> cm</label>' +
        '<div class="wl-bcolours" style="display:flex;gap:6px;flex-wrap:wrap;align-items:center">' +
        [["Mirror image", "mirror"], ["White", "white"], ["Black", "black"]].map(function (x) {
          // SAME .wlopt selection-button style as the Canvas edge chips.
          // Selected by VALUE, never by position: the default border colour is
          // MIRROR IMAGE (Summer 2026-08-24 — "default border and edge are always
          // mirror image"), matching the Canvas edge row, which already leads
          // with it. Keep this a value test so the lit chip can never drift from
          // st.borderType below.
          var sel = x[1] === "mirror";
          return '<label class="wlopt wl-bchip' + (sel ? " on" : "") + '" style="display:inline-flex;align-items:center;gap:5px">' +
            '<input type="radio" name="wlbordertype" value="' + x[1] + '"' + (sel ? " checked" : "") +
            ' style="position:absolute;opacity:0;width:1px;height:1px">' +
            borderSvg(x[1]) + '<span style="font-size:12px;line-height:1.2">' + x[0] + "</span></label>"; }).join("") + "</div></div>";
      st.border = 0;
      st.borderType = "mirror";      // Summer 2026-08-24: mirror is the default
      borderRow.addEventListener("change", function (ev) {
        if (ev.target && ev.target.name === "wlbordertype") {
          st.borderType = ev.target.value;
          borderRow.querySelectorAll(".wl-bchip").forEach(function (l) {
            l.classList.toggle("on", l.querySelector("input").checked); });
        } });
      // 0 cm = there is no border yet, so a selected colour would be a lie —
      // the whole colour row greys out (never hidden, Summer 2026-08-17) until
      // cm > 0; radios also disable so keyboard/tab users can't pick a colour
      function borderChipsDim() {
        var live = (st.border || 0) > 0;
        var cs = borderRow.querySelector(".wl-bcolours");
        if (cs) { cs.style.opacity = live ? "" : ".35"; cs.style.pointerEvents = live ? "" : "none"; }
        borderRow.querySelectorAll('input[name="wlbordertype"]').forEach(function (i) { i.disabled = !live; });
      }
      st.borderChipsDim = borderChipsDim;
      borderChipsDim();
      // debounced: spinner clicks and digit-by-digit typing coalesce into ONE
      // quote, so the price moves once, not in surprise jumps (Summer 2026-07-30)
      var borderTimer = null;
      borderRow.querySelector(".wlborder").addEventListener("input", function () {
        var v = Math.max(0, Math.min(20, Math.round(+this.value || 0)));
        if (String(v) !== this.value && this.value !== "") this.value = v;
        st.border = v;
        borderChipsDim();   // grey/un-grey immediately — only the quote debounces
        clearTimeout(borderTimer);
        borderTimer = setTimeout(function () {
          price().then(function () { drawAll(); if (st.ownDpiNote) st.ownDpiNote(); });
        }, 450);
      });
      // ---- matte / glossy finish (Summer 2026-07-23) — sits before the extras
      var finRow = document.createElement("div");
      finRow.className = "wlc4 body";
      // Finish gets a real section heading like Framing Options (Summer 2026-07-30)
      // Matte/Glossy are BUTTONS like every other selection (Summer 2026-07-30)
      // "Canvas finish" not "Finish" (Summer 2026-08-17) — buyers read the bare
      // word as a FRAME finish; the property key stays "Finish" (carts/pipeline)
      finRow.innerHTML = '<p class="wlsec" style="margin-bottom:10px">Canvas finish</p>' +
        '<div style="display:flex;gap:8px;flex-wrap:wrap">' +
        ["Matte", "Glossy"].map(function (x, i) {
          return '<button type="button" class="wlopt wlfinb' + (i === 0 ? " on" : "") +
            '" data-v="' + x + '">' + x + "</button>"; }).join("") + "</div>";
      if (OWN) enhRow.insertAdjacentElement("beforebegin", finRow);
      else setTimeout(function () {
        // artwork pages (Summer 2026-07-30): Finish sits right after the framing
        // section, before the Colour Filter — mirroring the print page order
        var ff2 = document.querySelector('fieldset[data-option-name*="fram"]');
        var fb2 = ff2 && (ff2.closest(".product-info__block-item") || ff2);
        if (fb2) fb2.insertAdjacentElement("afterend", finRow);
      }, 0);
      // the ADD-ONS heading is GONE (Summer 2026-08-24) — the two tick-box lines
      // read for themselves and the heading only added a bar of dead space.
      st.finish = "Matte";
      finRow.addEventListener("click", function (ev) {
        var b = ev.target.closest(".wlfinb"); if (!b) return;
        st.finish = b.dataset.v;
        finRow.querySelectorAll(".wlfinb").forEach(function (x) {
          x.classList.toggle("on", x === b); });
      });
      st.ownEdgeVis = function () {
        edgeRow.style.display = st.framing === "stretched" ? "" : "none";
        borderRow.style.display = st.framing === "rolled" ? "" : "none";
      };
      st.ownEdgeVis();
    // Summer 2026-07-15: the canvas + panel spec now reads as a plain line under
    // the framing note — same font, no chip background. The shaded green box that
    // used to sit above Add to Cart is gone entirely.
    // pNote is the second half of the ONE spec line above — not its own row
    var pNote = frTxt.nextElementSibling;
    // fold the theme's shipping note into the box, once
    var shipLine = Array.prototype.find.call(sec.querySelectorAll(".product-info__block-item"),
      function (b) { return /incl\.?\s*au\s*shipping/i.test(b.textContent) &&
        !b.querySelector("form[action*='/cart/add']") && !b.querySelector(".wlc4"); });
    var shipNote = document.createElement("div");
    shipNote.className = "nt wlship";
    // intl (Summer 2026-08-01): non-AU visitors get the approved worldwide
    // wording — AU keeps the original chips exactly. NZ joined intl 2026-08-23.
    var wlIntlChips = (function () { try { var cc = window.Shopify && Shopify.country;
      return cc && cc !== "AU"; } catch (e) { return false; } })();
    shipNote.innerHTML = (wlIntlChips
      ? '<span class="wlchip">Incl. worldwide shipping &amp; insurance</span>' +
        '<span class="wlchip">Made to order — 3 days production, 1–2 weeks delivery</span>'
      : '<span class="wlchip">Incl. AU shipping, GST &amp; insurance</span>' +
        '<span class="wlchip">Made to order, 2–3 weeks</span>') +
      (OWN ? '<span class="wlchip">No oversize surcharges</span>' : '');
    shipNote.style.cssText = "font-weight:400;color:#1b1b1b;margin:6px 0 0";
    if (shipLine) shipLine.style.display = "none";
    // the 380g canvas / panel spec now lives in the checkout card — don't repeat it
    // in the body (Summer 2026-07-14)
    var themeMatBlock = Array.prototype.find.call(sec.querySelectorAll(".product-info__block-item"),
      function (b) { return /380\s*g/i.test(b.textContent) && (b.textContent || "").length < 160 &&
        !b.querySelector("form[action*='/cart/add']") && !b.querySelector(".wlc4"); });
    if (themeMatBlock) themeMatBlock.style.display = "none";
    // Summer 2026-07-15: shipping + made-to-order sit UNDER THE PRICE.
    if (priceBlock) priceBlock.insertAdjacentElement("afterend", shipNote);
    else form.insertAdjacentElement("beforebegin", shipNote);
    try {                                                     // WL buttons wear the THEME's button skin
      var sysb = form.querySelector("button[type=submit],[name=add]");
      if (sysb) { var sbc = getComputedStyle(sysb);
        var sbg = sbc.backgroundColor;
        if (!sbg || /rgba\(.*, 0\)$/.test(sbg) || sbg === "transparent") {
          try { sbg = getComputedStyle(sysb, "::before").backgroundColor; } catch (e7) {}
        }
        var opaque = sbg && sbg !== "transparent" && !/rgba\(.*, 0\)$/.test(sbg);
        [["--wlsysbg", opaque ? sbg : null], ["--wlsysfg", opaque ? sbc.color : null],
         ["--wlsysrad", sbc.borderRadius], ["--wlsysfs", sbc.fontSize],
         ["--wlsysls", sbc.letterSpacing], ["--wlsystt", sbc.textTransform]]
          .forEach(function (kv) { if (kv[1] != null) sec.style.setProperty(kv[0], kv[1]); }); }
    } catch (e8) {}

    function q(s) { return cRow.querySelector(s) || lRow.querySelector(s); }
    function dims() {
      if (st.drag) return st.drag;
      if (OWN && st.active > 0 && st.ownSizeOf) {
        var sz = st.ownSizeOf(st.active);
        if (sz) return sz;
      }
      return st.custom ? [st.w, st.h] : st.size;
    }
    function orderDims() { return st.custom ? [st.w, st.h] : st.size; }
    function panelText(d) { var n = panelsFor(d[0], d[1]);
      return canvasTypeFor(d[0], d[1]) + ", " + n + (n > 1 ? " panels" : " panel") + "."; }
    // ONE panel/canvas display (Summer 2026-07-31): the SELECTED VARIANT'S
    // metafields (custom.canvastype / custom.panels) are the authority — the
    // theme's liquid block renders them and stays as the HIDDEN data source;
    // price() mirrors it under the framing option. Formula only for typed
    // customs (no variant exists). The border NEVER changes the panel count.
    function matSrcRead() {
      var b = Array.prototype.find.call(sec.querySelectorAll(".product-info__block-item"),
        function (x) { return /\d+\s*g[^-]{0,40}Canvas\s*-\s*\d+/.test((x.textContent || "").trim()) &&
          !x.querySelector("form[action*='/cart/add']") && !x.querySelector(".wlc4"); });
      if (!b) return null;
      b.style.display = "none";           // theme morphs re-show it — every read re-hides
      var m = /(\d+\s*g[^-]{0,40}Canvas)\s*-\s*(\d+)/.exec((b.textContent || "").trim());
      return m ? { canvas: m[1].trim(), panels: +m[2] } : null;
    }
    function panelInfo(d) {
      var mf = (!st.custom && !OWN) ? matSrcRead() : null;
      return { canvas: mf ? mf.canvas : canvasTypeFor(d[0], d[1]),
               n: mf ? mf.panels : panelsFor(d[0], d[1]) };
    }
    function capText(d) { var n = panelsFor(d[0], d[1]);
      return d[0] + "×" + d[1] + " cm" + (n > 1 ? " · " + n + " panels" : "") +
        " · " + (FR_SHORT[st.framing] || st.framing) +
        (st.look !== "natural" ? " · " + LABELS[st.look] + " filter" : "") +
        (st.custom || st.drag ? " · custom" : ""); }

    // 2026-09-23 speed: /api/quote is pure maths, so one page asks each exact
    // question once (a page load sent 16 calls for 10 distinct questions).
    // Keyed on the full request body; failures are never kept; every caller
    // gets its own copy of the answer.
    var quoteMemo = {};
    function quoteRaw(w, h, framing, custom, border, idx, typed) {
      // typed = the customer actually typed the size; a border alone is not typed
      // and carries no A$50 fee (Summer 2026-07-31). Defaults to `custom` for
      // callers with no border in play.
      var body = JSON.stringify({ w: w, h: h, framing: framing, substrate: "canvas", custom: custom,
            typed: typed === undefined ? !!custom : !!typed,
            own: OWN, border: border || 0,
            // buyer country so the worker can refuse a size that has no rate to
            // the UK/EU before the customer reaches a dead-end checkout (r2)
            country: (window.Shopify && Shopify.country) || "",
            // artwork pages price on the artwork's OWN curve (Summer 2026-07-30)
            index: OWN ? undefined : (idx || (card && card.index) || undefined) });
      var go = function () {
        return fetch(API + "/api/quote", { method: "POST", headers: { "content-type": "application/json" }, body: body })
          .then(function (x) { return x.json(); }); };
      var copy = function (r) { return JSON.parse(JSON.stringify(r)); };
      if (quoteMemo[body]) return quoteMemo[body].then(copy);
      // one silent retry, then a readable failure — a dropped response used to
      // leave the price silently stale ("sometimes works", Summer 2026-07-30)
      var p = go()
        .catch(function () { return new Promise(function (res) { setTimeout(res, 600); }).then(go); })
        .catch(function () { return { ok: false, message: "Connection hiccup — please try that size again." }; });
      quoteMemo[body] = p;
      p.then(function (r) { if (!r || r.ok === false) delete quoteMemo[body]; });
      return p.then(copy); }
    // framing captions (2026-07-30, print page): name + live price under every
    // tile, so the rolled→oak price jump is visible BEFORE the click, not after.
    // Quotes are cached per size|framing|border; /api/quote is pure maths.
    var FR_CAP = { rolled: "Rolled print", stretched: "Stretched", natural_oak: "Natural Oak",
      black_oak: "Black Oak", white_oak: "White Oak" };
    var frCapCache = {}, frCapSeq = 0;
    function frCapQuote(w, h, k, asC, bb) {
      // same custom→standard fallback as the piece rows (pieceQuoteD): a
      // standard 80×80 in a set must not be priced as a custom cut (2026-07-30)
      // artwork standard sizes read the REAL variant price locally (VARP2) —
      // exact by definition and no round-trip (Summer 2026-07-31)
      if (!OWN && !asC && !bb) {
        var vp2 = VARP2[w + "x" + h + "|" + k];
        if (vp2 !== undefined) return Promise.resolve(vp2);
      }
      var key = w + "x" + h + "|" + k + "|" + bb;
      if (frCapCache[key] !== undefined) return Promise.resolve(frCapCache[key]);
      // engine quotes are AUD — normalise to presentment HERE so the caption
      // maths (set sums, discounts) all happens in one currency space (the
      // VARP2 branch above is already presentment)
      return quoteRaw(w, h, k, asC || bb > 0, bb, undefined, asC)
        .then(function (r) {
          if (r && r.ok) return toPres(r.total);
          return quoteRaw(w, h, k, false, bb, undefined, false).then(function (r2) {
            return (r2 && r2.ok) ? toPres(r2.total) : null; });
        })
        .then(function (t) { frCapCache[key] = t; return t; })
        .catch(function () { return null; });
    }
    function frCaps() {
      // artwork pages too since 2026-07-31 (Summer: same price-per-tile as the
      // print page) — standard sizes price from VARP2, customs/borders quote
      var f = document.querySelector('fieldset[data-option-name*="fram"]'); if (!f) return;
      var d = orderDims(); if (!d || !d[0] || !d[1]) return;
      var labs = f.querySelectorAll("label.block-swatch[data-value-handle]");
      if (!labs.length) return;
      // SETS (Summer 2026-07-30): the tile price answers "what will I pay for
      // this framing" — so with several pieces it shows the SET total (all
      // sized pieces, discount applied), matching the big price. One piece:
      // that piece's price.
      var n = st.bulkN || 1, disc = 0, sizes = [];
      if (n > 1 && st.ownSizeOf) {
        disc = n >= 4 ? .20 : n === 3 ? .15 : .10;
        for (var i = 0; i < n; i++) { var sz = st.ownSizeOf(i); if (sz) sizes.push(sz); }
      } else sizes.push(d);
      var asC = !!st.custom, seq = ++frCapSeq, jobs = [];
      Array.prototype.forEach.call(labs, function (lab) {
        var k = frKey(lab.getAttribute("data-value-handle") || "");
        var bb = k === "rolled" ? (st.border || 0) : 0;
        var pr = Promise.all(sizes.map(function (sz2) {
          return frCapQuote(sz2[0], sz2[1], k, asC, bb); }))
          .then(function (qs) {
            if (qs.some(function (q) { return q == null; })) return null;
            var sum = 0;
            qs.forEach(function (q) { sum += Math.ceil(q * (1 - disc)); });
            return sum;
          });
        jobs.push(pr.then(function (total) { return { lab: lab, k: k, total: total }; }));
      });
      Promise.all(jobs).then(function (res) {
        if (seq !== frCapSeq) return;                       // a newer size took over
        res.forEach(function (x) {
          var cap = x.lab.querySelector(".wlfrcap");
          if (!cap) { cap = document.createElement("span"); cap.className = "wlfrcap";
            x.lab.appendChild(cap); }
          cap.innerHTML = "<b>" + FR_CAP[x.k] + "</b>" +
            (x.total != null ? ((n > 1 ? "Set " : "") + money(x.total)) : "");
        });
      });
    }
    async function price() {
      var d = orderDims();
      var bb = (st.framing === "rolled" && st.border > 0) ? st.border : 0;   // border bills on artwork pages too (2026-07-30)
      var asC = st.custom || bb > 0;   // a bordered rolled print bills like a custom size
      // only the LATEST call may touch the UI — like frCaps' seq guard; without
      // it a slow older quote could land after a newer one and show the wrong
      // price for the typed size (Summer 2026-07-30)
      var pseq = price._seq = (price._seq || 0) + 1;
      // A PRICE ON SCREEN MUST BELONG TO THE SIZE ON SCREEN (Summer 2026-08-24).
      // The seq guard below already throws away a late answer, and totalCalc()
      // dims a stale total — but neither runs until the NEW quote lands, and on
      // a cold worker that can take seconds. In that window the previous size's
      // price sat there at full opacity: 200x80 was showing $337 while the
      // dropdowns read 200x200, whose real price is $815. Dim it the instant the
      // size changes, synchronously, before we await anything.
      var wantKey = d[0] + "x" + d[1] + "|" + st.framing + "|" + bb;
      if (!(st.quote && st.quote.ok && st.quote.wlFor === wantKey)) {
        var mpW = curPrice();
        if (mpW) mpW.style.opacity = ".35";
        var spW = document.querySelector(".product-sticky-bar sale-price");
        if (spW) spW.style.opacity = ".35";
      }
      try {
        var r = await quoteRaw(d[0], d[1], st.framing, asC, bb, undefined, !!st.custom);
        if (pseq !== price._seq) return false;
        matLine.textContent = "";
        if (!r.ok) {
          st.quote = null;
          // Summer 2026-08-24 ("why is the price in international so pale?"):
          // the dim set above says "this number may not match the size yet". A
          // REFUSED quote never cleared it, so the price stayed at .35 opacity
          // for the rest of the visit. On the .com that happens constantly —
          // every rolled print under the UK/EU delivery minimum is refused
          // (reason small_rolled_ukeu) — and never on the .com.au.
          // That refusal is about DELIVERY, not about the price: the engine
          // priced the size fine and now sends the number with the refusal, so
          // we WRITE IT and undim. The note under the size box carries the
          // reason. Both of Summer's rules hold — the price on screen belongs to
          // the size on screen, and it is not pale.
          // Any OTHER refusal (impossible size) leaves the dim on: there is no
          // number for that size, so what stands is the previous size's price.
          if (r.reason === "small_rolled_ukeu" && typeof r.total === "number") {
            var enhX = (st.enh ? 5 : 0), kitX = (st.kit && kit.price ? +kit.price : 0);
            var mpX = curPrice();
            if (mpX) { mpX.textContent = moneyMain(toPres(r.total + enhX) + kitX);
                       mpX.style.opacity = ""; mpX.dataset.wlSet = "1"; }
            var spX = document.querySelector(".product-sticky-bar sale-price");
            if (spX) { spX.textContent = moneyMain(toPres(r.total + enhX) + kitX);
                       spX.style.opacity = ""; spX.dataset.wlSet = "1"; }
          }
          if (st.custom) { q(".wlc-note").textContent = r.message; pNote.textContent = ""; }
          if (OWN && st.ownSizeErr) st.ownSizeErr(r.message || "That size is not possible.");
          return false; }
        // a good quote clears any stale size warning left by an intermediate
        // keystroke (e.g. the 180×1 while "120" was still being typed)
        if (st.custom) q(".wlc-note").textContent = WLC_NOTE;
        if (OWN && st.ownSizeErr) st.ownSizeErr("");
        st.quote = r;
        // the quote remembers WHAT it priced (2026-07-31): the page total once
        // summed a quote for one size while add-to-cart sent another — page said
        // $2,991, the cart said $3,184. A quote that no longer matches the
        // current size/framing/border counts as missing, never as a price.
        st.quote.wlFor = d[0] + "x" + d[1] + "|" + st.framing + "|" + bb;
        var mainPrice = curPrice();
        if (mainPrice) mainPrice.style.opacity = "";          // matching quote — trust it again
        var spOk = document.querySelector(".product-sticky-bar sale-price");
        if (spOk) spOk.style.opacity = "";
        var kitExtra = (st.kit && kit.price ? kit.price : 0) + (st.enh ? 5 : 0);
        // split the add-ons: kit price is presentment, the $5 enhancement is AUD
        var kitOnly = (st.kit && kit.price ? +kit.price : 0), enhAud = (st.enh ? 5 : 0);
        // Print page (Summer's ruling 2026-07-30): ONE price system — the engine
        // quote — for every size, standard or custom. The Shopify variant table
        // had drifted from the engine (140×220 black oak: variant $1,866 vs
        // engine $1,744) and the framing captions quoted the engine while the
        // big price showed the variant. Display AND checkout now both use the
        // engine (ownAdd routes every piece through /api/native-line, which
        // reprices server-side with the same customQuote).
        if (OWN || asC || st.look !== "natural") {
          if (mainPrice) { mainPrice.textContent = moneyMain(toPres(r.total + enhAud) + kitOnly); wlAfterpay(r.total + kitExtra); }
        } else if (kitExtra) {
          var idInp0 = sec.querySelector('input[name="id"][form="' + form.id + '"]') || form.querySelector("[name=id]");
          var vp = idInp0 && VARP[+idInp0.value];
          if (mainPrice && vp) { mainPrice.textContent = moneyMain(vp + kitOnly + toPres(enhAud)); wlAfterpay(vp + kitExtra); }
        } else {
          if (mainPrice && priceMem.orig != null && mainPrice.dataset.wlSet === "1") {
            mainPrice.innerHTML = priceMem.orig; delete mainPrice.dataset.wlSet; }
        }
        if (mainPrice && (OWN || asC || st.look !== "natural" || kitExtra)) mainPrice.dataset.wlSet = "1";
        // the sticky add-to-cart bar shows its own sale-price — keep it in step
        var sp = document.querySelector(".product-sticky-bar sale-price");
        if (sp) {
          if (OWN || asC || st.look !== "natural") {
            if (stickyMem.orig == null) stickyMem.orig = sp.innerHTML;
            sp.textContent = moneyMain(toPres(r.total + enhAud) + kitOnly); sp.dataset.wlSet = "1";
          } else if (kitExtra) {
            var idInp1 = sec.querySelector('input[name="id"][form="' + form.id + '"]') || form.querySelector("[name=id]");
            var vp1 = idInp1 && VARP[+idInp1.value];
            if (vp1) { if (stickyMem.orig == null) stickyMem.orig = sp.innerHTML;
              sp.textContent = moneyMain(vp1 + kitOnly + toPres(enhAud)); sp.dataset.wlSet = "1"; }
          } else if (stickyMem.orig != null && sp.dataset.wlSet === "1") {
            sp.innerHTML = stickyMem.orig; delete sp.dataset.wlSet; stickyMem.orig = null;
          }
        }
        // Summer 2026-07-14: read as shaded, unbreakable blocks — size | frame ·
        // canvas · panels | shipping · time (shipping block lives in shipNote).
        // size/frame already read off the pickers directly above — no need to
        // repeat them; this line carries only the canvas + panel count.
        var pi = panelInfo(d);
        pNote.textContent = pi.canvas + " · " + pi.n + (pi.n > 1 ? " panels" : " panel");
        if (OWN && st.ownBulkTotal) st.ownBulkTotal();
        frCaps();
        return true;
      } catch (e) { console.warn("wl price", e); return false; }
    }

    function neutraliseChecked(on) {
      if (!sizeFs) return;
      sizeFs.querySelectorAll("[data-wl-neut]").forEach(function (l) {
        l.removeAttribute("style"); l.removeAttribute("data-wl-neut"); });
      if (!on) return;
      var r0 = sizeFs.querySelector("input[type=radio]:checked");
      var checked = r0 && sizeFs.querySelector('label[for="' + r0.id + '"]');
      var plainInp = Array.prototype.find.call(
        sizeFs.querySelectorAll("input[type=radio]"), function (i) { return !i.checked; });
      var plain = plainInp && sizeFs.querySelector('label[for="' + plainInp.id + '"]');
      if (!checked || !plain) return;
      var cs = getComputedStyle(plain);
      ["background-color", "color", "border-color", "font-weight", "box-shadow", "outline"]
        .forEach(function (prop) { checked.style.setProperty(prop, cs.getPropertyValue(prop), "important"); });
      checked.setAttribute("data-wl-neut", "1");
    }
    function setCustomUI(on) {
      pill.classList.toggle("on", on);
      cRow.style.display = on ? "" : "none";
      if (sizeFs) sizeFs.classList.toggle("wl-dim", on);
      neutraliseChecked(on);
    }
    function clearCustom() {
      st.custom = false; setCustomUI(false);
      q(".wlc-note").textContent = WLC_NOTE;
    }
    function applyCustom(w, h, fromDrag) {
      st.custom = true; st.w = w; st.h = h; setCustomUI(true);
      if (OWN && st.ownSetCustom) st.ownSetCustom(w, h);   // drag fills the visible Custom boxes
      q(".wlc-w").value = w; q(".wlc-h").value = h;
      track("wl_custom_quote", { w: w, h: h });
      price().then(function () { drawAll(); if (OWN && st.ownDpiNote) st.ownDpiNote(); });
    }
    pill.onclick = function () {
      if (pill.classList.contains("on")) { clearCustom(); price(); drawAll(); return; }
      setCustomUI(true);
      artLock(+q(".wlc-w").value ? q(".wlc-w") : q(".wlc-h"));
      var w = +q(".wlc-w").value, h = +q(".wlc-h").value;
      if (w && h) applyCustom(w, h); else q(".wlc-w").focus();
    };
    // ---- Fix ratio for the artwork custom boxes (Summer 2026-08-24) --------
    // st.artFix is deliberately SEPARATE from st.ratioKeep: that one belongs to
    // the print page's size machinery and is read by five other functions.
    // The ratio source is st.aspect, set from the artwork image once it loads
    // (the loadImg at the foot of mount()) — until then there is nothing to lock
    // to and the boxes behave exactly as they always did.
    st.artFix = true;
    function artLock(srcEl) {
      var r = st.aspect;
      if (st.artFix === false || !r || !srcEl) return;
      var wI = q(".wlc-w"), hI = q(".wlc-h");
      if (srcEl === wI && +wI.value) hI.value = Math.round(+wI.value / r);
      else if (srcEl === hI && +hI.value) wI.value = Math.round(+hI.value * r);
    }
    // AUTO-APPLY while typing (no Apply button)
    var typeTimer = null;
    function autoApply(ev) {
      clearTimeout(typeTimer);
      var src = ev && ev.target;
      typeTimer = setTimeout(function () {
        artLock(src);                      // the side you typed last wins
        var w = +q(".wlc-w").value, h = +q(".wlc-h").value;
        if (w && h) applyCustom(w, h);
      }, 600); }
    q(".wlc-w").addEventListener("input", autoApply);
    q(".wlc-h").addEventListener("input", autoApply);
    (function () {
      var cb = cRow.querySelector(".wlcfixb"); if (!cb) return;
      cb.addEventListener("change", function () {
        st.artFix = cb.checked;
        if (!cb.checked) return;           // unticking never moves a size
        var wI = q(".wlc-w"), hI = q(".wlc-h");
        artLock(+wI.value ? wI : hI);      // re-derive; width is the side that wins
        var w = +wI.value, h = +hI.value;
        if (w && h) applyCustom(w, h);
      });
    })();
    // the custom boxes live INSIDE the theme size fieldset — their native
    // "change" (fired on blur, e.g. moving W → H) must never reach the
    // fieldset listeners or it reads as a standard-size pick and the row is
    // cleared mid-typing (Summer's bug 2026-07-30)
    cRow.addEventListener("change", function (e) { e.stopPropagation(); });
    // Enter = apply now, never the form's implicit submit (which re-selected
    // the standard size and hid the row)
    cRow.addEventListener("keydown", function (e) {
      if (e.key !== "Enter") return;
      e.preventDefault(); e.stopPropagation();
      clearTimeout(typeTimer);
      artLock(document.activeElement === q(".wlc-h") ? q(".wlc-h") : q(".wlc-w"));
      var w = +q(".wlc-w").value, h = +q(".wlc-h").value;
      if (w && h) applyCustom(w, h);
      else (w ? q(".wlc-h") : q(".wlc-w")).focus();
    });
    lRow.querySelectorAll(".dt").forEach(function (b) { b.onclick = function () { setLook(b.dataset.k, b); }; });
    function setLook(k, btn) {
      lRow.querySelectorAll(".dt").forEach(function (x) { x.classList.remove("on"); });
      (btn || lRow.querySelector('.dt[data-k="' + k + '"]')).classList.add("on");
      st.look = k;
      q(".wlc-ln").textContent = (k === "natural" ? "None — as painted." :
        LABELS[k] + " — applied by the artist at print resolution." +
        (card.is_le ? " Limited editions with a filter are issued as a separate open line." : ""));
      st.art = k === "natural" ? st.artBase : (st.artBase && lookCanvas(st.artBase, k));
      price(); drawAll(); }

    // read the CHECKED radio's label — radio values are numeric ids on this theme
    function readFs(fs) {
      if (!fs) return null;
      var r = fs.querySelector("input[type=radio]:checked");
      if (!r) return null;
      var lb = fs.querySelector('label[for="' + r.id + '"]');
      return lb ? (lb.getAttribute("data-value-handle") || lb.textContent || "") : (r.value || "");
    }
    function frFullText() {
      if (!frFs) return "";
      var r = frFs.querySelector("input[type=radio]:checked");
      var lb = r && frFs.querySelector('label[for="' + r.id + '"]');
      if (!lb) return "";
      // read the THEME's own span, not our injected price caption (2026-07-30)
      var sp = lb.querySelector("span:not(.wlfrcap)");
      return (sp ? sp.textContent : lb.textContent).replace(/\s+/g, " ").trim();
    }
    function readSel() {
      // theme morphs replace the fieldsets — the cached nodes can be detached,
      // so re-resolve live before reading (a stale read left st.framing on
      // "rolled" after the natural-oak auto-select: custom quotes underpriced)
      sizeFs = document.querySelector('fieldset[data-option-name*="size"]') || sizeFs;
      frFs = document.querySelector('fieldset[data-option-name*="fram"]') || frFs;
      if (OWN) {
        wFsOwn = document.querySelector('fieldset[data-option-name*="width"]') || wFsOwn;
        hFsOwn = document.querySelector('fieldset[data-option-name*="height"]') || hFsOwn;
        // THE DROPDOWN IS THE SIZE (Summer 2026-08-24). This used to read the size
        // back off Shopify's hidden Width/Height radios. Clicking those is a
        // REQUEST, not a fact: Shopify rebuilds the fieldsets ~150 ms later and can
        // drop the second click, so a 260×400 pick came back as 260×120 — the wall,
        // the caption, all five framing prices and the cart line followed the theme
        // while the visible row still read 400, and the page quoted €409 for a
        // €1,252 print. ONE truth now: the customiser's own selects. The radios are
        // kept in step by assertPicked() for the variant id alone, and are read here
        // only before the size box has mounted (first paint).
        var ownSz = st.ownStdSize ? st.ownStdSize() : null;
        if (ownSz) st.size = ownSz;
        else { var gw = ownPickNum(wFsOwn), gh = ownPickNum(hFsOwn);
          if (gw && gh) st.size = [gw, gh]; }
      } else {
        var sv = readFs(sizeFs), m = sv && /^(\d+)\s*[-x×\s]+(\d+)/.exec(String(sv).trim());
        if (m) st.size = [+m[1], +m[2]];
      }
      var fv = readFs(frFs);
      if (fv) st.framing = frKey(String(fv));
      if (st.ownEdgeVis) st.ownEdgeVis();   // edge/border rows follow framing on all pages
      frTxt.textContent = frFullText();
    }
    function ownPickNum(fs) {
      if (!fs) return 0;
      var i = fs.querySelector("input:checked"); if (!i) return 0;
      var lab = i.closest("label") || (i.id && fs.querySelector('label[for="' + i.id + '"]'));
      var m2 = /(\d{2,3})/.exec((lab && lab.textContent) || "");
      return m2 ? +m2[1] : 0; }
    function onPick(e) {
      // typing in the custom W/H boxes is not a size pick (belt-and-braces
      // with the cRow stopPropagation above)
      if (e && e.target && cRow.contains(e.target)) return;
      readSel(); clearCustom(); price(); drawAll(); }
    function onSizeClick(e) {
      var lb = e.target.closest("label.block-swatch");
      if (lb && !lb.classList.contains("wl-cpill") && st.custom) onPick(); }
    if (sizeFs) { sizeFs.addEventListener("change", onPick);
      sizeFs.addEventListener("click", onSizeClick); }
    if (OWN && hFsOwn) { hFsOwn.addEventListener("change", onPick);
      hFsOwn.addEventListener("click", onSizeClick); }
    var frAuto = false;
    function onFramingPick() { if (!frAuto) st.frUser = true;    // framing keeps custom size
      readSel(); price(); drawAll(); }
    if (frFs) frFs.addEventListener("change", onFramingPick);
    // default view = the 4th standard size (only when the URL doesn't pin a
    // variant). OUTSIDE AUSTRALIA it is the FIRST size actually on show instead
    // (Summer 2026-08-23) — EU/UK hide the smallest tiles for want of a shipping
    // rate, so "first" has to mean first visible, never a hidden tile.
    if (sizeFs && (WL_AUDEL || stdSizes[3]) && location.search.indexOf("variant=") < 0) {
      setTimeout(function () {
        var lb4 = null;
        if (WL_AUDEL) lb4 = Array.prototype.find.call(
          sizeFs.querySelectorAll("label[data-value-handle]"),
          function (l) { return l.offsetParent !== null; }) || null;
        if (!lb4 && stdSizes[3]) {
          var h4 = handleize(stdSizes[3]);
          lb4 = sizeFs.querySelector('label[data-value-handle="' + h4 + '"]') ||
                sizeFs.querySelector('label[data-value-handle^="' + h4 + '"]');
        }
        var inp4 = lb4 && sizeFs.querySelector("#" + CSS.escape(lb4.getAttribute("for")));
        if (lb4 && !(inp4 && inp4.checked)) lb4.click();
      }, 400);
    }

    if (frFs) {
      // the size auto-click above morphs the theme blocks: frFs cached at mount
      // is detached by 800ms — re-resolve the live fieldset before clicking, and
      // retry once at 2s in case the morph was still in flight at the first pass.
      // Rolled is never the default (Summer): a ?variant link keeps its framing
      // unless that framing is Rolled; the user's own click always wins.
      var autoOak = function () {
        if (OWN || st.frUser) return;
        var f = document.querySelector('fieldset[data-option-name*="fram"]') || frFs;
        // OUTSIDE AUSTRALIA the default is ROLLED (Summer 2026-08-23): stretched
        // and framed pieces deliver within Australia, so opening on an oak frame
        // sold overseas visitors the one thing that cannot fly to them. The
        // options stay visible and clickable — only the opening pick changes.
        // A ?variant link is an explicit choice and always wins here.
        if (WL_AUDEL) {
          if (location.search.indexOf("variant=") >= 0) return;
          var lbr = f.querySelector('label[data-value-handle*="rolled"]');
          var inr = lbr && f.querySelector("#" + CSS.escape(lbr.getAttribute("for")));
          if (lbr && !(inr && inr.checked)) {
            frAuto = true; lbr.click();
            readSel(); price(); drawAll();
            setTimeout(function () { frAuto = false; }, 300); }
          return;
        }
        if (location.search.indexOf("variant=") >= 0 && frKey(String(readFs(f) || "")) !== "rolled") return;
        var lbf = f.querySelector('label[data-value-handle*="natural-oak"]');
        var inf = lbf && f.querySelector("#" + CSS.escape(lbf.getAttribute("for")));
        if (lbf && !(inf && inf.checked)) {
          // Clicking the label focuses its radio, and the browser scrolls that
          // into view — which is why the page opened ~425px down the page instead
          // of at the top. Put the reader back where they were. (Summer 2026-07-15)
          frAuto = true; lbf.click();
          // the change listener may still sit on a detached fieldset at 800ms —
          // sync state directly so the auto-pick always reaches st.framing
          readSel(); price(); drawAll();
          setTimeout(function () { frAuto = false; }, 300); }
      };
      setTimeout(autoOak, 800);
      setTimeout(autoOak, 2000);
    }
    // theme re-renders its blocks on variant change — re-seat our nodes
    setInterval(function () {
      var s2 = document.querySelector('fieldset[data-option-name*="size"]');
      if (OWN && !s2) s2 = document.querySelector('fieldset[data-option-name*="width"]');
      if (OWN && kitRow && !kitRow.isConnected) {
        var eR = holder.ownerDocument.querySelector(".wlenh");
        if (eR) eR.closest(".wlc4").insertAdjacentElement("afterend", kitRow); }
      if (OWN && st.ownSizeBox && !st.ownSizeBox.isConnected) {   // morph ate the size UI
        var wb2 = st.ownFsNames && st.ownFsNames.w &&
          document.querySelector('fieldset[data-option-name="' + st.ownFsNames.w + '"]');
        var blk2 = wb2 && (wb2.closest(".product-info__block-item") || wb2);
        if (blk2) blk2.insertAdjacentElement("beforebegin", st.ownSizeBox); }
      if (s2 && !s2.contains(cRow)) { var v2 = s2.querySelector(".variant-picker__option-values") || s2;
        v2.appendChild(pill); s2.appendChild(cRow);
        s2.addEventListener("change", onPick);
        s2.addEventListener("click", onSizeClick);
        if (st.custom) s2.classList.add("wl-dim"); sizeFs = s2;
        if (st.custom) neutraliseChecked(true); }
      var f2 = document.querySelector('fieldset[data-option-name*="fram"]');
      if (f2 && !f2.contains(frNote)) { f2.appendChild(frNote); f2.addEventListener("change", onFramingPick); frFs = f2; }
      if (f2 && !f2.querySelector(".wlfrcap")) frCaps();   // morph ate the captions (all pages)
      // the canvas/panel line rides with the frame note — a theme re-render wiped
      // it and only frNote was ever re-seated, so the line vanished for good
      if (f2 && !frNote.contains(pNote)) frNote.appendChild(pNote);
      // edge + border rows live inside the framing section on the print page
      if (OWN && f2) {
        if (typeof edgeRow !== "undefined" && edgeRow && !f2.contains(edgeRow)) f2.appendChild(edgeRow);
        if (typeof borderRow !== "undefined" && borderRow && !f2.contains(borderRow)) f2.appendChild(borderRow);
      }
      var mp2 = curPrice();
      if ((OWN || st.custom || st.look !== "natural") && st.quote && st.quote.ok && mp2 && mp2.dataset.wlSet !== "1") {
        mp2.textContent = moneyMain(st.quote.total, true); mp2.dataset.wlSet = "1"; wlAfterpay(st.quote.total); }
      var sp2 = document.querySelector(".product-sticky-bar sale-price");
      if (sp2 && (OWN || st.custom || st.look !== "natural") && st.quote && st.quote.ok && sp2.dataset.wlSet !== "1") {
        if (stickyMem.orig == null) stickyMem.orig = sp2.innerHTML;
        sp2.textContent = moneyMain(toPres(st.quote.total + (st.enh ? 5 : 0)) +
          (st.kit && kit.price ? +kit.price : 0)); sp2.dataset.wlSet = "1"; }
      var tl2 = Array.prototype.find.call(sec.querySelectorAll(".product-info__block-item"),
        function (b) { return b.style.display !== "none" &&
          !b.querySelector("fieldset,variant-picker") &&
          !b.contains(pNote) && !b.querySelector("form[action*='/cart/add']") &&
          /\d{3}g/.test(b.textContent) && /panel/i.test(b.textContent); });
      if (tl2) tl2.style.display = "none";
      // the metafield liquid block re-renders AFTER variant morphs (our price()
      // read can race it) — re-hide it and refresh the ONE panel line once its
      // text settles (Summer 2026-07-31)
      if (!OWN && pNote) {
        var d9 = orderDims(), pi9 = panelInfo(d9);
        var t9 = pi9.canvas + " · " + pi9.n + (pi9.n > 1 ? " panels" : " panel");
        if (pNote.textContent !== t9) pNote.textContent = t9;
      }
      // theme morphs can REPLACE the cart form, killing the ATC intercept —
      // re-resolve and re-attach (the recipe box it used to re-seat is gone)
      // …and on artwork pages they also REPLACE the framing fieldset, taking the
      // edge/border rows with it — re-mount whatever fell out (2026-07-30 port)
      if (!OWN && typeof edgeRow !== "undefined" && edgeRow) {
        var ffm = document.querySelector('fieldset[data-option-name*="fram"]');
        if (ffm && !edgeRow.isConnected) ffm.appendChild(edgeRow);
        if (ffm && borderRow && !borderRow.isConnected) ffm.appendChild(borderRow);
        if (ffm && finRow && !finRow.isConnected) {
          var fb3 = ffm.closest(".product-info__block-item") || ffm;
          fb3.insertAdjacentElement("afterend", finRow);
        }
        if (st.ownEdgeVis) st.ownEdgeVis();
      }
      if (OWN && st.ownGate) st.ownGate();
      if (OWN && st.ownSeatAfter) st.ownSeatAfter();
      if (OWN && st.bulkN > 1 && st.ownBulkTotal) st.ownBulkTotal();
      if (OWN && window.__wlFixTitle) window.__wlFixTitle();
      var f3 = sec.querySelector("form[action*='/cart/add']") || document.querySelector("form[action*='/cart/add']");
      if (f3 && f3 !== form) {
        form = f3;
        form.addEventListener("submit", onAdd, true);
        var ab3 = form.querySelector("button[type=submit],[name=add]");
        if (ab3) ab3.addEventListener("click", onAdd, true);
      }
    }, 1200);

    // XHR on purpose (2026-07-31): the theme monkey-patches fetch() and auto-
    // opens its cart drawer on any '/cart/add' — BEFORE fresh WLCUSTOM prices
    // settle, which painted $0 lines with negative discount maths ("-$41").
    // XHR slips past that patch, so the ONLY thing that opens the drawer is our
    // settle gate below, once every line reports sane prices.
    function cartAddXHR(items) {
      return new Promise(function (resolve, reject) {
        var x = new XMLHttpRequest();
        x.open("POST", "/cart/add.js");
        x.setRequestHeader("content-type", "application/json");
        x.onload = function () {
          if (x.status >= 200 && x.status < 300) resolve();
          else reject(new Error("cart add failed")); };
        x.onerror = function () { reject(new Error("cart add failed")); };
        x.send(JSON.stringify({ items: items }));
      });
    }
    // ================= 6. ONE ADD TO CART — same product (+ optional kit) ========
    // The theme's product-rerender replaces the form node after hydration, so a
    // button captured at build time can be a DETACHED clone — "Adding…" then
    // painted an off-DOM node and the customer saw nothing (desktop, 2026-07-31).
    // Resolve every live ATC button (buy box + theme sticky bar) at call time.
    function atcBtns() {
      return Array.prototype.slice.call(document.querySelectorAll(
        "form[action*='/cart/add'] button[type=submit], button[type=submit][form^='product-form']," +
        "button[name=add], .product-form__submit"))
        .filter(function (b) { return b.tagName === "BUTTON"; });
    }
    function atcPaint(t, dis) { atcBtns().forEach(function (b) {
      b.textContent = t; b.disabled = !!dis; }); }
    async function onAdd(e) {
      if (OWN) { e.preventDefault(); e.stopPropagation(); return ownAdd(e); }
      var bb0 = st.framing === "rolled" ? (st.border || 0) : 0;
      var edgeSel = st.framing === "stretched" && st.edge && st.edge !== "Mirror image";
      var finSel = st.finish && st.finish !== "Matte";
      // pure defaults used to ride the theme's own form — but the theme add gives
      // NO button feedback ("Adding… / ✓ Added" never showed on default adds,
      // Summer 2026-07-31), so every add now goes through the intercepted path;
      // defaults still add by plain variant id below, same cart result.
      e.preventDefault(); e.stopPropagation();
      var btn = atcBtns()[0] || e.target;
      var old = btn.textContent || "Add to cart"; atcPaint("Adding…", true);
      try {
        readSel(); var d = orderDims();
        var bb = st.framing === "rolled" ? (st.border || 0) : 0;
        var items = [];
        if (!st.custom && st.look === "natural" && !bb && !edgeSel && !finSel) {
          var idInp = sec.querySelector('input[name="id"][form="' + form.id + '"]') || form.querySelector("[name=id]");
          if (!idInp || !idInp.value) throw new Error("could not read the selected variant");
          items.push({ id: +idInp.value, quantity: 1 });
        } else {
          var r = await fetch(API + "/api/native-line", { method: "POST", headers: { "content-type": "application/json" },
            body: JSON.stringify({ kind: "artwork", country: (window.Shopify && Shopify.country) || "", index: card.index, w: d[0], h: d[1],
              framing: st.framing, substrate: "canvas", look: st.look,
              custom: st.custom || bb > 0, typed: !!st.custom, border: bb,
              border_type: st.borderType || "mirror",
              panels: panelInfo(d).n }) }).then(function (x) { return x.json(); });
          if (!r.ok) throw new Error(r.message || "could not prepare the item");
          var pA = r.properties || {};
          pA["Finish"] = st.finish || "Matte";
          if (st.framing === "stretched" && st.edge) pA["Canvas edge"] = st.edge;
          items.push({ id: r.variantId, quantity: 1, properties: pA });
        }
        if (st.kit && kit.id) items.push({ id: kit.id, quantity: 1 });
        await cartAddXHR(items);
        // fresh WLCUSTOM variants take seconds to settle on Shopify's side — a
        // drawer opened too early shows blank titles / $0 / minus totals
        // (Summer 2026-07-24, worst on 3-piece bundles). Don't open the drawer
        // until every cart line reports a title and a real price (max 12s),
        // then refresh once more for late thumbnails.
        (function () {
          var fire = function () { document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", { bubbles: true })); };
          var t0 = Date.now();
          (function settle() {
            fetch("/cart.js").then(function (x) { return x.json(); }).then(function (c) {
              var bad = (c.items || []).some(function (i) { return !i.price || !i.title ||
                i.final_line_price < 0 ||
                (i.line_level_total_discount || 0) > (i.line_price || 0) ||
                (i.handle === "wl-print-your-own-art" && !i.image); });
              if (bad && Date.now() - t0 < 20000) return setTimeout(settle, 700);
              fire(); setTimeout(fire, 4000); setTimeout(fire, 9000);
            }).catch(function () { fire(); });
          })();
        })();
        // header count is cosmetic — update it in the background instead of
        // making the customer wait one more round-trip for "✓ Added"
        fetch("/cart.js").then(function (x) { return x.json(); }).then(function (c) {
          var ic = document.querySelector("a[href='/cart'] .cart-count, .cart-count-bubble, [class*='cart-count']");
          if (ic) ic.textContent = c.item_count;
        }).catch(function () {});
        track("wl_add_to_cart", { index: card.index, custom: st.custom });
        atcPaint("✓ Added — in your cart", true);
        setTimeout(function () { atcPaint(old, false); }, 2600);
      } catch (err) { atcPaint(old, false);
        q(".wlc-note").textContent = err.message || "Something went wrong — nothing was charged. Try again."; }
    }
    async function ownAdd(e) {
      var btn = atcBtns()[0] || e.target;
      var note = st.ownMsg || function (t) { q(".wlc-note").textContent = t || ""; };
      if (!st.ownRef) { note("Upload your artwork first — the exact file you upload is what we print."); 
        try { btn.scrollIntoView({ block: "center" }); } catch (e2) {} return; }
      var old = btn.textContent || "Add to cart"; atcPaint("Adding…", true);
      try {
        readSel(); var d = orderDims();
        // NOTHING IS BOUGHT AT A SIZE THE CUSTOMER CANNOT SEE (Summer 2026-08-24).
        // The size row and the order are one number now; if they ever part again,
        // the order stops here, the page resets to the number on screen, and the
        // customer presses add once more — knowing what they are buying.
        var shown = st.ownShownSize ? st.ownShownSize() : null;
        if (shown && d && d[0] && d[1] && (shown[0] !== d[0] || shown[1] !== d[1])) {
          if (st.custom) { st.w = shown[0]; st.h = shown[1]; } else st.size = shown;
          atcPaint(old, false);
          await price(); drawAll(); if (st.ownDpiNote) st.ownDpiNote();
          note("The size is now " + shown[0] + " × " + shown[1] + " cm and the price above "
             + "has been updated. Check it and press Add to cart again.");
          return;
        }
        var bb = st.framing === "rolled" ? (st.border || 0) : 0;
        // underscore props are hidden from the customer's cart but stay on the
        // order for the studio (Summer 2026-07-24 — cart was information overload)
        var items = [], props = { "_Artwork file": st.ownUrl,
          "_File name": st.ownName || "",
          "_File pixels": st.ownPx ? st.ownPx.w + "x" + st.ownPx.h : "see file",
          "Finish": st.finish || "Matte",
          "Panels": String(panelsFor(d[0], d[1])) };   // border never changes panels (2026-07-31)
        if (st.framing === "stretched" && st.edge) props["Canvas edge"] = st.edge;
        if (st.bulkN > 1) {
          // SET: one framing/edge/border/finish for all pieces; per piece only size+file.
          // Every piece validated, then ONE server call prices the whole set.
          if (!st.ownRef) { note("Upload the artwork for piece 1 first (the wall above).");
            atcPaint(old, false); return; }
          var plist = [{ w: d[0], h: d[1], own_ref: st.ownRef, own_url: st.ownUrl,
            thumb: st.ownThumb, own_image_id: st.ownImgId || 0,
            name: st.ownName || "", px: st.ownPx ? st.ownPx.w + "x" + st.ownPx.h : "",
            panels: panelsFor(d[0], d[1]) }];
          for (var bi = 0; bi < st.bulkN - 1; bi++) {
            var pc = st.pieces[bi] || {};
            var psz = pc.mode === "custom" ? [+pc.w, +pc.h] : [+pc.sw, +pc.sh];
            if (!pc.ref) { note("Piece " + (bi + 2) + " needs its file uploaded first.");
              atcPaint(old, false); return; }
            if (!(psz[0] && psz[1])) { note("Piece " + (bi + 2) + " needs a size in cm.");
              atcPaint(old, false); return; }
            plist.push({ w: psz[0], h: psz[1], own_ref: pc.ref, own_url: pc.url,
              thumb: pc.thumb, own_image_id: pc.imgId || 0,
              name: pc.name || "", px: pc.px || "",
              panels: panelsFor(psz[0], psz[1]) });
          }
          var rb = await fetch(API + "/api/native-lines", { method: "POST", headers: { "content-type": "application/json" },
            body: JSON.stringify({ framing: st.framing, edge: st.edge, border: bb,
              border_type: st.borderType || "mirror",
              finish: st.finish, pieces: plist }) }).then(function (x) { return x.json(); });
          if (!rb.ok) throw new Error(rb.message || "could not prepare the set");
          var srvSum = 0;
          rb.lines.forEach(function (ln) {
            srvSum += +ln.price || 0;
            items.push({ id: ln.variantId, quantity: 1, properties: ln.properties || {} }); });
          // repaint the page total to the server's priced set (normative) — the
          // displayed number and the cart must be the same number, always
          var srvKit = (st.kit && kit.price ? +kit.price : 0);
          srvSum += (st.enh ? 5 : 0) + srvKit;
          if (st.ownSyncTotal) st.ownSyncTotal(srvSum, srvKit);
        } else {
          // Summer's ruling 2026-07-30: standard sizes checkout through the SAME
          // engine-priced path as custom — the stored variant prices had drifted
          // from the engine, so the variant-id path is gone on this page.
          var r = await fetch(API + "/api/native-line", { method: "POST", headers: { "content-type": "application/json" },
            body: JSON.stringify({ kind: "own", country: (window.Shopify && Shopify.country) || "", w: d[0], h: d[1], framing: st.framing,
              substrate: "canvas", custom: !!st.custom || bb > 0, own: true, border: bb,
              border_type: st.borderType || "mirror",
              panels: panelsFor(d[0], d[1]),
              own_ref: st.ownRef, own_url: st.ownUrl, own_thumb: st.ownThumb,
              own_image_id: st.ownImgId || 0 }) }).then(function (x) { return x.json(); });
          if (!r.ok) throw new Error(r.message || "could not prepare the item");
          var p2 = r.properties || {}; for (var pk in props) p2[pk] = props[pk];
          items.push({ id: r.variantId, quantity: 1, properties: p2 });
        }
        // quality check is per IMAGE — every piece in a set must carry it, not just
        // piece 1 (Summer 2026-07-31: bundle of 2, only one line showed the note).
        // Stamp before the add-on lines are pushed so it lands on print pieces only.
        if (st.qc) items.forEach(function (it) { it.properties = it.properties || {};
          it.properties["Quality check"] = "requested — confirm with customer before printing"; });
        // enhancement $5 (was $10) since 2026-08-23: paid line + a property on the
        // print pieces so production can trace which files carry it.
        if (st.enh) {
          items.forEach(function (it) { it.properties = it.properties || {};
            // no price in the property (2026-08-24): the row is sold in every
            // market now, so a hardcoded A$5 would lie to a customer charged
            // US$4. The charge is its own cart line — this is the trace only.
            it.properties["Image enhancement"] = "yes"
              + (st.enhRef ? " — file " + st.enhRef : ""); });
          items.push({ id: 55901774381224, quantity: 1 });   // one $5 covers all pieces
        }
        if (st.kit && kit.id) items.push({ id: kit.id, quantity: 1 });
        await cartAddXHR(items);
        // the enhancement must ACTUALLY be a cart line — verify, re-add once
        // (Summer 2026-07-31: box ticked, no enhancement line at checkout)
        if (st.enh) { try {
          var cEnh = await fetch("/cart.js").then(function (x) { return x.json(); });
          if (!(cEnh.items || []).some(function (i2) { return i2.variant_id === 55901774381224; }))
            await cartAddXHR([{ id: 55901774381224, quantity: 1 }]);
        } catch (e6) {} }
        // fresh WLCUSTOM variants take seconds to settle on Shopify's side — a
        // drawer opened too early shows blank titles / $0 / minus totals
        // (Summer 2026-07-24, worst on 3-piece bundles). Don't open the drawer
        // until every cart line reports a title and a real price (max 12s),
        // then refresh once more for late thumbnails.
        (function () {
          var fire = function () { document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", { bubbles: true })); };
          var t0 = Date.now();
          (function settle() {
            fetch("/cart.js").then(function (x) { return x.json(); }).then(function (c) {
              var bad = (c.items || []).some(function (i) { return !i.price || !i.title ||
                i.final_line_price < 0 ||
                (i.line_level_total_discount || 0) > (i.line_price || 0) ||
                (i.handle === "wl-print-your-own-art" && !i.image); });
              if (bad && Date.now() - t0 < 20000) return setTimeout(settle, 700);
              fire(); setTimeout(fire, 4000); setTimeout(fire, 9000);
            }).catch(function () { fire(); });
          })();
        })();
        // header count is cosmetic — update it in the background instead of
        // making the customer wait one more round-trip for "✓ Added"
        fetch("/cart.js").then(function (x) { return x.json(); }).then(function (c) {
          var ic = document.querySelector("a[href='/cart'] .cart-count, .cart-count-bubble, [class*='cart-count']");
          if (ic) ic.textContent = c.item_count;
        }).catch(function () {});
        atcPaint("✓ Added — in your cart", true);
        setTimeout(function () { atcPaint(old, false); }, 2600);
      } catch (err) { atcPaint(old, false);
        note(err.message || "Something went wrong — nothing was charged. Try again."); }
    }
    form.addEventListener("submit", onAdd, true);
    var atcBtn = form.querySelector("button[type=submit],[name=add]");
    if (atcBtn) atcBtn.addEventListener("click", onAdd, true);
    // the theme morphs the form node — capture at document level so the intercept
    // survives any re-render. Was print-page only; artwork PDPs lost their form
    // listeners the same way, so desktop adds ran theme-native with zero button
    // feedback (Summer 2026-07-31). Non-OWN pages stay scoped to the main product
    // form by id — related-product quick-adds must keep riding the theme.
    var docHook = function (e) {
      var f = e.target && (e.target.closest ? e.target.closest("form[action*='/cart/add']")
              : null);
      if (e.type === "click") { var b2 = e.target.closest && e.target.closest("button[type=submit],[name=add]");
        if (!b2) return; f = b2.closest("form[action*='/cart/add']") ||
          (b2.getAttribute("form") ? document.getElementById(b2.getAttribute("form")) : null); }
      if (!f) return;
      if (!OWN && form && form.id && f.id !== form.id) return;
      onAdd(e);
    };
    document.addEventListener("submit", docHook, true);
    document.addEventListener("click", docHook, true);
    // THE reveal signal. The build is in place, so the cover comes off.
    // wl-c-ready is what wl-overrides.css waits for, on BOTH the print page and
    // the artwork PDPs (artwork PDPs had no cover at all before 2026-08-24).
    // There is no timed reveal anywhere any more: a clock reveals the raw theme
    // layout to exactly the people whose connection is too slow to have replaced
    // it yet, which is how Summer met the raw width/height grids on 4G.
    // wlown-ready / wl-print-ready stay for older cached CSS and for wl_bar.js.
    // Set directly, NOT inside requestAnimationFrame. rAF does not fire at all
    // in a background tab, and people open product pages in background tabs
    // constantly. wlown-ready had this flaw too and never showed, because a 3s
    // timer in wl_bar.js was quietly doing the reveal instead. That timer is
    // gone, so a hidden tab would sit behind the cover until the backstop
    // called a perfectly good page broken. Caught on the live render. (2026-08-24)
    reserveWall();
    document.body.classList.add("wl-c-ready");
    if (OWN) { document.body.classList.add("wlown-ready");
               document.body.classList.add("wl-print-ready"); }

    // ================= mockup drawing ============================================
    // 2026-09-24 SPEED: the demo-room canvas used to sit at height 10 until BOTH the
    // room photo and the artwork had loaded, then jump to full height after the page
    // was shown (the biggest layout jump on artwork pages). Hold its final size from
    // the start with tplGeom's own maths; the room photo is fixed at 896x1200
    // (TPL_PX). drawOn replaces it with the real numbers when the photo lands.
    function reserveWall() { try {
      var TPL_PX = { w: 896, h: 1200 };   // inside: reserveWall runs above this line's position
      var cv = wq(".wcv"); if (!cv || OWN || st.tab !== "tpl" || st.tpl.img) return;
      var W = cv.__w || cv.clientWidth; if (!W) return;
      var h = st.tpl.h_cm, dd = dims();
      if (dd && dd[1]) h = Math.max(h, Math.min(420, (+dd[1] || 0) + 20));
      var srcWall = TPL.floorY * TPL_PX.h, ppcS = srcWall / TPL.wallCm;
      var cropTop = Math.max(0, srcWall - h * ppcS);
      cv.width = Math.round(W); cv.height = Math.round((TPL_PX.h - cropTop) * W / TPL_PX.w);
      var x0 = cv.getContext("2d"); x0.fillStyle = "#efedE8"; x0.fillRect(0, 0, cv.width, cv.height);   // same wall tone as the My-room placeholder
    } catch (eRW) {} }
    function tplGeom(cv) {
      var img = st.tpl.img, W = cv.__w || cv.clientWidth || 560;
      // demo-room photo still loading (first visit on slow mobile) — skip this
      // frame; the loadImg().then in setTab calls drawAll() again once it lands
      if (!img) return null;
      var srcWall = TPL.floorY * img.height, ppcS = srcWall / TPL.wallCm;
      var h = st.tpl.h_cm, cropTop = Math.max(0, srcWall - h * ppcS);
      var s = W / img.width;
      return { W: W, H: Math.round((img.height - cropTop) * s), cropTop: cropTop,
               s: s, ppc: ppcS * s, wallH: h * ppcS * s };
    }
    function sbsOK(w, h, N) {                       // side-by-side panel = (w/N) × h
      var pw = w / N;
      return Math.max(pw, h) <= 300 && Math.min(pw, h) <= 200; }
    function panelRects(cx, cy, aw, ah, gap, N, vertical) {
      var out = [];
      for (var k = 0; k < N; k++) {
        if (vertical) { var pw = (aw - gap * (N - 1)) / N;
          out.push([cx - aw / 2 + k * (pw + gap), cy - ah / 2, pw, ah, k / N, 0, 1 / N, 1]); }
        else { var ph = (ah - gap * (N - 1)) / N;
          out.push([cx - aw / 2, cy - ah / 2 + k * (ph + gap), aw, ph, 0, k / N, 1, 1 / N]); }
      }
      return out; }
    function coverSrc(img, ratio) {
      var iw = img.width, ih = img.height, tw = iw, th = iw / ratio;
      if (th > ih) { th = ih; tw = ih * ratio; }
      return [(iw - tw) / 2, (ih - th) / 2, tw, th]; }
    function drawPanelFlat(x, r) {
      var g = FRAME_COLOURS[st.framing], ppcm = r.ppcm;
      // last line of defence: skip the frame rather than throw mid-draw
      if (!isFinite(r[0] + r[1] + r[2] + r[3] + ppcm)) return;
      if (st.framing === "rolled") {                    // wallpaper: flat, no shadow, no backing
        // OWN never crops (Summer 2026-07-31): the print stretches the whole
        // image to the ordered size, so the preview must too
        var fullR = (OWN || st.custom || st.drag) ? [0, 0, st.art.width, st.art.height]
          : coverSrc(st.art, (r[2] / r[6]) / (r[3] / r[7]));
        x.drawImage(st.art, fullR[0] + r[4] * fullR[2], fullR[1] + r[5] * fullR[3],
          fullR[2] * r[6], fullR[3] * r[7], r[0], r[1], r[2], r[3]);
        return;
      }
      x.save(); x.shadowColor = "rgba(0,0,0,.34)"; x.shadowBlur = 18; x.shadowOffsetY = 8;
      if (g) {
        var band = FRAME_CM * ppcm, gapf = GAPF_CM * ppcm;
        var ox = r[0] - gapf - band, oy = r[1] - gapf - band,
            ow = r[2] + 2 * (gapf + band), oh = r[3] + 2 * (gapf + band);
        var grad = x.createLinearGradient(ox, oy, ox, oy + oh);
        grad.addColorStop(0, g[0]); grad.addColorStop(1, g[1]);
        x.fillStyle = grad; x.fillRect(ox, oy, ow, oh);
        x.restore(); x.save();
        x.fillStyle = "rgba(20,16,12,.55)";
        x.fillRect(ox + band, oy + band, ow - 2 * band, oh - 2 * band);
      } else { x.fillStyle = "#fff"; x.fillRect(r[0], r[1], r[2], r[3]); }
      x.restore();
      var full = (OWN || st.custom || st.drag) ? [0, 0, st.art.width, st.art.height]
        : coverSrc(st.art, (r[2] / r[6]) / (r[3] / r[7]));
      x.drawImage(st.art, full[0] + r[4] * full[2], full[1] + r[5] * full[3],
        full[2] * r[6], full[3] * r[7], r[0], r[1], r[2], r[3]);
    }
    function artCorners(cv) {
      if (st.tab !== "tpl" && st.own.quad && st.own.img) {
        var W = cv.width, H = cv.height, d = dims();
        var qp = st.own.quad.map(function (p) { return [p[0] * W, p[1] * H]; });
        var pw = planeWcm(cv), hw = d[0] / pw / 2, hh = d[1] / st.own.h_cm / 2;
        var c = [[st.u - hw, st.v - hh], [st.u + hw, st.v - hh], [st.u + hw, st.v + hh], [st.u - hw, st.v + hh]];
        var Hm = solveH([[0, 0], [1, 0], [1, 1], [0, 1]], qp);
        return c.map(function (p) { return applyH(Hm, p[0], p[1]); });
      }
      var g = tplGeom(cv); if (!g) return null;
      var d2 = dims(), aw = d2[0] * g.ppc, ah = d2[1] * g.ppc;
      var cx = st.u * g.W, cy = st.v * g.wallH;
      return [[cx - aw / 2, cy - ah / 2], [cx + aw / 2, cy - ah / 2],
              [cx + aw / 2, cy + ah / 2], [cx - aw / 2, cy + ah / 2]];
    }
    function planeWcm(cv) {
      // Wall width in cm from the marked corners (Summer 2026-09-07, "yes to math").
      // The old way averaged the near and far edges — exact straight on, 9% short
      // at 25°, 17% short at 35°. Now: single-view metrology on the homography
      // the drawing already solves. Principal point = picture centre. When the
      // photo is a little tilted (both vanishing points finite — the normal
      // phone photo) the focal length is solved and the answer is exact; when
      // the verticals are dead parallel the focal length cannot be solved, so a
      // typical phone lens (0.8 × picture width) is assumed — half the old error.
      var W = cv.width, H = cv.height, qd = st.own.quad;
      var wpx = (Math.hypot((qd[1][0] - qd[0][0]) * W, (qd[1][1] - qd[0][1]) * H) +
                 Math.hypot((qd[2][0] - qd[3][0]) * W, (qd[2][1] - qd[3][1]) * H)) / 2;
      var hpx = (Math.hypot((qd[3][0] - qd[0][0]) * W, (qd[3][1] - qd[0][1]) * H) +
                 Math.hypot((qd[2][0] - qd[1][0]) * W, (qd[2][1] - qd[1][1]) * H)) / 2;
      var flat = st.own.h_cm * wpx / hpx;                   // the old answer = the fallback
      try {
        var Hm = solveH([[0, 0], [1, 0], [1, 1], [0, 1]], qd.map(function (q) { return [q[0] * W, q[1] * H]; }));
        var cx = W / 2, cy = H / 2;
        var a1 = Hm[0] - cx * Hm[6], b1 = Hm[3] - cy * Hm[6], c1 = Hm[6];
        var a2 = Hm[1] - cx * Hm[7], b2 = Hm[4] - cy * Hm[7], c2 = Hm[7];
        var den = c1 * c2, f2 = 0;
        if (Math.abs(den) > 1e-9 * Math.abs(a1 * a2 + b1 * b2) + 1e-18) {
          var f2c = -(a1 * a2 + b1 * b2) / den;
          if (f2c > 0 && Math.sqrt(f2c) >= .4 * W && Math.sqrt(f2c) <= 6 * W) f2 = f2c; }
        if (!f2) f2 = (.8 * W) * (.8 * W);
        var ratio = Math.sqrt((a1 * a1 + b1 * b1) / f2 + c1 * c1) / Math.sqrt((a2 * a2 + b2 * b2) / f2 + c2 * c2);
        if (isFinite(ratio) && ratio > .2 && ratio < 8) return st.own.h_cm * ratio;
      } catch (e) {}
      return flat; }
    // test hook (like wall.__clog): set a quad, get the width in cm back
    wall.__wlq = function (q) { if (q) { st.own.quad = q; } return planeWcm(wq(".wcv")); };
    function drawOn(cv) {
      // OWN starts with no artwork — still draw the empty demo room so the wall
      // shows at full height with the upload button on it (2026-07-23 squash bug)
      if (!cv || (!st.art && !OWN)) return;
      var x = cv.getContext("2d"), d = dims();
      // one non-finite anywhere in the geometry crashed the preview for the
      // rest of the page (Safari throws on createLinearGradient with NaN,
      // field errors 2026-08-15) — heal the state instead of drawing with it
      if (!isFinite(st.u)) st.u = .5;
      if (!isFinite(st.v)) st.v = .5;
      if (!d || !isFinite(d[0] + d[1])) { st.drag = null; d = st.size; }
      if (!d || !isFinite(d[0] + d[1])) return;
      var N = panelsFor(d[0], d[1]);
      var handles = !cv.__noHandles;
      function dots() { (artCorners(cv) || []).forEach(function (p) {
        x.beginPath(); x.arc(p[0], p[1], 7, 0, 7); x.fillStyle = "#fff"; x.fill();
        x.beginPath(); x.arc(p[0], p[1], 4.5, 0, 7); x.fillStyle = "rgba(74,82,48,.95)"; x.fill(); }); }
      if (st.tab === "tpl") {
        if (!st.tpl.img) return;
        var g = tplGeom(cv);
        if (!g || !isFinite(g.W + g.H + g.ppc + g.wallH)) return;
        cv.width = g.W; cv.height = g.H;
        x.drawImage(st.tpl.img, 0, g.cropTop, st.tpl.img.width, st.tpl.img.height - g.cropTop,
                    0, 0, g.W, g.H);
        if (OWN && !st.art) {
          if (st.ownShowOverlay) st.ownShowOverlay();
          if (st.ownName) {   // file received, format not displayable: true-size placeholder
            var aw0 = d[0] * g.ppc, ah0 = d[1] * g.ppc;
            var rects0 = panelRects(st.u * g.W, st.v * g.wallH, aw0, ah0,
              PANEL_GAP_CM * g.ppc, N, sbsOK(d[0], d[1], N));
            rects0.forEach(function (r0) {
              x.save(); x.shadowColor = "rgba(0,0,0,.25)"; x.shadowBlur = 14; x.shadowOffsetY = 6;
              x.fillStyle = "rgba(238,236,229,.95)"; x.fillRect(r0[0], r0[1], r0[2], r0[3]); x.restore(); });
          }
          return;
        }
        var aw = d[0] * g.ppc, ah = d[1] * g.ppc;
        st.u = Math.min(1 - (aw / 2 + 6) / g.W, Math.max((aw / 2 + 6) / g.W, st.u));
        var vmin = (ah / 2 + 6) / g.wallH, vmax = 1 - (ah / 2 + 6) / g.wallH;
        st.v = vmax > vmin ? Math.min(vmax, Math.max(vmin, st.v)) : .5;
        var cx = st.u * g.W, cy = st.v * g.wallH;
        var rects = panelRects(cx, cy, aw, ah, PANEL_GAP_CM * g.ppc, N, sbsOK(d[0], d[1], N));
        rects.forEach(function (r) { r.ppcm = g.ppc; drawPanelFlat(x, r); });
        if (handles) dots();
      } else {
        if (OWN && st.ownShowOverlay) st.ownShowOverlay();   // demo overlay never bleeds into other tabs
        if (!st.own.img) {
          var W0 = cv.__w || cv.clientWidth || 560;
          cv.width = W0; cv.height = Math.round(W0 * .62);
          x.fillStyle = "#efedE8"; x.fillRect(0, 0, cv.width, cv.height);
          return;
        }
        var W = cv.__w || cv.clientWidth || 560, H = Math.round(W * st.own.img.height / st.own.img.width);
        cv.width = W; cv.height = H;
        x.drawImage(st.own.img, 0, 0, W, H);
        if (st.own.edit) {
          var qp = st.own.quad.map(function (p) { return [p[0] * W, p[1] * H]; });
          x.strokeStyle = "rgba(74,82,48,.9)"; x.lineWidth = 2;
          x.beginPath(); x.moveTo(qp[0][0], qp[0][1]);
          qp.slice(1).forEach(function (p) { x.lineTo(p[0], p[1]); });
          x.closePath(); x.stroke();
          x.fillStyle = "rgba(74,82,48,.95)";
          qp.forEach(function (p) { x.beginPath(); x.arc(p[0], p[1], 11, 0, 7); x.fill(); });
          x.fillStyle = "#fff"; x.font = "11px sans-serif"; x.textAlign = "center";
          qp.forEach(function (p, i) { x.fillText(String(i + 1), p[0], p[1] + 4); });
        } else {
          var pw = planeWcm(cv), hw = d[0] / pw, hh = d[1] / st.own.h_cm;
          st.u = Math.min(.98 - hw / 2, Math.max(.02 + hw / 2, st.u));
          st.v = Math.min(.98 - hh / 2, Math.max(.02 + hh / 2, st.v));
          var qp2 = st.own.quad.map(function (p) { return [p[0] * W, p[1] * H]; });
          var Hm = solveH([[0, 0], [1, 0], [1, 1], [0, 1]], qp2);
          var rectsP = panelRects(st.u, st.v, d[0] / pw, d[1] / st.own.h_cm, PANEL_GAP_CM / pw, N, sbsOK(d[0], d[1], N));
          rectsP.forEach(function (r) {
            var band = FRAME_CM / pw, gp = GAPF_CM / pw;
            var fc = FRAME_COLOURS[st.framing];
            function quadOf(px, py, pww, phh) {
              return [[px, py], [px + pww, py], [px + pww, py + phh], [px, py + phh]]
                .map(function (p) { return applyH(Hm, p[0], p[1]); }); }
            function fill(qq, style) { x.beginPath(); x.moveTo(qq[0][0], qq[0][1]);
              qq.slice(1).forEach(function (p) { x.lineTo(p[0], p[1]); }); x.closePath();
              x.fillStyle = style; x.fill(); }
            if (st.framing !== "rolled") {
              x.save(); x.shadowColor = "rgba(0,0,0,.34)"; x.shadowBlur = 18; x.shadowOffsetY = 8;
              if (fc) { fill(quadOf(r[0] - gp - band, r[1] - gp - band, r[2] + 2 * (gp + band), r[3] + 2 * (gp + band)), fc[0]);
                x.restore(); fill(quadOf(r[0] - gp, r[1] - gp, r[2] + 2 * gp, r[3] + 2 * gp), "rgba(20,16,12,.55)"); }
              else { fill(quadOf(r[0], r[1], r[2], r[3]), "#fff"); x.restore(); }
            }
            if (!st.art) {   // undisplayable format: show the panel placeholder, no art
              fill(quadOf(r[0], r[1], r[2], r[3]), "rgba(238,236,229,.92)"); return; }
            var full = (OWN || st.custom || st.drag) ? [0, 0, st.art.width, st.art.height]
              : coverSrc(st.art, (r[2] * pw) / (r[3] * st.own.h_cm));
            var slice = document.createElement("canvas");
            slice.width = Math.max(1, full[2] * r[6]); slice.height = Math.max(1, full[3] * r[7]);
            slice.getContext("2d").drawImage(st.art, full[0] + r[4] * full[2], full[1] + r[5] * full[3],
              full[2] * r[6], full[3] * r[7], 0, 0, slice.width, slice.height);
            drawWarped(x, slice, quadOf(r[0], r[1], r[2], r[3]));
          });
          if (handles) dots();
        }
      }
      var cap = cv.__cap || wq(".capl");
      if (cap) cap.textContent = capText(dims());
    }
    // tgt = the element that receives the gestures (the .wdrag zone over the art);
    // coordinates stay canvas-relative. Defaults to the canvas (full-view modal).
    function attach(cv, tgt) {
      var el = tgt || cv;
      var drag = null;
      var pos = function (ev) { var r = cv.getBoundingClientRect(); var t = ev.touches ? ev.touches[0] : ev;
        // a zero-size rect (mid-layout on iOS) would divide to NaN/Infinity and
        // poison st.u/st.v for the rest of the page — refuse the reading instead
        if (!r.width || !r.height) return null;
        return [(t.clientX - r.left) / r.width * cv.width, (t.clientY - r.top) / r.height * cv.height]; };
      el.onmousedown = el.ontouchstart = function (ev) {
        var p = pos(ev), W = cv.width, H = cv.height;
        if (!p) return;
        if (st.tab !== "tpl" && st.own.edit) {
          var qp = st.own.quad.map(function (pt) { return [pt[0] * W, pt[1] * H]; });
          var hitR = ev.touches ? 34 : 22;                 // a finger is wider than a mouse
          for (var k = 0; k < 4; k++)
            if (Math.hypot(p[0] - qp[k][0], p[1] - qp[k][1]) < hitR) { drag = { handle: k }; break; }
          if (drag) ev.preventDefault();                   // not on a dot: let the page scroll
          return; }
        var qd = artCorners(cv) || [];
        var hitC = ev.touches ? 22 : 14;
        for (var k2 = 0; k2 < qd.length; k2++)
          if (Math.abs(p[0] - qd[k2][0]) < hitC && Math.abs(p[1] - qd[k2][1]) < hitC) {
            drag = { corner: k2 }; ev.preventDefault(); return; }
        drag = { from: p };
        if (ev.touches) { drag.pending = 1; drag.start = [ev.touches[0].clientX, ev.touches[0].clientY]; }
        else ev.preventDefault(); };
      el.onmousemove = el.ontouchmove = function (ev) {
        if (!drag) return; var p = pos(ev), W = cv.width, H = cv.height;
        if (!p) return;
        if (drag.pending && ev.touches) {                 // first move decides: scroll or move the art
          var dx = ev.touches[0].clientX - drag.start[0], dy = ev.touches[0].clientY - drag.start[1];
          if (Math.abs(dx) + Math.abs(dy) < 6) return;    // too small to tell yet
          if (Math.abs(dy) > Math.abs(dx)) { drag = null; return; }   // up/down = the page scrolls
          drag.pending = 0; }
        if (drag.handle != null) {
          st.own.quad[drag.handle] = [Math.min(1, Math.max(0, p[0] / W)), Math.min(1, Math.max(0, p[1] / H))];
          (st.own.touched = st.own.touched || {})[drag.handle] = 1;
          if (Object.keys(st.own.touched).length >= 4) { var gd = wq(".gdone");
            if (gd) { gd.style.background = getComputedStyle(sec).getPropertyValue("--wlsysbg") || "#425934"; gd.style.borderColor = gd.style.background; } }
          drawAll(); ev.preventDefault(); return; }
        if (drag.corner != null) {
          var w, h2;
          if (st.tab === "tpl") { var g = tplGeom(cv); if (!g) return;
            w = Math.abs(p[0] - st.u * g.W) * 2 / g.ppc;
            h2 = Math.abs(p[1] - st.v * g.wallH) * 2 / g.ppc; }
          else { var Hi = solveH(st.own.quad.map(function (pt) { return [pt[0] * W, pt[1] * H]; }),
              [[0, 0], [1, 0], [1, 1], [0, 1]]);
            var pl = applyH(Hi, p[0], p[1]);
            w = Math.abs(pl[0] - st.u) * 2 * planeWcm(cv);
            h2 = Math.abs(pl[1] - st.v) * 2 * st.own.h_cm; }
          // The corner drag obeys the SAME Fix-ratio box the size row shows
          // (Summer 2026-08-24). Print page reads st.ratioKeep, artwork page
          // reads st.artFix — before this only the print page was checked, so
          // the artwork page resized free-form with its box sitting ticked.
          var keepR = OWN ? (st.ratioKeep !== false) : (st.artFix !== false);
          if (keepR && st.aspect) {
            var w3 = Math.max(w, h2 * st.aspect);
            w = w3; h2 = w3 / st.aspect;
          }
          if (isFinite(w) && isFinite(h2))
            st.drag = [Math.max(30, Math.round(w)), Math.max(30, Math.round(h2))];
        } else {
          if (st.tab === "tpl") { var g2 = tplGeom(cv); if (!g2) return;
            st.u += (p[0] - drag.from[0]) / g2.W; st.v += (p[1] - drag.from[1]) / g2.wallH; }
          else { var Hi2 = solveH(st.own.quad.map(function (pt) { return [pt[0] * W, pt[1] * H]; }),
              [[0, 0], [1, 0], [1, 1], [0, 1]]);
            var a = applyH(Hi2, drag.from[0], drag.from[1]), b2 = applyH(Hi2, p[0], p[1]);
            st.u += b2[0] - a[0]; st.v += b2[1] - a[1]; }
          drag.from = p; }
        drawAll(); ev.preventDefault(); };
      el.onmouseup = el.ontouchend = function () {
        if (drag && drag.corner != null && st.drag) {
          var d = st.drag; st.drag = null;
          if (OWN && st.ownDragCommit) st.ownDragCommit(d[0], d[1]);
          else applyCustom(d[0], d[1], true); }
        drag = null; };
      // .wdrag is only as big as the artwork, so a quick mouse drag can outrun it —
      // follow the pointer on the window until the button comes back up
      el.addEventListener("mousedown", function () {
        var mm = function (e) { el.onmousemove(e); };
        var mu = function () { el.onmouseup();
          window.removeEventListener("mousemove", mm); window.removeEventListener("mouseup", mu); };
        window.addEventListener("mousemove", mm); window.addEventListener("mouseup", mu);
      });
    }
    var bigCv = null;
    function drawAll() {
      if (st.zoomViewer) { try { zoomRuler(); } catch (e) {} }   // size changed → ruler follows
      // demo wall grows with the artwork (art height + 20 cm headroom, max 420 —
      // so a 240×320 sets a 340 wall and up to 400-tall art always fits).
      // Only the DEMO room: "My room"/"In-situ" is the customer's real wall.
      var dd = dims();
      if (dd && dd[1]) {
        var need = Math.min(420, (+dd[1] || 0) + 20);
        if (st.tpl.h_cm < need) { st.tpl.h_cm = need;
          if (st.tab === "tpl") { var wi0 = wq(".whcm"); if (wi0) wi0.value = need;
            var wi0b = document.querySelector("#wlbigwrap .whcm2"); if (wi0b) wi0b.value = need; } }
      }
      drawOn(wq(".wcv")); if (bigCv && bigCv.__wrap.style.display !== "none") drawOn(bigCv);
      placeDragBox(); }
    // Keep the grab zone glued to the artwork (plus a margin that covers the resize
    // dots). Everything outside it belongs to the page, so the room scrolls.
    function placeDragBox() {
      var cv = wq(".wcv"), box = wq(".wdrag");
      if (!cv || !box) return;
      if (cv.style.display === "none" || (OWN && !st.art)) { box.style.display = "none"; return; }
      box.style.display = "";
      var r = cv.getBoundingClientRect();
      // marking wall corners needs the whole canvas, not just the art
      if (st.tab !== "tpl" && st.own.edit) {
        box.style.cssText += ";left:0;top:0;width:" + r.width + "px;height:" + r.height + "px";
        return; }
      var q = artCorners(cv);
      if (!q || q.length !== 4) { box.style.display = "none"; return; }
      var sx = r.width / cv.width, sy = r.height / cv.height, pad = 24;
      var xs = q.map(function (p) { return p[0] * sx; }), ys = q.map(function (p) { return p[1] * sy; });
      var x0 = Math.max(0, Math.min.apply(null, xs) - pad), y0 = Math.max(0, Math.min.apply(null, ys) - pad);
      var x1 = Math.min(r.width, Math.max.apply(null, xs) + pad);
      var y1 = Math.min(r.height, Math.max.apply(null, ys) + pad);
      box.style.left = x0 + "px"; box.style.top = y0 + "px";
      box.style.width = Math.max(0, x1 - x0) + "px"; box.style.height = Math.max(0, y1 - y0) + "px";
    }
    function snapshot(px, q) {
      var off = document.createElement("canvas");
      off.__w = px || 1100; off.__noHandles = true; off.__cap = { textContent: "" };
      drawOn(off);
      return off.toDataURL("image/jpeg", q || .9); }
    function fileName() { return card.index + " " + shortTitle(card.title) + " - wall liberation.jpg"; }
    function askEmail(msg) { return new Promise(function (res) {
      var ov = document.createElement("div");
      ov.style.cssText = "position:fixed;inset:0;z-index:2147483100;background:rgba(20,20,20,.55);display:flex;align-items:center;justify-content:center;padding:16px";
      ov.innerHTML = '<div style="background:#fff;padding:20px;max-width:380px;width:100%;font-family:' + bodyFont + '">' +
        '<div style="font-size:.9375rem;font-weight:600;margin:0 0 10px">' + msg + "</div>" +
        '<input type="email" placeholder="you@email.com" style="width:100%;box-sizing:border-box;font-size:14px;padding:10px;border:1px solid #d8d3cb" value="' + (localStorage.wl_email || "") + '">' +
        '<div style="margin-top:12px;display:flex;gap:12px;align-items:center">' +
        '<button class="ok" style="background:var(--wlsysbg,#425934);color:var(--wlsysfg,#fff);border:none;padding:10px 20px;font-size:12px;letter-spacing:.08em;text-transform:uppercase;cursor:pointer;font-family:inherit">Send</button>' +
        '<button class="no" style="background:none;border:none;color:#8a6d3b;text-decoration:underline;cursor:pointer;font-size:12px;font-family:inherit">cancel</button></div></div>';
      document.body.appendChild(ov);
      var inp = ov.querySelector("input"); setTimeout(function () { inp.focus(); }, 50);
      function done(v) { ov.remove(); res(v); }
      ov.querySelector(".ok").onclick = function () {
        var v = inp.value.trim();
        if (!v || v.indexOf("@") < 1) { inp.focus(); return; }
        try { localStorage.wl_email = v; } catch (e) {} done(v); };
      ov.querySelector(".no").onclick = function () { done(null); };
      ov.onclick = function (e) { if (e.target === ov) done(null); };
      inp.onkeydown = function (e) { if (e.key === "Enter") ov.querySelector(".ok").click(); };
    }); }

    // ================= tabs =================
    // Summer 2026-09-07: the buttons for the current step live on the picture
    // (bottom right), the step itself top left — the caption row keeps only
    // the size line and the wall-height box.
    function ctl(html) { wq(".wactx").innerHTML = html || ""; wactShow(); }
    function wactShow() {
      var a = wq(".wact");
      a.style.display = (wq(".wactx").innerHTML || wq(".gdone").style.display !== "none") ? "flex" : "none";
      // .aiview (history strip / message) sits UNDER the canvas inside the same
      // box — keep the chips on the picture, not over that text
      var av = wq(".aiview"), off = 0;
      if (av && av.style.display !== "none" && wq(".wcv").style.display !== "none") off = av.offsetHeight || 0;
      a.style.bottom = (8 + off) + "px"; }   // ignored on phones: the row is static there
    function step(n, txt) {
      var el = wq(".wstep");
      if (!txt) { el.style.display = "none"; return; }
      el.innerHTML = (n ? "<b>" + n + "</b>" : "") + txt; el.style.display = ""; }
    function stage(html) { var el = wq(".wstage"); el.innerHTML = html; el.style.display = html ? "flex" : "none"; }
    // Step 3: the wall height, asked once per photo right after Done. 270 is
    // pre-filled — Keep is one tap; type a number and it reads Set.
    function heightAsk() {
      step("", "How tall is this wall, floor to ceiling?");
      ctl('<span class="whpill"><input class="whin" inputmode="numeric" type="number" min="150" max="600" step="1" value="' + st.own.h_cm + '"> cm</span>' +
          '<button type="button" class="whok">Keep</button>');
      var inp = wq(".whin"), ok = wq(".whok");
      inp.oninput = function () { ok.textContent = (+inp.value === st.own.h_cm) ? "Keep" : "Set"; };
      inp.onkeydown = function (e) { if (e.key === "Enter") { e.preventDefault(); ok.click(); } };
      ok.onclick = function () {
        st.own.h_cm = Math.min(600, Math.max(150, +inp.value || 270));
        wq(".whcm").value = st.own.h_cm;
        st.own.hAsk = 0; st.own.hDone = 1;
        setTab(st.tab); };
      try { inp.focus({ preventScroll: true }); } catch (e) {}
    }
    function ownCtlWire() {
      var wh = wq(".whcm"), whm = wq(".whmax");
      wh.value = st.own.h_cm; whm.textContent = "(your wall)";
      wh.min = 150; wh.max = 600;
      wh.onchange = function () {
        st.own.h_cm = Math.min(600, Math.max(150, +this.value || 270)); this.value = st.own.h_cm; drawAll(); };
      var ou = wq(".oup"); if (ou) ou.onclick = function () { ownUpload(); };
      var of = wq(".ofit"); if (of) of.onclick = function () { startCorners(); };
    }
    function setTab(t) {
      st.tab = t;
      // room-view usage pulse (2026-08-12): one line per tab per page view, so
      // /wl-pulse can answer "do shoppers actually use My room / AI photo?"
      st._tabsSeen = st._tabsSeen || {};
      if (!st._tabsSeen[t]) { st._tabsSeen[t] = 1; clog("tab-" + t); }
      wall.querySelectorAll(".wt").forEach(function (b) { b.classList.toggle("on", b.dataset.t === t); });
      if (OWN && st.ownShowOverlay) st.ownShowOverlay();   // the demo upload overlay belongs to the Demo tab only
      readSel();                                           // fresh size/framing from the live buy box
      // Photo-real is the last step of My room (Summer 2026-09-07): st.view says
      // which picture fills the frame — the plain paste or the realistic photo.
      // The last render comes back ONCE per page load (localStorage).
      if (t === "own" && !st.ai.url && !st.ai.restored) { st.ai.restored = 1;
        try { st.ai.url = localStorage["wl_ailast_" + card.index] || null; } catch (e8) {}
        if (st.ai.url && !st.own.img) st.view = "photo"; }
      if (!st.ai.url || OWN) st.view = "plain";
      var photoView = t === "own" && st.view === "photo";
      // Summer 2026-07-15: My room used to fire the file picker the moment you
      // touched the tab — people had no idea what it was for. Ask first instead.
      var ownEmpty = t === "own" && !st.own.img && !photoView;
      var cvOn = t === "tpl" || (t === "own" && !!st.own.img && !photoView);
      // nothing uploaded yet: the grey frame stays, the stage panel sits on it
      var stageOn = ownEmpty;
      wq(".wcv").style.display = cvOn ? "" : "none";
      var sg = wq(".wstage"); sg.style.display = stageOn ? "flex" : "none";
      if (stageOn) sg.style.minHeight = Math.round((wq(".cvw").clientWidth || 560) * .62) + "px";   // same frame as the picture
      step("", ""); ctl("");
      // The grab zone lives inside .cvw and so does .aiview — leave it showing with
      // no canvas and it sits on top of the upload / "create another" buttons and
      // eats the click. It only ever belongs over a live canvas.
      var db = wq(".wdrag"); if (db) db.style.display = cvOn ? "" : "none";
      // enlarge is live for the wall canvas AND for a finished AI photo
      wq(".wfull").style.display = (cvOn || photoView) ? "" : "none";
      wq(".aiview").style.display = (t === "own" && !stageOn) ? "" : "none";

      wq(".wcap").style.display = cvOn ? "flex" : "none";
      wq(".wsave").style.display = "";
      wq(".wemail").style.display = "";

      // Show the drag/resize hint on EVERY tab that has a live canvas — it was
      // gated to "not Demo room AND a photo already uploaded", so on the default
      // tab nobody ever saw it. (Summer asked where it went, 2026-07-15.)
      var en0 = wq(".estnote");
      if (en0) en0.style.display = cvOn ? "" : "none";
      var wh = wq(".whcm"), whm = wq(".whmax");
      guide(t !== "tpl" && !!st.own.img && st.own.edit);   // corner-set follows you across My room/In-situ
      wq(".wmsg").textContent = "";
      if (t === "tpl") {
        ctl("");
        wh.value = st.tpl.h_cm; whm.textContent = "";
        wh.min = 200; wh.max = 420;
        wh.onchange = function () {
          st.tpl.h_cm = Math.min(420, Math.max(200, +this.value || 270)); this.value = st.tpl.h_cm; drawAll(); };
        if (!st.tpl.img) loadImg(API + "/room_tpl/" + TPL.file).then(function (im) { if (im) { st.tpl.img = im; drawAll(); } });
        else drawAll();
      } else {
        wq(".aiview").innerHTML = "";
        if (photoView) { photoResult(); return; }
        if (!st.own.img) { ownPanel(); drawAll(); return; }   // ask first — never auto-open the picker
        var ready = !st.own.edit && !st.own.hAsk, sm = SMALL();
        ctl('<button type="button" class="oup">' + (sm ? "Photo" : "Change photo") + '</button>' +
          (!st.own.edit ? '<button type="button" class="ofit">' + (sm ? "Corners" : "Re-do corners") + '</button>' : "") +
          (ready && !OWN ? '<button type="button" class="aigo">' + (sm ? "Photo-real view" : "Make the photo-real view") + '</button>' : ""));
        ownCtlWire();
        guide(st.own.edit); drawAll();
        if (!st.own.edit && st.own.hAsk) { heightAsk(); return; }
        if (ready && !OWN) plainReady();
      }
    }
    function SMALL() { return window.innerWidth < 750; }   // phone: short labels, nothing clipped
    function photoOn() { return st.tab === "own" && st.view === "photo" && !!st.ai.url; }
    function guide(on) {
      // step 2 on the picture + the Done chip (the old bar under the canvas is retired)
      wq(".gdone").style.display = on ? "" : "none";
      if (on) step("", "Put the 4 dots where the wall meets the floor and the ceiling");
      else if (!st.own.hAsk) step("", "");
      wactShow();
    }
    // ===== Detail zoom (Summer 2026-09-07) — tiles cut from the Wonder master at
    // half size, served by the worker; nothing loads until this tab is pressed.
    // The ruler says how many cm of the real print the 100 px bar spans, from
    // the size chosen in the buy box.
    function zoomProbe() {
      if (OWN || !card || !card.index || st.zoomInfo) return;
      var ix = String(card.index), cands = [ix, ix.replace(/[A-Z]$/, ""), ix.replace(/[A-Z]$/, "") + "N"]
        .filter(function (v, i, a) { return v && a.indexOf(v) === i; });
      (function next(i) {
        if (i >= cands.length) return;
        // no-cache = always ask the worker (a tiny conditional GET): a re-cut set
        // announces itself in the manifest within minutes, the old one was cached
        // for 30 days (The Beacon, 2026-09-10)
        fetch(API + "/tiles/" + cands[i] + "/info.json", { cache: "no-cache" })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) {
            if (j && j.width && j.verified !== false) {
              st.zoomInfo = j; st.zoomIdx = cands[i];
              wall.classList.add("has-zoom");                              // reveals the section
              var bp = wq(".wttzoom"); if (bp) bp.style.display = "";      // phone: the middle tab
              // Desktop stacks every pane, so the section is on the page from
              // here — but NOTHING of the viewer loads until it is nearly in
              // view (Summer asked: no extra page-load cost).
              // NOTHING may compete with the page (Summer 2026-09-07: "the page
              // feels slower"). On a laptop the section sits just under the fold,
              // so being visible is not enough: the viewer waits for the page to
              // finish loading AND for an idle moment. A touch or hover on the
              // section starts it at once.
              try {
                var pz = wall.querySelector(".wpane-zoom");
                if (pz) {
                  var io = null, armed = false;
                  var go = function () { if (io) io.disconnect(); zoomTab(); };
                  var idle = function () {
                    if ("requestIdleCallback" in window) requestIdleCallback(go, { timeout: 3000 });
                    else setTimeout(go, 1500);
                  };
                  var arm = function () {
                    if (armed) return; armed = true;
                    if (document.readyState === "complete") idle();
                    else window.addEventListener("load", idle, { once: true });
                  };
                  if ("IntersectionObserver" in window) {
                    io = new IntersectionObserver(function (es) {
                      if (es.some(function (e) { return e.isIntersecting; })) arm();
                    }, { rootMargin: "120px 0px", threshold: 0.01 });
                    io.observe(pz);
                  } else arm();
                  ["pointerenter", "touchstart", "click"].forEach(function (ev) {
                    pz.addEventListener(ev, go, { once: true, passive: true }); });
                }
              } catch (e2) {}
            }
            else next(i + 1);
          }).catch(function () { next(i + 1); });
      })(0);
    }
    function zoomRuler() {
      try {
        var v = st.zoomViewer; if (!v || !v.viewport) return;
        var z = v.viewport.getZoom(true), cw = v.viewport.getContainerSize().x;
        var wcm = orderDims()[0] || 100;
        var cm = 100 * wcm / (z * cw);              // cm of print across the 100 px bar
        var d = orderDims();
        wq(".zrule span").innerHTML = "<b style='font-size:13px'>" + (cm < 10 ? cm.toFixed(1) : Math.round(cm)) + " cm</b>" +
          " <small>of your " + d[0] + " × " + d[1] + " cm print</small>";
      } catch (e) {}
    }
    function zoomTab() {
      var info = st.zoomInfo;
      if (!info || st.zoomViewer) return;
      var navW = window.innerWidth < 750 ? 84 : 132;
      var start = function () {
        if (st.zoomViewer) { zoomRuler(); return; }
        var host = wq(".zosd");
        st.zoomViewer = OpenSeadragon({
          element: host, prefixUrl: "", showNavigationControl: false, showNavigator: true,
          navigatorPosition: "TOP_RIGHT", navigatorAutoFade: false,   // always on show
          // the map is cut to the print's own shape, so it holds no empty space
          navigatorWidth: navW + "px",
          navigatorHeight: Math.round(navW * info.height / info.width) + "px",
          gestureSettingsMouse: { clickToZoom: false, dblClickToZoom: true, scrollToZoom: true },
          gestureSettingsTouch: { pinchToZoom: true, flickEnabled: true, dblClickToZoom: true },
          homeFillsViewer: true,            // full-bleed first view — no black bars
          // the picture always fills the frame: you cannot pan or zoom out to
          // bare background (Summer 2026-09-07 — "no black in the zoom")
          visibilityRatio: 1, constrainDuringPan: true,
          minZoomImageRatio: 1, maxZoomPixelRatio: 1.15, animationTime: 0.7,
          springStiffness: 7, immediateRender: false, blendTime: 0.25,
          tileSources: { width: info.width, height: info.height, tileSize: info.tileSize, tileOverlap: 0,
            minLevel: 0, maxLevel: info.levels - 1,
            getTileUrl: function (level, x, y) { return API + "/tiles/" + st.zoomIdx + "/" + (info.prefix ? info.prefix + "/" : "") + level + "/" + x + "_" + y + ".jpg"; } }
        });
        window.__wlzoom = st.zoomViewer;            // debugging handle (harmless)
        st.zoomViewer.addHandler("zoom", zoomRuler);
        st.zoomViewer.addHandler("resize", zoomRuler);
        st.zoomViewer.addHandler("open", function () {
          // Opens on the WHOLE print, like a museum viewer. Measured 2026-09-07:
          // that first view is ~12 tiles (~150 KB); the old auto-zoom to 2.2x
          // pulled 171 tiles (~2.2 MB) before anyone asked for it. Zooming from
          // here loads only the pieces the buyer actually looks at.
          var vp = st.zoomViewer.viewport;
          vp.resize(vp.getContainerSize(), true);
          vp.goHome(true);
          vp.minZoomLevel = vp.getHomeZoom();       // zooming out stops at full-bleed
          // opens twice life-size-on-screen (Summer 2026-09-07) — set straight
          // there, no animation, so only that one level's pieces are fetched
          vp.zoomTo(vp.getHomeZoom() * 2, null, true);
          zoomRuler(); });
        st.zoomViewer.addHandler("resize", function () {
          var vp2 = st.zoomViewer.viewport;
          vp2.minZoomLevel = vp2.getHomeZoom(); });
        wq(".zctl").onclick = function (e) {
          var b = e.target.closest("button"); if (!b) return;
          var vp = st.zoomViewer.viewport;
          if (b.dataset.z === "in") vp.zoomBy(1.6); else if (b.dataset.z === "out") vp.zoomBy(1 / 1.6); else vp.goHome();
          vp.applyConstraints(true);        // never past full-bleed (no bare background)
        };
        try { clog("zoom-open"); } catch (e) {}
      };
      // let the box lay out first — OpenSeadragon measures its container once
      var start0 = start; start = function () { setTimeout(start0, 80); };
      if (window.OpenSeadragon) start();
      else {
        wq(".zhint").textContent = "Loading the detail viewer…";
        var sc = document.createElement("script");
        sc.src = "https://cdnjs.cloudflare.com/ajax/libs/openseadragon/4.1.1/openseadragon.min.js";
        sc.onload = function () { wq(".zhint").textContent = "Zoom in to see the brushwork · drag to move"; start(); };
        sc.onerror = function () { wq(".zhint").textContent = "The detail viewer could not load — please try again."; };
        document.head.appendChild(sc);
      }
    }
    // "My room", before any photo: explain what it does, then let THEM open the
    // picker. Same panel + button as In-situ so the two tabs behave alike.
    function ownPanel() {
      if (OWN && !st.ownName) {
        // print page, nothing uploaded yet: both steps, side by side (Summer 2026-07-23)
        stage('<div class="body">Upload your artwork and a photo of your room</div>' +
          '<div class="nt">Then put the 4 dots where the wall meets the floor and the ceiling, and your artwork appears at true size.</div>' +
          '<div style="display:flex;gap:10px;flex-wrap:wrap;justify-content:center">' +
          '<button type="button" class="btn oup1">Upload your artwork</button>' +
          '<button type="button" class="btn oup2">Upload your room photo</button></div>');
        wq(".wstage .oup1").onclick = function () { if (st.ownStartUpload) st.ownStartUpload(); };
      } else {
        stage('<div class="body">Upload a photo of your room</div>' +
          '<div class="nt">Mark the wall corners and ' + (OWN ? "your artwork" : "this artwork") + ' appears on your wall at true size.</div>' +
          '<button type="button" class="btn oup2">Upload your room photo</button>');
      }
      wq(".wstage .oup2").onclick = function () { ownUpload(); };
    }
    st.ownRoomBtns = function () {   // artwork arrived while the panel is open — refresh it
      if (OWN && st.tab === "own" && !st.own.img) ownPanel(); };
    function startCorners() {
      st.own.edit = true; st.own.touched = {};
      setTab("own");
    }
    function ownUpload() {
      var inp = wall.__upl;
      if (!inp) { inp = document.createElement("input"); inp.type = "file";
        inp.accept = "image/*,.heic,.heif";
        inp.style.cssText = "position:absolute;width:1px;height:1px;opacity:0;pointer-events:none";
        wall.appendChild(inp); wall.__upl = inp;   // stays referenced — Safari GC-proof
      }
      inp.value = "";
      clog("picker-open");
      inp.onchange = function () {
        var f = inp.files[0]; if (!f) return;
        clog("picked", { type: f.type || "?", kb: Math.round(f.size / 1024), ext: String(f.name || "").split(".").pop().slice(0, 6) });
        var msg = function (t, bad) { var m = wq(".wmsg");
          m.textContent = t;
          m.style.cssText = bad ? "margin-top:6px;font-weight:700;color:#8a2f2f" : "margin-top:6px";
          try { if (t) m.scrollIntoView({ block: "nearest" }); } catch (e) {} };
        if (f.size > 20 * 1048576) { msg("That photo is over 20 MB — please choose a smaller one.", 1); return; }
        msg("Loading your photo…");
        var isHeic = /heic|heif/i.test((f.type || "") + " " + (f.name || ""));
        var finish = function (im) {
          var f2 = Math.min(1, 1600 / Math.max(im.width, im.height));
          var cvs = document.createElement("canvas");
          cvs.width = Math.round(im.width * f2); cvs.height = Math.round(im.height * f2);
          cvs.getContext("2d").drawImage(im, 0, 0, cvs.width, cvs.height);
          loadImg(cvs.toDataURL("image/jpeg", .88)).then(function (clean) {
            if (!clean) { msg("Could not process that photo — please try a JPEG or PNG.", 1); return; }
            msg("");
            clog("shown", { w: clean.width, h: clean.height });
            st.own.img = clean;
            st.own.hAsk = 0; st.own.hDone = 0;       // a new photo = ask the wall height again
            st.view = "plain";
            st.own.quad = st.own.quad || [[.06, .08], [.94, .08], [.94, .92], [.06, .92]];
            startCorners(); }); };
        var fallback = function () {
          var rd = new FileReader();
          rd.onload = function () { loadImg(rd.result).then(function (im) {
            if (im) { finish(im); return; }
            // iPhone HEIC is the usual silent killer: the picker accepts it,
            // but Chrome/Edge cannot decode it into an image
            clog("decode-fail", { heic: isHeic, type: f.type || "?" });
            msg(isHeic ? "That is an iPhone HEIC photo, which this browser cannot open — export it as JPEG (or screenshot it) and upload that."
                       : "Could not open that picture (" + (f.type || "unknown type") + ") — please try a JPEG or PNG.", 1); }); };
          rd.onerror = function () { msg("Could not read that file — please try again.", 1); };
          rd.readAsDataURL(f); };
        if (window.createImageBitmap) {
          createImageBitmap(f, { imageOrientation: "from-image" })
            .catch(function () { return createImageBitmap(f); })
            .then(function (bm) { finish(bm); })
            .catch(fallback);
        } else fallback();
      };
      inp.click(); }
    // My room, placed: the one button that matters + what it costs (nothing)
    function plainReady() {
      var v = wq(".aiview");
      v.innerHTML = '<div class="cfm" style="margin:4px 0 0;padding:0">' + aiHist() + '<div class="nt aimsg"></div></div>';
      wireHist(v);
      var d = orderDims(), n = panelsFor(d[0], d[1]);   // the request body needs both
      var freeTxt = st.ai.remaining != null ? st.ai.remaining + " of 5 left today" : "5 a day";
      step("Free", freeTxt + " · takes 20 to 40 s");
      wactShow();
      wq(".wact .aigo").onclick = async function () {
        var gb = this; gb.disabled = true; gb.textContent = "Making…"; gb.style.flex = "3 1 0";
        step("", "Making your photo-real view · 20 to 40 s, please wait");
        clog("photo-real");
        try {
          // 1800 px, q.94: the frame band has to survive into the render (Summer
          // 2026-09-07 "no thick frames") — at 1100 px it was ~3 px of smeared
          // JPEG and the model guessed a chunky moulding instead of copying it
          var shot = snapshot(1800, .94);                 // draws your room with the art at true size
          // placed:1 — the snapshot already carries the artwork at its TRUE size
          // (wall-corner homography). Without it the worker prompt said "large"
          // and the model ignored the overlay → random big renders (Summer 2026-07-31).
          var body = { image: shot, index: card.index, framing: st.framing, panels: n,
            w: Math.round(d[0]), h: Math.round(d[1]), wall_h: Math.round(st.own.h_cm || 0), placed: 1,
            layout: sbsOK(d[0], d[1], n) ? "side-by-side" : "stacked",
            frame_cm: FRAME_CM };                        // the overlay's real frame face, for the prompt
          if (localStorage.wl_email) body.email = localStorage.wl_email;
          if (st.look !== "natural" && st.artBase)
            body.own_art = lookCanvas(st.artBase, st.look, 1000).toDataURL("image/jpeg", .9);
          body.ts = await new Promise(function (res) { tsGet(res); });
          var r = await fetch(API + "/api/ai-mockup", { method: "POST",
            headers: { "content-type": "application/json" }, body: JSON.stringify(body) })
            .then(function (x) { return x.json(); });
          if (!r.ok) throw new Error(r.message || r.reason || "The render did not come back.");
          track("wl_render", { index: card.index });
          st.ai.url = r.url; st.ai.remaining = r.remaining_free;
          try { localStorage["wl_ailast_" + card.index] = r.url; } catch (e8) {}
          try { var hh = JSON.parse(localStorage["wl_aihist_" + card.index] || "[]");
            if (hh.indexOf(r.url) < 0) { hh.unshift(r.url); hh = hh.slice(0, 6);
              localStorage["wl_aihist_" + card.index] = JSON.stringify(hh); } } catch (e9) {}
          st.view = "photo"; setTab("own");
        } catch (err) { gb.disabled = false; gb.style.flex = ""; gb.textContent = SMALL() ? "Photo-real view" : "Make the photo-real view";
          step("Free", freeTxt + " · takes 20 to 40 s");
          v.querySelector(".aimsg").textContent = err.message; wactShow(); }
      };
    }
    // the photo-real view fills the same frame; Share + Make another on it
    function photoResult() {
      var v = wq(".aiview");
      v.innerHTML = '<img src="' + API + st.ai.url + '">' +
        '<div class="nt" style="margin-top:8px">True to the artwork, approximate on light' +
        (st.ai.remaining != null ? " · " + st.ai.remaining + " free left today" : "") + "</div>" +
        '<div style="margin-top:8px">' + aiHist() + "</div>";
      wireHist(v);
      step("", "");
      ctl('<button type="button" class="wshare">Share</button><button type="button" class="airedo">Make another</button>');
      wq(".wact .airedo").onclick = function () { st.view = "plain"; setTab("own"); };
      wq(".wact .wshare").onclick = async function () {
        // the second decision maker (Summer 2026-09-07): one tap sends the
        // picture and the artwork page to a partner
        var bt = this, img = API + st.ai.url, page = location.origin + location.pathname;
        var text = "How " + shortTitle(card.title) + " would look on our wall";
        if (navigator.share) {
          try { await navigator.share({ title: document.title, text: text + " — " + page, url: img }); } catch (e) {}
          return; }
        try { await navigator.clipboard.writeText(text + "\n" + img + "\n" + page);
          bt.textContent = "Link copied"; setTimeout(function () { bt.textContent = "Share"; }, 2000);
        } catch (e2) { window.prompt("Copy this link", img); }
      };
    }
    function aiHist() {
      var hh = [];
      try { hh = JSON.parse(localStorage["wl_aihist_" + card.index] || "[]"); } catch (e9) {}
      if (!hh.length) return "";
      return '<div class="aihist" style="display:flex;gap:6px;align-items:center;margin:0 0 10px;flex-wrap:wrap">' +
        '<span class="nt">Your photos:</span>' + hh.map(function (u) {
          return '<img data-h="' + u + '" src="' + API + u + '" style="width:44px;height:44px;object-fit:cover;border:1px solid #d8d3cb;cursor:pointer">';
        }).join("") + "</div>";
    }
    function wireHist(scope) {
      scope.querySelectorAll(".aihist img").forEach(function (im) {
        im.onclick = function () { st.ai.url = im.dataset.h; st.view = "photo"; setTab("own"); }; });
    }
    wall.querySelectorAll(".wt").forEach(function (b) { b.onclick = function () { setTab(b.dataset.t); }; });
    zoomProbe();
    wq(".gdone").onclick = function () {
      st.own.edit = false; guide(false);
      if (!st.own.hDone) st.own.hAsk = 1;                 // step 3: the wall height, once per photo
      setTab("own"); };

    // top-row Save / Email — the manual mockup on Demo/My room, the AI photo on In-situ
    wq(".wsave").onclick = async function () {
      if (st.tab === "own" && !st.own.img && !photoOn()) { wq(".wmsg").textContent = "Upload your room photo first."; return; }
      var a = document.createElement("a");
      if (photoOn()) {
        try { var bl = await fetch(API + st.ai.url).then(function (x) { return x.blob(); });
          a.href = URL.createObjectURL(bl); } catch (e2) { window.open(API + st.ai.url, "_blank"); return; }
      } else a.href = snapshot();
      a.download = fileName(); a.click(); };
    wq(".wemail").onclick = async function () {
      if (st.tab === "own" && !st.own.img && !photoOn()) { wq(".wmsg").textContent = "Upload your room photo first."; return; }
      var email = await askEmail("Where should we send your mockup?");
      if (!email) return;
      wq(".wmsg").textContent = "Sending…";
      try {
        var body = photoOn()
          ? { email: email, url: st.ai.url, index: card.index }
          : { email: email, image: snapshot(), index: card.index };
        // print-own page: the design permalink rides in the email (replaces the
        // removed "Copy design link" row, Summer 2026-08-17)
        if (OWN && st.designLink) body.link = st.designLink();
        var er = await fetch(API + "/api/mockup-email", { method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify(body) })
          .then(function (x) { return x.json(); });
        wq(".wmsg").textContent = er.message || "Sent.";
      } catch (e) { wq(".wmsg").textContent = "Could not send — try again."; }
    };

    // full view — bind by class, NOT by index. ".fv"[2] was the EMAIL button, so
    // this handler overwrote the email one: the envelope opened full view and the
    // magnifier did nothing. (Summer 2026-07-15)
    var fvBtn = wq(".wfull");
    // An AI photo is a finished picture, not the wall canvas — enlarge it as an
    // image. Without this the magnifier had nothing to show and stayed hidden.
    function openAiBig() {
      var w = document.getElementById("wlaibig");
      if (!w) {
        w = document.createElement("div"); w.id = "wlaibig";
        w.style.cssText = "position:fixed;inset:0;z-index:2147483200;background:rgba(20,20,20,.92);" +
          "display:flex;align-items:center;justify-content:center;padding:16px;cursor:zoom-out";
        w.innerHTML = '<img alt="" style="max-width:100%;max-height:100%;object-fit:contain;display:block">';
        w.onclick = function () { w.style.display = "none"; };
        document.body.appendChild(w);
      }
      w.querySelector("img").src = API + st.ai.url;
      w.style.display = "flex";
    }
    fvBtn.onclick = function () {
      if (photoOn()) { openAiBig(); return; }
      var wrap = document.getElementById("wlbigwrap");
      if (!wrap) { wrap = document.createElement("div"); wrap.id = "wlbigwrap";
        wrap.innerHTML = '<div id="wlbig">' +
          '<canvas style="width:100%;display:block;border:1px solid #e6e2dc;touch-action:none;cursor:grab;background:#f6f4f0"></canvas>' +
          '<div class="wcap2" style="font-size:12.5px;background:#f6f4f0;border:1px solid #e6e2dc;border-top:0;padding:6px 10px;font-family:inherit">&nbsp;</div>' +
          '<div class="szc" style="display:flex;gap:6px;flex-wrap:wrap;margin-top:10px"></div>' +
          '<div class="lkc" style="display:flex;gap:6px;flex-wrap:wrap;margin-top:8px;align-items:center"></div>' +
          '<div style="margin-top:12px"><button type="button" class="ret" style="border:1px solid #1b1b1b;background:#1b1b1b;color:#fff;padding:9px 16px;font-size:11px;letter-spacing:.06em;cursor:pointer;font-family:inherit">Return to the product page</button></div>';
        document.body.appendChild(wrap);
        wrap.querySelector(".ret").onclick = function () { wrap.style.display = "none"; };
        wrap.onclick = function (e) { if (e.target === wrap) wrap.style.display = "none"; };
        bigCv = wrap.querySelector("canvas"); bigCv.__wrap = wrap; bigCv.__cap = wrap.querySelector(".wcap2");
        attach(bigCv); }
      var sz = wrap.querySelector(".szc");
      sz.innerHTML = stdSizes.map(function (s) {
        var m = /(\d+)\s*[x×]\s*(\d+)/.exec(s); var on = !st.custom && m && +m[1] === st.size[0] && +m[2] === st.size[1];
        return '<button type="button" class="chip' + (on ? " on" : "") + '" data-s="' + s + '">' + s + "</button>"; }).join("") +
        (st.custom ? '<span class="chip on">' + st.w + "×" + st.h + " custom</span>" : "");
      sz.querySelectorAll(".chip[data-s]").forEach(function (b) { b.onclick = function () {
        var h5 = handleize(b.dataset.s);
        var lb = sizeFs && (sizeFs.querySelector('label[data-value-handle="' + h5 + '"]') ||
                 sizeFs.querySelector('label[data-value-handle^="' + h5 + '"]'));
        if (lb) lb.click();
        setTimeout(function () { fvBtn.onclick(); }, 350); }; });
      var lk = wrap.querySelector(".lkc");
      lk.innerHTML = '<span class="wlsec" style="margin:0;font-size:12px">Colour Filter</span>' +
        '<button type="button" class="dt none' + (st.look === "natural" ? " on" : "") + '" data-k="natural" title="None" ' +
        'style="width:23px;height:23px;border-radius:50%;border:2px solid #fff;outline:1px solid ' +
        (st.look === "natural" ? "#1b1b1b" : "#ddd") + ';cursor:pointer;background:linear-gradient(135deg,#fff 44%,#c33 47%,#c33 53%,#fff 56%)"></button>' +
        Object.keys(TINTS).map(function (k) {
          return '<button type="button" class="dt' + (k === st.look ? " on" : "") + '" data-k="' + k + '" title="' + LABELS[k] +
            '" style="width:23px;height:23px;border-radius:50%;border:2px solid #fff;outline:1px solid ' +
            (k === st.look ? "#1b1b1b" : "#ddd") + ';cursor:pointer;background:' + TINTS[k] + '"></button>'; }).join("");
      lk.querySelectorAll(".dt").forEach(function (b) { b.onclick = function () {
        setLook(b.dataset.k); fvBtn.onclick(); }; });
      if (OWN) { lk.style.display = "none";
        wrap.querySelector(".ret").textContent = "Return to the customisation page"; }
      // wall height here too — same state as the inline control, so the small
      // view follows and "Return to the product page" keeps every value
      var whr = wrap.querySelector(".whc2");
      if (!whr) { whr = document.createElement("div"); whr.className = "whc2";
        whr.style.cssText = "margin-top:10px;font-size:12px;color:#1b1b1b;font-family:inherit";
        lk.parentElement.insertBefore(whr, lk.nextSibling); }
      var tst = (st.tab === "own") ? st.own : st.tpl;
      var bvOwn = st.tab === "own";
      whr.innerHTML = 'wall height <input class="whcm2" inputmode="numeric" type="number" step="1" ' +
        'min="' + (bvOwn ? 150 : 200) + '" max="' + (bvOwn ? 600 : 420) + '" ' +
        'style="width:52px;padding:3px 5px;border:1px solid #d8d3cb;font-family:inherit;font-size:12px"> cm ' +
        '<span style="opacity:.75">' + ((st.tab === "own") ? "(your wall)" : "") + "</span>";
      var wi2 = whr.querySelector(".whcm2"); wi2.value = tst.h_cm;
      wi2.onchange = function () {
        var own2 = st.tab === "own";
        tst.h_cm = own2 ? Math.min(600, Math.max(150, +this.value || 270))
                        : Math.min(420, Math.max(200, +this.value || 270));
        this.value = tst.h_cm;
        var inl = wq(".whcm"); if (inl) inl.value = tst.h_cm;
        drawAll(); drawOn(bigCv); };
      wrap.style.display = "flex";
      setTimeout(function () { drawOn(bigCv); }, 60);
      setTimeout(function () { if (bigCv.width < 320) drawOn(bigCv); }, 400); };

    // ================= R8: badges below the gallery ==============================
    try {
      var gal = sec.querySelector("product-gallery");
      if (gal && gal.parentElement) {
        var badgeBlocks = [];
        Array.prototype.forEach.call(sec.querySelectorAll(".product-info__block-item"), function (b) {
          var txt = (b.textContent || "").replace(/\s+/g, " ").trim();
          if (/Art\s*#/.test(txt) && txt.length < 140) badgeBlocks.push(b);
        });
        var mtags = sec.querySelector('.product-info__block-item[data-block-id="wl_meta_tags"]');
        if (mtags && badgeBlocks.indexOf(mtags) < 0) badgeBlocks.push(mtags);
        var grid0 = gal.parentElement;
        grid0.classList.add("wl-pgrid");
        var infoTop0 = form; while (infoTop0 && infoTop0.parentElement !== grid0) infoTop0 = infoTop0.parentElement;
        if (infoTop0) infoTop0.classList.add("wl-infocol");
        // badges + chips sit ON TOP OF THE GALLERY (inside the left column)
        var top = document.getElementById("wlpdptop");
        if (!top) { top = document.createElement("div"); top.id = "wlpdptop";
          gal.insertBefore(top, gal.firstChild); }
        var secEl = gal.closest(".shopify-section");
        // Summer 2026-07-31: was 10px — set inline WITH !important, so it outranked
        // every stylesheet. That 10px sits OUTSIDE the white card (page grey) and was
        // the gap under the Back/Save/Share strip. The card's own top padding already
        // gives the gallery its breathing room.
        if (secEl) secEl.style.setProperty("padding-top", "0px", "important");
        // column tint: halfway between the page background and white — low contrast by construction
        try {
          var pb = getComputedStyle(document.body).backgroundColor.match(/\d+/g).map(Number);
          var tint = "rgb(" + pb.slice(0, 3).map(function (v) { return Math.round(v + (150 - v) * .10); }).join(",") + ")";
          if (infoTop0) { infoTop0.style.backgroundColor = tint; sec.style.setProperty("--wltint", tint); }
        } catch (e3) {}
        // green badges on line 1; the Art#/Edition line joins the CHIP row below
        var frow = document.createElement("div");
        frow.className = "wl-badgerow";
        var artBlocks = [];
        badgeBlocks.forEach(function (b) {
          if (b.getAttribute("data-block-type") === "feature-with-icon") {
            b.classList.add("wl-artchip"); artBlocks.push(b); }
        });
        var feats = Array.prototype.filter.call(
          sec.querySelectorAll('.product-info__block-item[data-block-type="feature-with-icon"]'),
          function (f) { return !frow.contains(f) &&
            /shipping|guarantee|melbourne|delivery/i.test(f.textContent); });
        feats.forEach(function (f) { frow.appendChild(f); });
        if (frow.children.length) top.appendChild(frow);
        // chip line: Art#/Edition info first, then the tag chips — one row, one style
        var mrow = document.createElement("div");
        mrow.className = "wl-meta";
        artBlocks.forEach(function (b) { mrow.appendChild(b); });
        badgeBlocks.forEach(function (b) {
          if (b.getAttribute("data-block-type") !== "feature-with-icon") mrow.appendChild(b);
        });
        if (mtags && !frow.contains(mtags)) mrow.appendChild(mtags);
        if (mrow.children.length) top.appendChild(mrow);
        // Art# badge is PLAIN WORDS (Summer 2026-08-13) — no chip skin. The old
        // pixel-match-to-tag-chips copier lived here; the CSS rule on
        // .wl-artchip .feature-badge is the single source of its look now.
        // one line always on desktop: shrink the badge font until the row fits
        var fitBadges = function () {
          if (!frow.children.length || !frow.parentElement) return;
          if (window.innerWidth <= 700) { frow.style.removeProperty("--wlbf"); return; }
          var f = 11.5;
          frow.style.setProperty("--wlbf", f + "px");
          while (frow.scrollWidth > frow.clientWidth + 1 && f > 7) {
            f -= 0.5; frow.style.setProperty("--wlbf", f + "px"); }
        };
        // reorderPdp() moves this row into the left column after it is built, which
        // changes the width it has to fit — so re-fit once it has landed.
        window.__wlFitBadges = fitBadges;
        setTimeout(fitBadges, 60); setTimeout(fitBadges, 1200); setTimeout(fitBadges, 2600);
        window.addEventListener("resize", function () { clearTimeout(window.__wlbfit);
          window.__wlbfit = setTimeout(fitBadges, 250); });
      }
    } catch (e) { console.warn("wl badges", e); }

    // ================= back to top =================
    var topBtn = document.createElement("button");
    topBtn.type = "button"; topBtn.textContent = "↑ top";
    topBtn.style.cssText = "position:fixed;right:18px;bottom:64px;z-index:79;display:none;" +
      "border:1px solid #1b1b1b;background:rgba(255,255,255,.95);color:#1b1b1b;padding:9px 13px;" +
      "font:10px Helvetica;letter-spacing:.12em;text-transform:uppercase;cursor:pointer;" +
      "box-shadow:0 4px 14px rgba(0,0,0,.15);font-family:" + bodyFont;
    document.body.appendChild(topBtn);
    topBtn.onclick = function () { window.scrollTo({ top: 0, behavior: "smooth" }); };
    // The chat launcher sits 80px off the bottom and is 46 tall, so a fixed
    // bottom:64px put this button straight under it. Measure the launcher and sit
    // clear BELOW it instead of guessing — the app can move it. (Summer 2026-07-15)
    var stackUnderChat = function () {
      try {
        var ag = document.querySelector("shopify-agent");
        var act = ag && ag.shadowRoot && ag.shadowRoot.querySelector('[part="activator"]');
        if (!act) return;
        var r = act.getBoundingClientRect();
        if (!r.height) return;
        var chatFromBottom = window.innerHeight - r.bottom;
        var h = topBtn.offsetHeight || 33;
        topBtn.style.right = Math.max(8, Math.round(window.innerWidth - r.right)) + "px";
        topBtn.style.bottom = Math.max(8, Math.round(chatFromBottom - 10 - h)) + "px";
      } catch (e) {}
    };
    setTimeout(stackUnderChat, 1200); setTimeout(stackUnderChat, 3000);
    window.addEventListener("resize", stackUnderChat);
    // the wall canvas sizes itself from its pane width at draw time — a viewport
    // change (rotation, window drag, a hidden pane becoming visible) needs a redraw
    window.addEventListener("resize", function () { clearTimeout(st.__wlRz);
      st.__wlRz = setTimeout(function () { drawAll(); }, 200); });
    // mobile carries its own back-to-top on the sticky Add-to-Cart bar (wl_bar.js)
    window.addEventListener("scroll", function () {
      var on = window.scrollY > 700 && window.innerWidth >= 750;
      if (on && topBtn.style.display !== "block") { topBtn.style.display = "block"; stackUnderChat(); }
      else if (!on) topBtn.style.display = "none"; }, { passive: true });

    // ================= COMPLETE THE SET — inline, engine-priced ==================
    // Wrapped in a function so it can run LATE (Summer 2026-08-24). This band is
    // the ONLY thing in the whole mount that reads cfg.cards, and cfg.cards means
    // the 578 KB library fetch. The print page now mounts before that fetch
    // returns and calls WLC.setCards() when it lands, so a slow library can no
    // longer hold up the buy box. setElRef guards it: it can only build once.
    function buildSet() {
    // HIDDEN (Summer 2026-10-15): since the 24 Sep page-card build the box came up
    // empty on every first visit (colour/style/artist fields live only on the
    // library card). The set discount is Shopify's own automatic discount and
    // needs no box. To bring it back: delete the next line.
    return;
    if (setElRef) return;
    // ARTWORK PAGES ONLY (Summer 2026-08-24, second pass). The band bundles THIS
    // catalogue artwork with companions; the Print-Your-Own page has no catalogue
    // artwork — its card is the synthetic "OWNART" stub — so a set cannot be
    // priced or added there. It used to be shielded by accident: the old mount
    // read form.closest(), which threw on that template and left the box built
    // but unattached. Moving the mount to seatSet() removed the throw and an
    // EMPTY full-width band appeared on the print pages. Gate it out loud.
    if (OWN) return;
    try {
      var all = (cfg.cards || []).filter(function (c) {
        return c.index !== card.index && c.url && c.image && (c.sizes || []).length; });
      if (all.length >= 3) {
        var setEl = document.createElement("div");
        setEl.className = "wlc4 wlsetband";
        // tint only — the band is full-bleed, so the old ring of page background
        // has nothing left to frame. Width/padding live in .wlsetband CSS.
        // (A real GRID move once parked this in a phantom row 2400px down; the
        // band is a plain block OUTSIDE the grid, which is why that cannot recur.)
        setEl.style.cssText = "background:var(--wltint,#f1f1ef);width:100%;box-sizing:border-box";
        setElRef = setEl;
        seatSet();                       // ATC → specs → description → the band
        reorderPdp();
        var MB = { colour: "colour", style: "style", artist: "artist" };
        var setSt = { by: "colour", rows: [], used: {} };
        // shared colour maths (wl_colour.js) — load once, then re-rank the box
        if (!window.WLColour) {
          var cjs = document.createElement("script");
          cjs.src = API + "/app/colour.js";
          cjs.onload = function () {
            if (setElRef && setSt.by === "colour") { freshRows(); renderSet(); } };
          document.head.appendChild(cjs);
        }
        function ratioOfCard(c) {
          var m = /(\d+)\s*[x×]\s*(\d+)/.exec((c.sizes || [])[0] || "");
          return m ? Math.max(+m[1], +m[2]) / Math.min(+m[1], +m[2]) : null; }
        function compScore(c, by) {
          if (by === "artist") return c.artist && c.artist === card.artist ? 2 : 0;
          if (by === "style") {
            // look & feel: shared styles + same orientation + similar proportions — colour ignored
            var shStyle = (c.styles || []).filter(function (x) { return (card.styles || []).indexOf(x) >= 0; }).length;
            if (!shStyle) return 0;
            var sc2 = shStyle;
            if (c.orientation && c.orientation === card.orientation) sc2 += .6;
            var ra = ratioOfCard(card), rb = ratioOfCard(c);
            if (ra && rb) sc2 += Math.max(0, .6 - Math.abs(Math.log(ra / rb)));
            // palette kinship as tiebreak (2026-07-30) — a style set should
            // still hang together on the wall
            if (window.WLColour && card.pal && c.pal) sc2 += .5 * WLColour.sim(card.pal, c.pal);
            return sc2;
          }
          // colour — ONE shared function (wl_colour.js via worker /app/colour.js,
          // 2026-07-30): measured pixel palettes on the cards (c.pal). The tag
          // maths below survives ONLY as fallback for cards without a palette.
          if (window.WLColour && card.pal && c.pal) {
            var s3 = WLColour.sim(card.pal, c.pal);
            return s3 >= .3 ? s3 : 0;         // 0..1 measured palette kinship
          }
          // fallback: PERCENTAGE of tag overlap, dominance-weighted, ranked highest-first.
          // weight(position i of n) = n-i; similarity = 2·Σ shared min-weights / (ΣA + ΣB)
          var A = card.colours || [], B = c.colours || [];
          if (!A.length || !B.length) return 0;
          var wa = function (i, n) { return n - i; };
          var sumA = 0, sumB = 0, inter = 0;
          A.forEach(function (_, i) { sumA += wa(i, A.length); });
          B.forEach(function (_, i) { sumB += wa(i, B.length); });
          A.forEach(function (col, ia) {
            var ib = B.indexOf(col);
            if (ib >= 0) inter += Math.min(wa(ia, A.length) / sumA, wa(ib, B.length) / sumB); });
          return inter >= .25 ? inter : 0;            // 0..1 = share of palette in common
        }
        function pool() {
          return all.map(function (c) { return { c: c, s: compScore(c, setSt.by) }; })
            .filter(function (o) { return o.s > 0; })
            .sort(function (a, b) { return b.s - a.s; })
            .map(function (o) { return o.c; }); }
        function freshRows() {
          setSt.used = {};
          setSt.rows = pool().slice(0, 3).map(function (c) { setSt.used[c.index] = 1;
            return { c: c, on: true, size: (c.sizes || [])[0] || "", cw: "", ch: "", custom: false,
                     framing: "natural_oak", quote: null }; }); }   // rolled is never the default
        function swapRow(k) {
          var nxt = pool().find(function (c) { return !setSt.used[c.index]; });
          if (!nxt) { setEl.querySelector(".wlm-msg").textContent = "No more matches this way — try another match mode."; return; }
          setSt.used[nxt.index] = 1;
          setSt.rows[k] = { c: nxt, on: setSt.rows[k].on, size: (nxt.sizes || [])[0] || "", cw: "", ch: "",
                            custom: false, framing: "natural_oak", quote: null };
          renderSet(); }
        async function rowQuote(r) {
          var m = r.custom ? [+r.cw, +r.ch]
            : (function () { var mm = /(\d+)\s*[x×]\s*(\d+)/.exec(r.size); return mm ? [+mm[1], +mm[2]] : null; })();
          if (!m || !m[0] || !m[1]) { r.quote = null; return; }
          var qq = await quoteRaw(m[0], m[1], r.framing, r.custom, 0, r.c.index);
          r.qdims = m;                      // TYPED cm — quote_w/h is the billing round-up
          r.quote = qq.ok ? qq : null; }
        async function totals() {
          var lines = [];
          var d0 = orderDims();
          // the main piece keeps its configured border in the set (2026-08-17 —
          // it used to be silently dropped on this path); companions have no border UI
          var b0 = st.framing === "rolled" ? (st.border || 0) : 0;
          var q0 = st.custom && st.quote && st.quote.ok ? st.quote     // custom quote is live; standard sizes always re-quote
                   : await quoteRaw(d0[0], d0[1], st.framing, st.custom || b0 > 0, b0, undefined, !!st.custom);
          // w/h carry the TYPED size (Summer 2026-07-31) — sending quote_w/h here
          // used to turn a typed 145×91 set piece into a 150×100 order. The server
          // re-rounds for pricing, so the price is identical either way.
          if (q0.ok) lines.push({ type: "artwork", index: card.index, w: d0[0], h: d0[1],
            framing: st.framing, substrate: "canvas", qty: 1, unit_price: q0.price, surcharge: q0.surcharge || 0, custom: st.custom, border: b0 });
          setSt.rows.forEach(function (r) { if (r.on && r.quote && r.qdims)
            lines.push({ type: "artwork", index: r.c.index, w: r.qdims[0], h: r.qdims[1],
              framing: r.framing, substrate: "canvas", qty: 1, unit_price: r.quote.price, surcharge: r.quote.surcharge || 0, custom: r.custom }); });
          if (lines.length < 2) return { none: true };
          var priced = await fetch(API + "/api/cart/price", { method: "POST",
            headers: { "content-type": "application/json" }, body: JSON.stringify({ lines: lines }) })
            .then(function (x) { return x.json(); });
          priced.lines_in = lines;
          return priced; }
        async function renderSet() {
          // no inline styling — wl-overrides.css owns the section-head look
          // (Summer 2026-07-30: same head as Size/Framing, serif special-case removed)
          setEl.innerHTML = '<p class="wlsec">Complete the Set &amp; Save</p>' +
            // the tier line was deleted 2026-08-24 (Summer) — the BUY MORE & SAVE
            // promo right above Add to cart already states 10/15/20%, so this
            // band repeated it. The running total below still names the rate.
            '<div style="display:flex;gap:6px;align-items:center;flex-wrap:wrap;margin-top:2px"><span class="nt">Match by</span>' +
            Object.keys(MB).map(function (k) {
              return '<button type="button" class="wlm-chip wlm-by' + (k === setSt.by ? " on" : "") + '" data-by="' + k + '">' + MB[k] + "</button>"; }).join("") +
            "</div>" +
            '<div class="wlm-grid">' + setSt.rows.map(function (r, k) {
              var ps = String(r.c.title || "").split("|").map(function (x) { return x.trim(); }).filter(Boolean);
              var tt = ps.length > 1 ? ps[1] : (ps[0] || "");
              if (r.c.artist && tt.toLowerCase() === r.c.artist.toLowerCase())
                tt = ps.length > 2 ? ps[2] : tt;
              var showArtist = r.c.artist && tt.toLowerCase() !== r.c.artist.toLowerCase();
              return '<div data-k="' + k + '">' +
                '<a href="' + (r.c.url || "#") + '" target="_blank" rel="noopener" title="Open the artwork page">' +
                '<img src="' + (API + "/thumbs/" + r.c.index + ".jpg" + iv(r.c)) + '" alt="' + tt.replace(/"/g, "&quot;") + '"></a>' +
                '<div class="ttl"><label style="cursor:pointer"><input type="checkbox" class="wlm-on" ' + (r.on ? "checked" : "") + ' style="width:auto"> ' +
                tt.slice(0, 60) + "</label>" + (showArtist ? '<span style="color:#8a8a8a"> · ' + r.c.artist + "</span>" : "") + "</div>" +
                '<select class="wlm-sz">' + (r.c.sizes || []).map(function (s) {
                  return "<option" + (!r.custom && s === r.size ? " selected" : "") + ">" + s + "</option>"; }).join("") +
                // custom sizes sell worldwide since 2026-08-23 r2 (rolled ships
                // everywhere; the UK/EU small-size rule is enforced by the quote)
                '<option value="__c"' + (r.custom ? " selected" : "") + ">Custom size…</option>" + "</select>" +
                '<div class="wlm-c" style="display:' + (r.custom ? "block" : "none") + ';margin-top:4px">' +
                'W <input class="wlm-w" inputmode="numeric" style="width:52px" value="' + r.cw + '"> ' +
                'H <input class="wlm-h" inputmode="numeric" style="width:52px" value="' + r.ch + '"> cm</div>' +
                '<select class="wlm-fr" style="margin-top:4px">' +
                // r2 (2026-08-23): every framing is offered everywhere; outside
                // Australia the framed ones say so instead of vanishing
                [["rolled", "Rolled"], ["stretched", "Stretched"], ["black_oak", "Black Oak Frame"], ["natural_oak", "Natural Oak Frame"], ["white_oak", "White Oak Frame"]]
                  .map(function (f) { return '<option value="' + f[0] + '"' + (r.framing === f[0] ? " selected" : "") + ">" +
                    f[1] + (WL_AUDEL && f[0] !== "rolled" ? " — Australia delivery" : "") + "</option>"; }).join("") + "</select>" +
                '<div class="pr wlm-pr" style="margin-top:4px">…</div>' +
                '<button type="button" class="ghost wlm-swap" style="margin-top:6px">⟳ Swap artwork</button></div>'; }).join("") + "</div>" +
            '<div class="body wlm-tot" style="margin-top:10px"></div>' +
            '<button type="button" class="wlm-addbtn wlm-add">Add the set to cart</button>' +
            '<div class="nt wlm-msg" style="margin-top:6px"></div>';
          setEl.querySelectorAll(".wlm-by").forEach(function (b) {
            b.onclick = function () { setSt.by = b.dataset.by; freshRows(); renderSet(); }; });
          setEl.querySelectorAll(".wlm-grid > div").forEach(function (cell) {
            var k = +cell.dataset.k, r = setSt.rows[k];
            cell.querySelector(".wlm-on").onchange = function () { r.on = this.checked; refreshPrices(); };
            cell.querySelector(".wlm-sz").onchange = function () {
              if (this.value === "__c") { r.custom = true; cell.querySelector(".wlm-c").style.display = "block"; }
              else { r.custom = false; r.size = this.value; cell.querySelector(".wlm-c").style.display = "none"; refreshPrices(); } };
            ["wlm-w", "wlm-h"].forEach(function (cl) {
              cell.querySelector("." + cl).oninput = function () {
                r.cw = cell.querySelector(".wlm-w").value; r.ch = cell.querySelector(".wlm-h").value;
                clearTimeout(r._t); r._t = setTimeout(refreshPrices, 600); }; });
            cell.querySelector(".wlm-fr").onchange = function () { r.framing = this.value; refreshPrices(); };
            cell.querySelector(".wlm-swap").onclick = function () { swapRow(k); }; });
          setEl.querySelector(".wlm-add").onclick = addSet;
          refreshPrices();
        }
        async function refreshPrices() {
          try {
          await Promise.all(setSt.rows.map(rowQuote));
          setEl.querySelectorAll(".wlm-grid > div").forEach(function (cell) {
            var r = setSt.rows[+cell.dataset.k];
            cell.querySelector(".wlm-pr").textContent = r.quote ? money(r.quote.total, true) : "—"; });
          var p = await totals();
          var tot = setEl.querySelector(".wlm-tot");
          if (!p || p.none || !p.lines) { tot.textContent = "Tick at least one companion — the set discount starts at two pieces."; setEl.__priced = null; return; }
          tot.innerHTML = "<b>" + p.pieces + " pieces — " + Math.round(p.bundle_rate * 100) + "% off at checkout:</b> " +
            (p.discount ? '<span style="text-decoration:line-through;color:#8a8a8a">' + money(p.subtotal, true) + "</span> " : "") +
            "<b>" + money(p.total, true) + "</b>" +
            (p.pieces === 2 ? ' <span class="nt">— one more piece takes the set to 15% off</span>' :
             p.pieces === 3 ? ' <span class="nt">— one more piece takes the set to 20% off</span>' : "");
          setEl.__priced = p;
          } catch (e) { var tt = setEl.querySelector(".wlm-tot");
            if (tt) tt.textContent = "Prices are catching up — one moment…"; }
        }
        async function addSet() {
          var btn = setEl.querySelector(".wlm-add"); var msg = setEl.querySelector(".wlm-msg");
          btn.disabled = true; btn.textContent = "Adding the set…";
          var p = await totals(); setEl.__priced = p;   // never trust a stale preview — the main config may have changed
          if (!p || p.none || !p.lines || p.lines.length < 2) {
            msg.textContent = "Tick at least one companion first.";
            btn.disabled = false; btn.textContent = "Add the set to cart"; return; }
          try {
            var items = [];
            for (var i = 0; i < p.lines.length; i++) {
              var l = p.lines[i];
              var src = p.lines_in[i] || {};
              var r = await fetch(API + "/api/native-line", { method: "POST", headers: { "content-type": "application/json" },
                body: JSON.stringify({ kind: "artwork", country: (window.Shopify && Shopify.country) || "", index: l.index, w: l.w, h: l.h, framing: l.framing,
                  substrate: "canvas", look: l.index === card.index ? st.look : "natural",
                  custom: !!src.custom || (src.border || 0) > 0, typed: !!src.custom,
                  border: src.border || 0, border_type: st.borderType || "mirror",
                  panels: panelsFor(l.w, l.h),
                  unit_override: l.unit_price + (l.surcharge || 0) }) })   // full price — the 10/15/20% applies automatically at checkout
                .then(function (x) { return x.json(); });
              if (!r.ok) throw new Error(r.message || "could not prepare the set");
              var props2 = r.properties || {};
              props2["Set"] = p.pieces + " pieces — " + Math.round(p.bundle_rate * 100) + "% off at checkout";
              items.push({ id: r.variantId, quantity: 1, properties: props2 });
            }
            var cr = await fetch("/cart/add.js", { method: "POST", headers: { "content-type": "application/json" },
              body: JSON.stringify({ items: items }) });
            if (!cr.ok) throw new Error("cart add failed");
            // fresh WLCUSTOM variants take seconds to settle on Shopify's side — a
        // drawer opened too early shows blank titles / $0 / minus totals
        // (Summer 2026-07-24, worst on 3-piece bundles). Don't open the drawer
        // until every cart line reports a title and a real price (max 12s),
        // then refresh once more for late thumbnails.
        (function () {
          var fire = function () { document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", { bubbles: true })); };
          var t0 = Date.now();
          (function settle() {
            fetch("/cart.js").then(function (x) { return x.json(); }).then(function (c) {
              var bad = (c.items || []).some(function (i) { return !i.price || !i.title ||
                i.final_line_price < 0 ||
                (i.line_level_total_discount || 0) > (i.line_price || 0) ||
                (i.handle === "wl-print-your-own-art" && !i.image); });
              if (bad && Date.now() - t0 < 20000) return setTimeout(settle, 700);
              fire(); setTimeout(fire, 4000); setTimeout(fire, 9000);
            }).catch(function () { fire(); });
          })();
        })();
            track("wl_set_added", { pieces: p.pieces });
            btn.textContent = "✓ Set added — " + items.length + " pieces in your cart";
            setTimeout(function () { btn.textContent = "Add the set to cart"; btn.disabled = false; }, 3000);
          } catch (err) { btn.disabled = false; btn.textContent = "Add the set to cart";
            msg.textContent = err.message || "Something went wrong — nothing was charged."; }
        }
        freshRows();
        if (setSt.rows.length >= 2) {
          renderSet();
          var setSig = "";                       // main config changed (size/frame/custom) → set preview follows
          setInterval(function () {
            if (!document.body.contains(setEl)) return;
            var d = orderDims(); var sig = d[0] + "x" + d[1] + "|" + st.framing + "|" + st.custom;
            if (sig !== setSig) { setSig = sig; refreshPrices(); }
          }, 1500);
        } else setEl.remove();
      }
    } catch (e) { console.warn("wl sets", e); }
    }
    buildSet();
    // late cards: wl_bar.js calls this when /api/library finally answers
    try { window.WLC.setCards = function (cards) {
      cfg.cards = cards || []; buildSet(); }; } catch (eSC) {}

    attach(wq(".wcv"), wq(".wdrag"));

    // ---- open at the TOP (Summer 2026-07-15) -----------------------------------
    // Selecting the framing option focuses its radio (~1000px down) and the browser
    // scrolls just enough to reveal it — the page opened ~425px in. A product with
    // no variant radios (the install kit) is unaffected, which is the tell. Pin the
    // top through the picker's init, and stand down the instant the reader moves or
    // if the browser is legitimately restoring a position on back/forward.
    (function keepTop() {
      try {
        if (location.hash) return;
        var nav = (performance.getEntriesByType("navigation")[0] || {}).type;
        if (nav === "back_forward") return;            // restoring scroll is correct here
        // Event-driven, not a timed window: the theme's variant re-fetch can land
        // seconds after load on a cold page, so any fixed window is a guess. Snap
        // back on a scroll we did not ask for, until the reader touches the page.
        var quit = false, fixes = 0, by = null;
        var snap = function () { if (!quit && window.pageYOffset > 0) {
          fixes++; window.scrollTo(0, 0); } };
        // isTrusted: a script on the page fires a synthetic pointer event during
        // load, which killed this guard before it could do anything. Only a real
        // human gesture should stand it down.
        var stop = function (e) {
          if (e && e.isTrusted === false) return;
          quit = true; by = (e && e.type) || "timeout";
          window.removeEventListener("scroll", snap);
        };
        ["wheel", "touchstart", "keydown", "mousedown"].forEach(function (ev) {
          window.addEventListener(ev, stop, { passive: true }); });
        window.addEventListener("scroll", snap, { passive: true });
        // mount() can run AFTER the jump has already happened — a scroll listener
        // alone would then never fire. Correct what is already there, then watch.
        snap();
        window.__wlKT = { at: Math.round(performance.now()), yAtInstall: Math.round(window.pageYOffset),
          get fixes() { return fixes; }, get quit() { return quit; }, get by() { return by; } };
        setTimeout(stop, 12000);                       // never linger past the load
      } catch (e) {}
    })();
    readSel(); price();
    if (OWN) {
      window.__wlFixTitle = function () {
        var h1 = document.querySelector(".product-info h1, h1.product-title, .product-info__title, h1");
        if (!h1 || h1.querySelector(".wlsub")) return;
        var t = h1.textContent;
        var cut = t.indexOf("\u2014");
        if (cut < 0) return;
        var head = t.slice(0, cut).trim(), rest = t.slice(cut + 1).trim();
        h1.textContent = "";
        h1.appendChild(document.createTextNode(head));
        var sub = document.createElement("span");
        sub.className = "wlsub";
        sub.style.cssText = "display:block;font-size:72%;line-height:1.35;margin-top:4px;letter-spacing:.02em;white-space:nowrap";
        sub.textContent = rest;
        h1.appendChild(sub);
      };
      window.__wlFixTitle();
      setTab("tpl"); return; }
    loadImg(API + "/main/" + card.index + ".jpg" + iv(card)).then(function (im) {
      return im || loadImg(API + "/thumb/" + card.index + ".jpg" + iv(card)); }).then(function (im) {
      if (!im) { wq(".wmsg").textContent = "The artwork preview could not load — refresh the page."; return; }
      st.artBase = im; st.art = im;
      st.aspect = (im.naturalWidth || im.width) / (im.naturalHeight || im.height);
      setTab("tpl"); });
  }
  window.WLC = { mount: mount };
})();

// ---- Enhance-widget placement + auto-height (Summer 2026-08-23) -------------
// The PSF description carries the enhance widget inside #wlenhsec; Summer's
// ruling: it sits directly UNDER "See it on your wall" (.wlwall), above the
// gallery/description, and the iframe hugs its content (no dead gap).
(function () {
  function boot() {
    // ONE height applier per page (Summer 2026-08-24). wl-customiser, wl-search
    // and wl-bar each carried a copy of this listener and ALL THREE load on the
    // print page — three forced layouts and three writes for one box on every
    // beat. Whichever script boots first wires it; the others stand down.
    if (!window.__wlEnhHWired) {
      window.__wlEnhHWired = 1;
      window.addEventListener("message", function (e) {
        var d = e && e.data;
        if (!d || !d.wlEnhH) return;
        document.querySelectorAll('iframe[src*="enhance-widget"]').forEach(function (f) {
          if (f.contentWindow !== e.source) return;
          var before = f.getBoundingClientRect(), oldH = before.height;
          var newH = Math.max(90, Math.min(1400, +d.wlEnhH + 8));
          if (Math.abs(newH - oldH) < 1) return;    // unchanged — don't touch the DOM
          f.style.height = newH + "px";
          // a height change ABOVE the fold (e.g. switching Example 1/2 after
          // an oversized result view) must not silently scroll unrelated page
          // content into view — keep whatever the visitor is looking at put
          // (root-caused 2026-08-24: "clicking Example 1 jumps the page")
          if (before.top < 0) window.scrollTo(0, window.scrollY + (newH - oldH));
        });
      });
    }
    // customiser-only extras — the widget's beat doubles as "I'm alive"
    window.addEventListener("message", function (e) {
      var d = e && e.data;
      if (!d || !d.wlEnhH) return;
      // deliver the customer's upload even if it landed before the iframe was ready
      if (window.__wlEnhOwn)
        document.querySelectorAll('iframe[src*="enhance-widget"]').forEach(function (f) {
          if (f.contentWindow === e.source)
            try { f.contentWindow.postMessage({ wlEnhOwn: window.__wlEnhOwn }, "*"); } catch (e2) {}
        });
      // heartbeat re-seat: reorderPdp() moves .wlwall after first placement —
      // keep the section glued beneath it for the life of the page
      if (window.__wlEnhSeat) window.__wlEnhSeat();
    });
    // Summer's ruling (2026-08-23, r4 2026-08-24): the section lives inside the
    // "See it on your wall" block — under the room, before the gallery. It is
    // seated into .wpane-enh once and rides wherever reorderPdp() moves .wlwall,
    // so there is no order to flip any more.
    // invisible until first correctly seated — kills the load-time jump
    // (the section ships inside the description HTML and gets moved up)
    var hideCss = document.createElement("style");
    hideCss.textContent = "#wlenhsec:not(.wlseated){visibility:hidden}";
    document.head.appendChild(hideCss);
    // r4 (Summer 2026-08-24): ONE home at every width — the .wpane-enh pane that
    // .wlwall builds between the room pane and the gallery pane. Desktop reveals
    // every pane, so the section still reads "under the room, before the gallery"
    // exactly as r3 put it; mobile turns that pane into the Enhance Image tab.
    // Having no width branch also ends the last of the instability: reorderPdp
    // moves .wlwall wholesale and the section rides inside it, and there is
    // nothing left for a resize to re-decide.
    function seat() {
      var sec = document.getElementById("wlenhsec"),
          pane = document.querySelector(".wlwall .wpane-enh");
      if (!(sec && pane)) return false;
      if (sec.parentElement !== pane) {
        var y = window.scrollY;                       // DOM moves must not scroll the page
        pane.appendChild(sec);
        if (window.scrollY !== y) window.scrollTo(0, y);
      }
      sec.style.margin = "0";                         // the pane owns the spacing now
      sec.classList.add("wlseated");
      return true;
    }
    window.__wlEnhSeat = seat;                       // heartbeat handler calls this
    var tries = 0, iv = setInterval(function () {
      if (seat()) tries = Math.max(tries, 32);
      if (++tries > 40) clearInterval(iv);
    }, 250);
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
